webpackJsonp([1],{

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(533),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0daf7a0d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(210);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';





// if (
//   process.env.NODE_ENV === 'production' &&
//   process.env.RAVEN_KEY &&
//   process.env.RAVEN_PROJECT
// ) {
//   Raven
//     .config(`https://${process.env.RAVEN_KEY}@sentry.io/${process.env.RAVEN_PROJECT}`)
//     .addPlugin(RavenVue, Vue)
//     .install();
// } else {
//   console.log('Raven disabled. Add RAVEN_KEY & RAVEN_PROJECT');
// }

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);

// Vue.component('alert', require('vue-strap').alert);
// Vue.component('datePicker', require('vue-strap').alert);
console.log('API', "%API_HOST%");
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.options.root = "%API_HOST%";
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.headers.common['Content-Type'] = 'application/json';
// Vue.http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.headers.common.Accept = 'application/json';
// Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});
//
// router.beforeEach((to, from, next) => {
//   if (to.query.token) {
//
//     if (to.query.product) {
//       next({
//         path: to.path,
//         query: {
//           product: to.query.product
//         }
//       });
//     } else {
//       next({
//         path: to.path,
//         query: false
//       });
//     }
//   } else {
//     next();
//   }
// });

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_addUser___ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_addUser____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_addUser___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auditConfig___ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auditConfig____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_auditConfig___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_audits___ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_audits____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_audits___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_checklistConfig___ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_checklistConfig____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_checklistConfig___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_checklists___ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_checklists____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_checklists___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_companies___ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_companies____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_companies___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_companies_companyConfig__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_companies_companyConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_companies_companyConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_login_index__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_login_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_logout_index__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_logout_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_logout_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Main__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_redirect___ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_redirect____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_redirect___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_roles___ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_roles____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_roles___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_shifts___ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_shifts____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_shifts___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_taskConfig_index__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_taskConfig_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_taskConfig_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_tasks_index__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_tasks_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_tasks_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_usersPermissions_index__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_usersPermissions_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_usersPermissions_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_workingAreas_index__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_workingAreas_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_workingAreas_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_router__ = __webpack_require__(560);








// import Home from '@/components/home/index';













__WEBPACK_IMPORTED_MODULE_18_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_19_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_19_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    // name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Main___default.a,
    children: [{
      path: 'company/:companyId',
      name: 'Home SuperUser',
      component: __WEBPACK_IMPORTED_MODULE_10__components_Main___default.a
    }, {
      path: '',
      name: 'Home',
      component: __WEBPACK_IMPORTED_MODULE_10__components_Main___default.a
    }]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_8__components_login_index___default.a
  }, {
    path: '/logout',
    name: 'logout',
    component: __WEBPACK_IMPORTED_MODULE_9__components_logout_index___default.a
  }, {
    path: '/configuration/WorkingAreas',
    // name: 'workingAreas',
    component: __WEBPACK_IMPORTED_MODULE_17__components_workingAreas_index___default.a,
    children: [{
      path: '',
      name: 'workingAreas'
      // component: WorkingAreas,
    }, {
      path: 'company/:companyId',
      name: 'workingAreas SuperUser'
      // component: WorkingAreas,
    }]
  }, {
    path: '/configuration/UsersPermissions',
    // name: 'User & Permissions',
    component: __WEBPACK_IMPORTED_MODULE_16__components_usersPermissions_index___default.a,
    children: [{
      path: '',
      name: 'User & Permissions'
      // component: UsersPermissions,
    }, {
      path: 'company/:companyId',
      name: 'User & Permissions SuperUser'
      // component: UsersPermissions,
    }]
  }, {
    path: '/configuration/AddUser',
    // name: 'Add User',
    component: __WEBPACK_IMPORTED_MODULE_1__components_addUser____default.a,
    props: { type: 'user' },
    children: [{
      path: '',
      name: 'Add User'
      // component: AddUser,
    }, {
      path: ':userId',
      name: 'Change User'
      // component: AddUser,
    }, {
      path: 'company/:companyId',
      name: 'Add User SuperUser'
      // component: AddUser,
    }, {
      path: ':userId/company/:companyId',
      name: 'Change User SuperUser'
      // component: AddUser,
    }]
  }, {
    path: '/configuration/AddAdmin',
    // name: 'Add Admin',
    component: __WEBPACK_IMPORTED_MODULE_1__components_addUser____default.a,
    props: { type: 'admin' },
    children: [{
      path: '',
      name: 'Add Admin'
      // component: AddUser,
    }, {
      path: ':userId',
      name: 'Change Admin'
      // component: AddUser,
    }, {
      path: 'company/:companyId',
      name: 'Add Admin SuperUser'
      // component: AddUser,
    }, {
      path: ':userId/company/:companyId',
      name: 'Change Admin SuperUser'
      // component: AddUser,
    }]
  }, {
    path: '/configuration/Shifts',
    // name: 'Days, times, shifts',
    component: __WEBPACK_IMPORTED_MODULE_13__components_shifts____default.a,
    children: [{
      path: '',
      name: 'Days, times, shifts'
    }, {
      path: 'company/:companyId',
      name: 'Days, times, shifts SuperUser'
    }]
  }, {
    path: '/configuration/Roles',
    // name: 'Roles',
    component: __WEBPACK_IMPORTED_MODULE_12__components_roles____default.a,
    children: [{
      path: '',
      name: 'Roles'
    }, {
      path: 'company/:companyId',
      name: 'Roles SuperUser'
    }]
  }, {
    path: '/constructor/TaskConstructor',
    name: 'Task Configuration',
    component: __WEBPACK_IMPORTED_MODULE_14__components_taskConfig_index___default.a,
    children: [{
      path: ':taskId',
      name: 'Task Configuration Change'
      // component: TaskConfig,
    }, {
      path: ':taskId/company/:companyId',
      name: 'Task Configuration Change SuperUser'
      // component: TaskConfig,
    }, {
      path: 'company/:companyId',
      name: 'Task Configuration SuperUser'
      // component: TaskConfig,
    }]
  }, {
    path: '/constructor/TaskConstructor/duplicate',
    name: 'Task Configuration Duplicate',
    component: __WEBPACK_IMPORTED_MODULE_14__components_taskConfig_index___default.a,
    props: { duplicate: true },
    children: [{
      path: ':taskId',
      name: 'Task Configuration Duplicate'
      // component: TaskConfig,
    }, {
      path: ':taskId/company/:companyId',
      name: 'Task Configuration Duplicate SuperUser'
    }]
  }, {
    path: "" + '/constructor/Tasks',
    name: 'Tasks',
    component: __WEBPACK_IMPORTED_MODULE_15__components_tasks_index___default.a,
    children: [{
      path: '',
      name: 'Tasks'
    }, {
      path: 'company/:companyId',
      name: 'Tasks SuperUser'
    }]
  }, {
    path: "" + '/constructor/new_tasks',
    name: 'New tasks',
    component: __WEBPACK_IMPORTED_MODULE_11__components_redirect____default.a,
    props: { route: 'tasktemplates' },
    children: [{
      path: '',
      name: 'New Tasks'
    }, {
      path: 'company/:companyId',
      name: 'New Tasks SuperUser'
    }]
  }, {
    path: "" + '/constructor/new_task',
    name: 'New task',
    component: __WEBPACK_IMPORTED_MODULE_11__components_redirect____default.a,
    props: { route: 'tasktemplates/new' },
    children: [{
      path: '',
      name: 'New Task'
    }, {
      path: 'company/:companyId',
      name: 'New Task SuperUser'
    }]
  }, {
    path: '/constructor/ChecklistConstructor',
    // name: 'Checklist Configuration',
    component: __WEBPACK_IMPORTED_MODULE_4__components_checklistConfig____default.a,
    children: [{
      path: '',
      name: 'Checklist Configuration'
    }, {
      path: 'company/:companyId',
      name: 'Checklist Configuration SuperUser'
    }]
  }, {
    path: '/constructor/ChecklistConstructor/:checklistId',
    // name: 'Checklist Configuration Change',
    component: __WEBPACK_IMPORTED_MODULE_4__components_checklistConfig____default.a,
    children: [{
      path: '',
      name: 'Checklist Configuration Change'
    }, {
      path: 'company/:companyId',
      name: 'Checklist Configuration Change SuperUser'
    }]
  }, {
    path: '/constructor/ChecklistConstructor/duplicate/:checklistId',
    component: __WEBPACK_IMPORTED_MODULE_4__components_checklistConfig____default.a,
    props: { duplicate: true },
    children: [{
      path: '',
      name: 'Checklist Configuration Duplicate'
    }, {
      path: 'company/:companyId',
      name: 'Checklist Configuration Duplicate SuperUser'
    }]
  }, {
    path: '/constructor/Checklists',
    // name: 'Checklists',
    component: __WEBPACK_IMPORTED_MODULE_5__components_checklists____default.a,
    children: [{
      path: '',
      name: 'Checklists'
    }, {
      path: 'company/:companyId',
      name: 'Checklists SuperUser'
    }]
  }, {
    path: "" + '/constructor/new_checklists',
    name: 'New checklists',
    component: __WEBPACK_IMPORTED_MODULE_11__components_redirect____default.a,
    props: { route: 'checklisttemplates' },
    children: [{
      path: '',
      name: 'New Checklists'
    }, {
      path: 'company/:companyId',
      name: 'New Checklists SuperUser'
    }]
  }, {
    path: "" + '/constructor/new_checklist',
    name: 'New checklist',
    component: __WEBPACK_IMPORTED_MODULE_11__components_redirect____default.a,
    props: { route: 'checklisttemplates/new' },
    children: [{
      path: '',
      name: 'New Checklist'
    }, {
      path: 'company/:companyId',
      name: 'New Checklist SuperUser'
    }]
  }, {
    path: '/constructor/AuditConstructor',
    // name: 'Audit Configuration',
    component: __WEBPACK_IMPORTED_MODULE_2__components_auditConfig____default.a,
    children: [{
      path: '',
      name: 'Audit Configuration'
    }, {
      path: 'company/:companyId',
      name: 'Audit Configuration SuperUser'
    }]
  }, {
    path: '/constructor/AuditConstructor/:auditId',
    // name: 'Audit Configuration Change',
    component: __WEBPACK_IMPORTED_MODULE_2__components_auditConfig____default.a,
    children: [{
      path: '',
      name: 'Audit Configuration Change'
    }, {
      path: 'company/:companyId',
      name: 'Audit Configuration Change SuperUser'
    }]
  }, {
    path: '/constructor/AuditConstructor/duplicate/:auditId',
    component: __WEBPACK_IMPORTED_MODULE_2__components_auditConfig____default.a,
    props: { duplicate: true },
    children: [{
      path: '',
      name: 'Audit Configuration Duplicate'
    }, {
      path: 'company/:companyId',
      name: 'Audit Configuration Duplicate SuperUser'
    }]
  }, {
    path: '/constructor/Audits',
    // name: 'Audits',
    component: __WEBPACK_IMPORTED_MODULE_3__components_audits____default.a,
    children: [{
      path: '',
      name: 'Audits'
    }, {
      path: 'company/:companyId',
      name: 'Audits SuperUser'
    }]
  }, {
    path: "" + '/constructor/new_audits',
    name: 'New audits',
    component: __WEBPACK_IMPORTED_MODULE_11__components_redirect____default.a,
    props: { route: 'audittemplates' },
    children: [{
      path: '',
      name: 'New Audits'
    }, {
      path: 'company/:companyId',
      name: 'New Audits SuperUser'
    }]
  }, {
    path: "" + '/constructor/new_audit',
    name: 'New audit',
    component: __WEBPACK_IMPORTED_MODULE_11__components_redirect____default.a,
    props: { route: 'audittemplates/new' },
    children: [{
      path: '',
      name: 'New Audit'
    }, {
      path: 'company/:companyId',
      name: 'New Audit SuperUser'
    }]
  }, {
    path: '/companies',
    name: 'Companies SuperUser',
    component: __WEBPACK_IMPORTED_MODULE_6__components_companies____default.a
  }, {
    path: '/companyConfig',
    name: 'Add Company SuperUser',
    component: __WEBPACK_IMPORTED_MODULE_7__components_companies_companyConfig___default.a
  }, {
    path: '/companyConfig/:companyId',
    name: 'Change Company SuperUser',
    component: __WEBPACK_IMPORTED_MODULE_7__components_companies_companyConfig___default.a
  }]
});

function hasQueryParams(route) {
  return !!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(route.query).length;
}

// pass SAML login redirect parameters to login
router.beforeEach(function (to, from, next) {
  if (!hasQueryParams(to) && hasQueryParams(from) && to.name === 'Home') {
    next({ name: to.name, query: from.query, params: from.params });
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(138);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(14);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'redirectToPortal',
  props: ['route'],
  mounted: function mounted() {
    console.log('redirect to new portal');
    var portalUrl = "%PORTAL_URL%";
    var token = localStorage.getItem('access_token');
    var authUser = JSON.parse(localStorage.getItem('authUser'));
    var companyId = this.$route.params.companyId || authUser.company.id;
    var route = this.route;
    window.location.href = portalUrl + '/externallogin?token=' + token + '&route=' + route + '&companyId=' + companyId;
  }
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      access_token: '',
      currentView: 'loginForm',
      authUser: null,
      companyId: null
    };
  },
  created: function created() {
    var _this = this;

    var token = localStorage.getItem('access_token');
    var authUser = localStorage.getItem('authUser');
    this.access_token = token || '';
    this.authUser = authUser ? JSON.parse(authUser) : null;
    if (!this.access_token || !this.authUser) {
      this.redirect("" + '/');
    }
    this.$router.beforeEach(function (to, from, next) {
      console.log('router', to, from);
      if (!to.name) {
        // this.$router.push({ name: 'Home' });
        next({ name: 'Home' });
        return;
      }
      if (to.name.indexOf(' SuperUser') + 1 && _this.authUser && _this.authUser.role !== 'superuser') {
        next({ name: 'Home' });
        return;
      }

      if (_this.authUser && _this.authUser.role === 'superuser') {
        // if (to.name === 'Add Company SuperUser' && to.params && false) {
        //   next({ name: 'Add Company SuperUser', params: {} });
        //   return;
        // }

        // If the superuser is going to the login or logout page, let him pass safely
        if (to.name.indexOf('logout') !== -1 || to.name.indexOf('login') !== -1) {
          next({ name: _name, params: _params });
          return;
        }

        var _name = to.name;
        var _params = to.params;
        console.log('route', _name, _params);
        if (to.name.indexOf(' SuperUser') === -1) {
          _name = _name + ' SuperUser';
          next({ name: _name, params: _params });
          return;
        }
        if (_params.companyId) {
          // this.$router.push({ name: name, params: params });
          next();
          return;
        }
        if (!_params.companyId && _name !== 'Add Company SuperUser' && _name !== 'Companies SuperUser') {
          _params.companyId = from.params.companyId;
          if (!_params.companyId) {
            _name = 'Companies SuperUser';
          }
        } else {
          next();
          return;
        }
        next({ name: _name, params: _params });
        return;
        // if (to.name.indexOf(' SuperUser') === -1) {
        //   if (from.params.companyId) {
        //     to.params.companyId = from.params.companyId;
        //   }
        //   this.$router.push({ name: `${to.name} SuperUser`, params: to.params });
        //   next();
        //   return;
        // } else {
        //   if (!to.params.companyId && to.name !== 'Add Company SuperUser' ) {
        //     to.params.companyId = from.params.companyId;
        //     // this.$router.push({ name: `${to.name}`, params: { companyId: from.params.companyId } });
        //     next();
        //     return;
        //   }
        // }
      }
      next();
    });
    this.checkAccess();
  },

  methods: {
    sendAuth: function sendAuth(data) {
      var _this2 = this;

      this.$http.post('authorize/', { username: data[0], password: data[1], app: 'cms' }, {
        method: 'POST',
        headers: {}
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          return;
        }
        _this2.access_token = response.body.access_token;
        _this2.authUser = response.body.user;
        return response.json();
      });
    },
    onLogout: function onLogout() {
      var redirectedOnError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      console.log('app: logout');
      this.access_token = '';
      this.authUser = null;
      this.$route.params.redirectedOnError = redirectedOnError;
      // this.$route.router.go(process.env.START_URL + '/');
      // this.redirect(process.env.START_URL + '/');
    },
    onLogin: function onLogin(accessToken, authUser) {
      this.access_token = accessToken;
      this.authUser = authUser;
      console.log('login');
      if (this.authUser && this.authUser.role == 'superuser') {
        this.$router.push({ name: 'Companies SuperUser' });
      } else {
        this.$router.push({ name: 'Home' });
      }
    },
    redirect: function redirect(url) {
      this.$router.push(url);
    },
    checkAccess: function checkAccess() {
      if (!this.$route.name) {
        this.$router.push({ name: 'Home' });
        return;
      }
      if (this.$route.name.indexOf(' SuperUser') + 1 && this.authUser && this.authUser.role !== 'superuser') {
        this.$router.push({ name: 'Home' });
        return;
      }
      if (this.authUser && this.authUser.role === 'superuser') {
        if (this.$route.name.indexOf(' SuperUser') === -1 && this.$route.name.indexOf('logout') === -1) {
          this.$router.push({ name: 'Companies SuperUser' });
          return;
        }
      }
      if (this.authUser && this.authUser.role === 'manager') {
        return;
      }
      var routeName = this.$route.name;
      switch (routeName) {
        case 'workingAreas':
        case 'User & Permissions':
        case 'Add User':
        case 'Add Admin':
        case 'Days, times, shifts':
        case 'Roles':
          this.$router.push({ name: 'Home' });
          break;
        default:
          break;
      }
    }
  },
  watch: {
    access_token: function access_token(val) {
      if (val && !localStorage.getItem("remove_access_token")) {
        localStorage.setItem('access_token', val);
      } else {
        localStorage.removeItem('access_token');
        localStorage.removeItem("remove_access_token");
        this.access_token = null;
        this.$router.push({ name: 'login' });
      }
    },
    authUser: function authUser(val) {
      if (val && !localStorage.getItem("remove_authUser")) {
        localStorage.setItem('authUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
      } else {
        localStorage.removeItem('authUser');
        this.authUser = null;
        localStorage.removeItem("remove_authUser");
        this.$router.push({ name: 'login' });
      }
    }
  }
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_index__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__login_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_index__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__home_index__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main',
  props: ['onLogout', 'onLogin', 'access_token', 'authUser'],
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_0__header_index__, loginForm: __WEBPACK_IMPORTED_MODULE_1__login_index__, home: __WEBPACK_IMPORTED_MODULE_2__home_index__ },
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {
    sendAuth: function sendAuth(access_token, user) {
      // this.$http.post('authorize/', { username: data[0], password: data[1] },
      //   {
      //     method: 'POST',
      //     headers: {},
      //   })
      //   .then((response) => {
      //     if (response.status !== 200) {
      //       console.log(response);
      //       return;
      //     }
      //     console.log(response);
      //     this.$emit('onLogin', response.body.access_token, response.body.user);
      //   });
      this.$emit('onLogin', access_token, user);
    },

    redirect: function redirect(url) {
      this.$router.push(url);
    }
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__personalDetails___ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__personalDetails____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__personalDetails___);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-user',
  props: ['onLogout', 'type'],
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_0__header___, personalDetails: __WEBPACK_IMPORTED_MODULE_1__personalDetails___ },
  mounted: function mounted() {},
  data: function data() {
    return {
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Users & Permissions',
        routerName: 'User & Permissions'
      }, {
        text: 'Add administrator',
        active: true
      }]
    };
  },

  methods: {
    bradcrumbClick: function bradcrumbClick(e) {
      if (!e.routerName) return;
      this.$router.push({ name: 'User & Permissions', params: { type: this.type } });
    }
  },
  computed: {},
  created: function created() {
    var breadActionType = this.$route.params.userId ? 'Change' : 'Add';
    var breadUserType = this.type == 'admin' ? 'administrator' : 'user';
    this.breadCrumbItems[this.breadCrumbItems.length - 1].text = breadActionType + ' ' + breadUserType;
    var token = localStorage.getItem('access_token');
    var authUser = localStorage.getItem('authUser');
    this.access_token = token || '';
    this.authUser = authUser ? JSON.parse(authUser) : null;
  }
});

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autocomplete_vue_autocomplete_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autocomplete_vue_autocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__autocomplete_vue_autocomplete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__areaCheckbox___ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__areaCheckbox____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__areaCheckbox___);



var alert = __webpack_require__(10).alert;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'personal-details',
  props: ['onLogout', 'access_token', 'authUser', 'type'],
  mounted: function mounted() {},

  components: { Autocomplete: __WEBPACK_IMPORTED_MODULE_0__autocomplete_vue_autocomplete_vue___default.a, AreaCheckbox: __WEBPACK_IMPORTED_MODULE_1__areaCheckbox____default.a, alert: alert },
  data: function data() {
    return {
      usersList: [],
      selectedUser: null,
      usersListOptions: [],
      mustDelete: false,
      // authUser: null,
      formData: {
        id: null,
        first_name: '',
        last_name: '',
        username: '',
        email: '',
        upn: '',
        passwordForm: '',
        confirmPassword: '',
        img: '',
        // picture: null,
        pictureBugFixer: null,
        company: null,
        role: this.type === 'admin' ? 'shift_leader' : 'basic',
        areas: []
      },
      userData: {},
      suggestArea: [],
      areas: [],
      areasChecked: [],
      areaFromList: false,
      roles: [{
        text: 'Shift leader',
        value: 'shift_leader'
      }, {
        text: 'Manager',
        value: 'manager'
      }],
      alertError: {
        text: 'Some required fields are not filled',
        title: 'Error!',
        visible: false
      },
      alertSuccess: {
        text: 'User created, tab will be closed in 3 seconds',
        title: '',
        visible: false
      },
      needFill: false
    };
  },

  methods: {
    getUsersList: function getUsersList() {
      var _this = this;

      var url = 'users/';
      if (this.$route.params.companyId) {
        url = url + '?company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return null;
        }
        _this.usersList = response.body.filter(function (user) {
          return !user.is_deleted && user.id.toString() !== _this.$route.params.userId;
        });
        _this.usersListOptions = _this.usersList.map(function (user) {
          return { value: user.id, text: user.first_name + ' ' + user.last_name };
        }).sort(function (a, b) {
          if (a.text > b.text) return 1;
          if (a.text < b.text) return -1;
          return 0;
        });
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
      });
    },
    readURL: function readURL(input) {
      var self = this;
      if (input.files && input.files[0]) {
        this.formData.pictureBugFixer = input.files[0];
        var reader = new FileReader();
        reader.onload = function (e) {
          // $('#icon').attr('src', e.target.result);
          self.formData.img = e.target.result;
          self.imageOrientation(input, self);
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    handleFileChange: function handleFileChange(e) {
      // this.formData.img = e.target.files[0].name;
      e.preventDefault();
      if (e.target.files && e.target.files[0] && e.target.files[0].size > 5000000) {
        e.target.value = '';
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
        return;
      }
      this.readURL(e.target);
    },
    getWorkingAreas: function getWorkingAreas() {
      var _this2 = this;

      var url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = url + '&company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        _this2.areas = response.body;
        // return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this2.onLogout();
        }
      });
    },
    processJSON: function processJSON(json) {
      return json.results;
    },
    getDataSearchArea: function getDataSearchArea(data, area) {
      for (var i = 0; i < this.areasChecked.length; i++) {
        if (this.areasChecked[i].id === area.area.id) {
          return;
        }
      }
      this.areasChecked.push(area.area);
    },
    getUserAreaPath: function getUserAreaPath(area) {
      var result = [];
      for (var i = 0; i < area.length; i++) {
        var res = this.getUserAreaPath(area[i].subareas);
        for (var j = 0; j < res.length; j++) {
          result.push({ name: area[i].name + '/' + res[j].name, area: res[j].area });
        }
        if (res.length === 0) {
          result.push({ name: area[i].name, area: area[i] });
        }
      }
      return result;
    },
    selectedAreaChanged: function selectedAreaChanged(area) {
      console.log('areachanged', area[0].name);
    },
    updateSuggestArea: function updateSuggestArea() {
      this.suggestArea = [];
      var areaPaths = this.getUserAreaPath(this.areas);
      for (var i = 0; i < areaPaths.length; i++) {
        this.suggestArea.push(areaPaths[i]);
      }
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    onClickDelete: function onClickDelete() {
      this.$refs.confirm_delete.hide();
      if (this.formData.open_actions_count || this.formData.assigned_actions_count) {
        this.$refs.assign_to_user.show();
      } else {
        this.deleteUser(this.formData.id);
      }
    },
    deleteUser: function deleteUser(id) {
      var _this3 = this;

      this.$http.put('users/' + id + '/deactivate/', { successor: this.selectedUser ? this.selectedUser : null }, {
        method: 'PUT',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        _this3.alertSuccess.text = 'User successfully deleted, tab will be closed in 3 seconds';
        _this3.alertSuccess.visible = true;
        _this3.needFill = false;
        setTimeout(function () {
          _this3.returnBack();
        }, 3000);
        // return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this3.onLogout();
        }
      });
    },
    submitUser: function submitUser() {
      var _this4 = this;

      var self = this;
      this.alertError.visible = false;
      this.alertError.text = 'Some required fields are not filled';
      if (this.formData.id) {
        this.alertSuccess.text = 'Saved successfully, tab will be closed in 3 seconds';
      }
      if (this.formData.email && !this.validateEmail(this.formData.email)) {
        this.alertError.text = 'Invalid Email';
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (!this.formData.username && !this.validateEmail(this.formData.email)) {
        this.alertError.text = 'Username or Email mandatory';
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (this.formData.id && this.formData.passwordForm.length !== 0 && this.formData.passwordForm !== this.formData.confirmPassword) {
        this.alertError.text = "Passwords don't match";
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (!this.formData.id && this.formData.passwordForm.length === 0) {
        this.alertError.text = 'Password mandatory';
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (!this.formData.id && (this.formData.passwordForm.length === 0 || this.formData.passwordForm !== this.formData.confirmPassword)) {
        this.alertError.text = "Passwords don't match";
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (this.formData.passwordForm.length !== 0 && (this.formData.passwordForm.length < 6 || !/(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])/.test(this.formData.passwordForm))) {
        this.alertError.text = "Please, check your password. Missing required characters!";
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }

      if (!this.areasChecked.length && this.formData.role !== 'manager') {
        this.needFill = true;
        this.alertError.text = 'Working area mandatory';
        this.alertError.visible = true;
        return null;
      }
      this.formData.areas = [];
      for (var i = 0; i < this.areasChecked.length; i++) {
        this.formData.areas.push(this.areasChecked[i].id);
      }
      if (this.formData.areas.length === 0 || this.formData.role === 'manager') {
        this.formData.areas = [];
      }
      if (this.authUser.company) {
        this.formData.company = this.authUser.company.id;
      }
      if (!this.formData.company && this.$route.params.companyId) {
        this.formData.company = this.$route.params.companyId;
      }

      var formData = new FormData();
      this.formData.password = this.formData.passwordForm;
      for (var key in this.formData) {
        formData.append(key, this.formData[key]);
      }
      if (!this.formData.id) {
        return this.$http.post('users/', this.formData, {
          method: 'POST',
          headers: {
            // 'Content-Type': 'multipart/form-data',
            // 'Content-Type': 'application/json',
            Authorization: 'Token ' + this.access_token
          }
          // emulateJSON: true,
        }).then(function (response) {
          if (response.status !== 201) {
            console.log(response);
            return null;
          }
          return self.sendPicture(self, response.body.id);
          // this.$refs.user_added.show();
          // return response.json();
        }).catch(function (response) {
          if (response.status === 401) {
            _this4.onLogout();
          }
          if (response.body.username && response.body.username.length) {
            self.alertError.text = response.body.username[0];
          } else if (response.body.non_field_errors) {
            self.alertError.text = response.body.non_field_errors[0];
          } else {
            self.alertError.text = response.body.detail;
          }
          self.alertError.visible = true;
          _this4.needFill = false;
        });
      }

      if (!this.formData.passwordForm) {
        delete this.formData.password;
      }
      return this.$http.patch('users/' + this.formData.id + '/', this.formData, {
        method: 'PATCH',
        headers: {
          // 'Content-Type': 'multipart/form-data',
          // 'Content-Type': 'application/json',
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          return null;
        }
        return self.sendPicture(self, response.body.id);
        // this.$refs.user_added.show();
        // return response.json();
      }).catch(function (resp) {
        if (resp.status === 401) {
          _this4.onLogout();
        }
        self.alertError.text = resp.body;
        self.alertError.visible = true;
        _this4.needFill = false;
      });
    },
    sendPicture: function sendPicture(self, id) {
      var _this5 = this;

      if (!id) {
        return;
      }
      if (!self.formData.pictureBugFixer) {
        self.alertSuccess.visible = true;
        this.needFill = false;
        setTimeout(function () {
          self.returnBack();
        }, 3000);
        return;
      }
      var formDataPicture = new FormData();
      formDataPicture.append('picture', self.formData.pictureBugFixer);
      self.$http.patch('users/' + id + '/', formDataPicture, {
        method: 'PATCH',
        headers: {
          // 'Content-Type': 'multipart/form-data',
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        self.alertSuccess.visible = true;
        _this5.needFill = false;
        setTimeout(function () {
          self.returnBack();
        }, 3000);
        // self.$refs.user_added.show();
        // return response.json();
      }).catch(function (resp) {
        return resp;
      });
    },
    getUrl: function getUrl() {
      return "" + '/configuration/usersPermissions';
    },
    returnBack: function returnBack() {
      window.close();
      //this.$router.push({ name: 'User & Permissions', params: { type: this.type } });
    },
    getUser: function getUser(id) {
      var _this6 = this;

      return this.$http.get('users/' + id, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return response.status;
        }
        _this6.userData = response.body;
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this6.onLogout();
        }
      });
    },
    getAreaById: function getAreaById(id) {
      var area = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.areas;

      for (var i = 0; i < area.length; i++) {
        if (area[i].id === id) {
          return area[i];
        }
        var res = this.getAreaById(id, area[i].subareas);
        if (res) {
          return res;
        }
      }
      return null;
    },
    fillData: function fillData() {
      this.formData.id = this.userData.id;
      this.mustDelete = this.mustDelete && this.formData.id !== this.authUser.id;
      this.formData.first_name = this.userData.first_name;
      this.formData.last_name = this.userData.last_name;
      this.formData.username = this.userData.username;
      this.formData.email = this.userData.email;
      this.formData.upn = this.userData.upn;
      this.formData.role = this.userData.role;
      this.formData.is_deleted = this.userData.is_deleted;
      this.formData.open_actions_count = this.userData.open_actions_count;
      this.formData.assigned_actions_count = this.userData.assigned_actions_count;
      if (this.userData.picture) {
        this.formData.img = this.userData.picture;
      }
      this.areasChecked = [];
      for (var i = 0; i < this.userData.areas.length; i++) {
        var area = this.getAreaById(this.userData.areas[i].id);

        if (!area) continue;

        this.areasChecked.push(area);
      }
    },
    getOrientation: function getOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) return callback(-2);
        var length = view.byteLength;
        var offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) return callback(-1);
            var little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) break;else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file);
    },
    imageOrientation: function imageOrientation(input, self) {
      self.getOrientation(input.files[0], function (orientation) {
        var img = document.getElementById('icon-frame');
        img.className = 'img-icon ';
        if (orientation === 6 || orientation === 5) {
          img.className += 'rotate90';
        }
        if (orientation === 8 || orientation === 7) {
          img.className += 'rotate270';
        }
        if (orientation === 3 || orientation === 4) {
          img.className += 'rotate180';
        }
        console.log('orientation: ' + orientation);
      });
    }
  },
  computed: {},
  created: function created() {
    var _this7 = this;

    this.getUsersList();
    this.getWorkingAreas().then(function () {
      if (_this7.$route.params.userId) {
        _this7.getUser(_this7.$route.params.userId).then(function () {
          return _this7.fillData();
        });
      }
    });
    // const authUser = localStorage.getItem('authUser');
    // this.authUser = authUser ? JSON.parse(authUser) : null;
    this.mustDelete = this.authUser && (this.authUser.role == 'manager' || this.authUser.role == 'superuser');
  },

  watch: {
    areas: function areas() {
      this.updateSuggestArea();
    }
  }
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'area-checkbox',
  model: {
    prop: 'value',
    event: 'selectedAreaChanged'
  },
  props: ['areas', 'selected', 'type', 'baseId'],
  mounted: function mounted() {},
  data: function data() {
    return {
      value: [],
      areaActiveS: [],
      locSelected: ''
    };
  },

  methods: {
    onClick: function onClick(index, item) {
      this.areaActiveS[index].active = !this.areaActiveS[index].active;
      if (this.type == 'radio') {
        // let checkbox = document.getElementById(this.baseId + item.id);
        // checkbox.checked = true;
        // this.$emit('selectedAreaChanged', [item]);
      }
      if (this.type == 'checkbox') {
        // let checkbox = document.getElementById(this.baseId + item.id);
        // // checkbox.checked = true;
        // this.$emit('selectedAreaChanged', [item]);
      }
    },
    selectedAreaChanged: function selectedAreaChanged(area) {
      if (this.type == 'radio') {
        this.value = area;
        this.$emit('selectedAreaChanged', this.value);
      }
      if (this.type == 'checkbox') {
        this.onCheck(area);
      }
    },
    onCheck: function onCheck(area) {
      if (this.type == 'checkbox') {
        for (var i = 0; i < area.length; i++) {
          var checked = document.getElementById(this.baseId + area[i].id).checked;
          if (checked && !(this.value.indexOf(area[i]) + 1)) {
            this.value.push(area[i]);
          }
        }
        for (var _i = 0; _i < this.value.length; _i++) {
          var _checked = document.getElementById(this.baseId + this.value[_i].id).checked;
          if (!_checked) {
            this.value.splice(_i, 1);
            _i--;
          }
        }
        this.$emit('selectedAreaChanged', this.value);
        // this.value = area;
      }
      if (this.type == 'radio') {
        for (var _i2 = 0; _i2 < area.length; _i2++) {
          var _checked2 = document.getElementById(this.baseId + area[_i2].id).checked;
          if (_checked2 && !(this.value.indexOf(area[_i2]) + 1)) {
            this.value.push(area[_i2]);
          }
        }
        for (var _i3 = 0; _i3 < this.value.length; _i3++) {
          var _checked3 = document.getElementById(this.baseId + this.value[_i3].id).checked;
          if (!_checked3) {
            this.value.splice(_i3, 1);
            _i3--;
          }
        }
        this.$emit('selectedAreaChanged', this.value);
        // this.value = area;
      }
    },
    updateCheckBox: function updateCheckBox() {
      if (!this.selected) return;
      for (var i = 0; i < this.selected.length; i++) {
        var elem = document.getElementById(this.baseId + this.selected[i].id);
        if (elem) {
          elem.checked = true;
        }
      }
    }
  },
  computed: {},
  created: function created() {
    // this.value = [];
    this.value = this.selected;
    for (var i = 0; i < this.areas.length; i++) {
      // this.areas[i].active = false;
      // console.log('add');
      this.areaActiveS.push({ active: false });
    }
    this.updateCheckBox();
  },

  watch: {
    selected: function selected(val) {
      this.value = this.selected;
      this.updateCheckBox();
    },
    areas: function areas() {
      for (var i = 0; i < this.areas.length; i++) {
        this.areaActiveS.push({ active: false });
      }
    }
  }
});

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__header___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__autocomplete_vue_autocomplete_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__autocomplete_vue_autocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__autocomplete_vue_autocomplete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__areaCheckbox___ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__areaCheckbox____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__areaCheckbox___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__thumbnail__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__thumbnail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__thumbnail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uploading__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uploading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__uploading__);












var alert = __webpack_require__(10).alert;
var spinner = __webpack_require__(10).spinner;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'audit-config',
  components: {
    headerBlock: __WEBPACK_IMPORTED_MODULE_6__header___,
    Autocomplete: __WEBPACK_IMPORTED_MODULE_7__autocomplete_vue_autocomplete_vue___default.a,
    AreaCheckbox: __WEBPACK_IMPORTED_MODULE_8__areaCheckbox____default.a,
    alert: alert,
    spinner: spinner,
    Thumbnail: __WEBPACK_IMPORTED_MODULE_9__thumbnail___default.a,
    Uploading: __WEBPACK_IMPORTED_MODULE_10__uploading___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a },
  props: ['onLogout', 'access_token', 'authUser', 'duplicate'],
  mounted: function mounted() {},
  data: function data() {
    return {
      formData: {
        id: null,
        name: '',
        picture: '',
        picture_url: '',
        role: 'basic',
        area: [],
        signatureCount: 0,
        score_type: 'thumbs',
        lowScore: 1,
        highScore: 10,
        tasks: []
      },
      is_performed: false,
      signatureCountOptions: [{
        text: 'No',
        value: 0
      }, {
        text: 'Yes, one signature',
        value: 1
      }, {
        text: 'Yes, two signatures',
        value: 2
      }],
      scoreTypeOptions: [{
        text: 'Thumb up/down',
        value: 'thumbs'
      }, {
        text: 'Custom score',
        value: 'score'
      }],
      activeTask: null,
      activeTaskNext: null,
      showTasks: true,
      tagsOptions: [],
      emptyTask: {
        id: null,
        name: '',
        description: '',
        selectedContent: '',
        picture: '',
        picture_url: '',
        video: '',
        video_url: '',
        video_thumbnail: '',
        thumbnail_url: null,
        video_require: false,
        description_file: '',
        description_file_url: '',
        steps: [],
        stepsMustDelete: [],
        index: 0,
        weight: null,
        tags: '',
        tagsValue: []
      },
      emptyStep: {
        id: null,
        order: 1,
        description: '',
        valid: true,
        picture_urlChanged: false,
        selectedContent: '',
        picture: '',
        picture_url: '',
        video: '',
        video_url: '',
        video_thumbnail: '',
        thumbnail_url: null,
        video_require: false
      },
      suggestArea: [],
      userRoles: [],
      areas: [],
      audit: null,
      auditId: null,
      processLoading: false,
      areaFromList: false,
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Audits',
        to: "" + '/constructor/Audits'
      }, {
        text: 'Constructor',
        active: true
      }],
      haveItemChanges: false,
      needFill: false,
      hasSaveError: false,
      alertError: {
        text: 'Some fields are not filled',
        title: 'Error!',
        visible: false
      },
      alertSuccess: {
        text: 'Saved successfully',
        title: 'Well Done!',
        visible: false
      },
      upload: {
        total: 1,
        uploaded: 0,
        image: true,
        visible: false
      },
      dragSrcEl: null
    };
  },

  methods: {
    handleVideoFileChange: function handleVideoFileChange(e) {
      if (e.target.files && e.target.files[0] && e.target.files[0].size > 50000000) {
        e.target.value = '';
        this.alertError.text = 'Maximum allowed video size is 50 MB.';
        this.alertError.visible = true;
        return;
      }
    },
    updateTags: function updateTags(task) {
      task.tags = '';
      for (var i = 0; i < task.tagsValue.length; i++) {
        if (i !== 0) {
          task.tags = task.tags + ', ';
        }
        task.tags = '' + task.tags + task.tagsValue[i].name;
      }
      this.onChangeAuditTask();
    },
    addTag: function addTag(task, newTag) {
      var tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      if (!this.tagsOptions.some(function (item) {
        if (item.name === tag.name) {
          tag.code = item.code;
          return true;
        }
        return false;
      })) {
        this.tagsOptions.push(tag);
      }
      task.tagsValue.push(tag);
      this.updateTags(task);
    },
    addEmptyStep: function addEmptyStep(task) {
      var maxStepOrder = 0;
      var self = this;
      var orders = [];
      var orderCount = 1;
      for (var i = 0; i < task.steps.length; i++) {
        orders.push(+task.steps[i].order);
        if (maxStepOrder < task.steps[i].order) {
          maxStepOrder = task.steps[i].order;
        }
      }
      for (var _i = 1; _i <= +maxStepOrder + 1; _i++) {
        if (orders.indexOf(_i) === -1) {
          orderCount = _i;
          break;
        }
      }
      task.steps.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.emptyStep)));
      task.steps[task.steps.length - 1].order = orderCount;
    },
    addEmptyTask: function addEmptyTask() {
      this.formData.tasks.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.emptyTask)));
      // this.addEmptyStep(this.formData.tasks[this.formData.tasks.length - 1]);
      console.log('add task', this.formData.tasks);
      if (this.activeTask === null) {
        this.activeTask = 0;
      }
    },
    removeStep: function removeStep(task, index) {
      if (task.steps[index].id) {
        task.stepsMustDelete.push(task.steps[index].id);
      }
      task.steps.splice(index, 1);
    },
    processJSON: function processJSON(json) {
      return json.results;
    },
    getDataSearchArea: function getDataSearchArea(data, area) {
      this.formData.area = [area.area];
    },
    getUserAreaPath: function getUserAreaPath(area) {
      var result = [];
      for (var i = 0; i < area.length; i++) {
        var res = this.getUserAreaPath(area[i].subareas);
        for (var j = 0; j < res.length; j++) {
          result.push({ name: area[i].name + '/' + res[j].name, area: res[j].area });
        }
        if (res.length === 0) {
          result.push({ name: area[i].name, area: area[i] });
        }
      }
      return result;
    },
    updateSuggestArea: function updateSuggestArea() {
      this.suggestArea = [];
      var areaPaths = this.getUserAreaPath(this.areas);
      for (var i = 0; i < areaPaths.length; i++) {
        this.suggestArea.push(areaPaths[i]);
      }
    },
    clearAuditItemVideo: function clearAuditItemVideo(e, step, index) {
      console.log(this.$refs.auditItemVideoFile, index);
      if (step.video_url) {
        step.video_url = '';
        this.$refs.auditItemVideoFile[index].reset();
        e.preventDefault();
        return;
      }
      if (!step.video) {
        return;
      }
      this.$refs.auditItemVideoFile[index].reset();
      e.preventDefault();
    },
    clearStepVideo: function clearStepVideo(e, step, index) {
      console.log(this.$refs.stepvideofile, index);
      if (step.video_url) {
        step.video_url = '';
        this.$refs.stepvideofile[index].reset();
        e.preventDefault();
        return;
      }
      if (!step.video) {
        return;
      }
      this.$refs.stepvideofile[index].reset();
      e.preventDefault();
    },
    clearPdfFile: function clearPdfFile(e, index) {
      if (this.formData.tasks[index].description_file_url) {
        this.formData.tasks[index].description_file_url = '';
        this.$refs['pdffile' + index][0].reset();
        e.preventDefault();
        return;
      }
      if (!this.formData.tasks[index].description_file) {
        return;
      }
      this.$refs['pdffile' + index][0].reset();
      e.preventDefault();
    },
    changePdfFile: function changePdfFile(e, index) {
      if (!this.formData.tasks[index].description_file) {
        return null;
      }
      if (this.formData.tasks[index].description_file && this.formData.tasks[index].description_file.size > 5000000) {
        this.$refs['pdffile' + index][0].reset();
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
      }
      return null;
    },
    calculateImagesCount: function calculateImagesCount() {
      var result = 0;
      if (this.formData.picture) {
        console.log('this.formData.picture');
        result++;
      }
      for (var i = 0; i < this.formData.tasks.length; i++) {
        if (this.formData.tasks[i].picture) result++;
        if (this.formData.tasks[i].description_file) result++;
        result += this.formData.tasks[i].steps.filter(function (item) {
          return item.picture;
        }).length;
      }
      console.log('calculateImagesCount', result);
      return result;
    },
    uploadVideo: function uploadVideo(data) {
      var _this = this;

      var uploadData = {
        filename: data.name
      };
      if (this.$route.params.companyId) {
        uploadData.company = this.$route.params.companyId;
      }
      return this.$http.post('upload/', uploadData, {
        method: 'POST',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          _this.alertError.text = _this.getErrorText(response);
          return response.status;
        }
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(response.body.upload_url, data, {
          method: 'PUT',
          headers: __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common
          // {
          //   'content-type': 'video/mp4',
          // },
          // emulateJSON: true,
        }).then(function (resp) {
          if (response.status !== 200) {
            _this.alertError.text = _this.getErrorText(resp);
            return resp.status;
          }
          return response.body.final_url;
        }).catch(function (response) {
          if (response.status === 401) {
            _this.onLogout();
          }
          _this.alertError.text = _this.getErrorText(response);
          return response;
        });
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
        _this.alertError.text = _this.getErrorText(response);
        return response;
      });
    },
    saveAuditItemVideo: function saveAuditItemVideo(item) {
      if (!item.video || item.selectedContent !== 'video') {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          resolve(false);
        });
      }
      return this.uploadVideo(item.video).then(function (urlVideo) {
        console.log('uploadUrlVideo', urlVideo);
        item.video_url = urlVideo;
        return null;
      });
    },

    // duplicateAudit() {
    //   this.$router.push({ name: this.$route.name.replace('Change', 'Duplicate') });
    //   location.reload();
    //   // this.$router.go(this.$router.currentRoute);
    // },
    duplicateAudit: function duplicateAudit() {
      var _this2 = this;

      return this.$http.post('audit-templates/' + this.auditId + '/duplicate/', {}, {
        method: 'POST',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('audit duplication err', response);
          _this2.alertError.text = _this2.getErrorText(response);
          return response.status;
        }
        console.log('DUPLICATE RESPONSE', response);
        _this2.$router.push({ name: 'Audit Configuration Change',
          params: { auditId: response.body.id } });
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this2.onLogout();
        }
        _this2.alertError.text = _this2.getErrorText(response);
        return response;
      });
    },
    saveAudit: function saveAudit() {
      var _this3 = this;

      var self = this;
      if (!this.validateAudit()) {
        this.alertError.visible = true;
        return;
      }
      this.hasSaveError = false;
      // return;
      this.upload.total = this.calculateImagesCount();
      this.upload.uploaded = 0;
      this.upload.image = this.upload.total !== 0;
      this.upload.visible = true;

      this.sendSaveAuditTemplate(self.formData).then(function (response) {
        if (response !== 200 && response !== 201) {
          self.hasSaveError = true;
          console.log('sendSaveAuditTemplate err', response);
        } else _this3.needFill = false;
        if (self.duplicate) {
          setTimeout(function () {
            _this3.$router.push({
              name: _this3.$route.name.replace('Duplicate', 'Change'),
              params: {
                companyId: _this3.$route.params.companyId,
                checklistId: _this3.formData.id
              }
            });
          }, 3000);
        }
      }).then(function () {
        return self.saveTasks(self.formData.tasks);
      }).then(function () {
        self.haveItemChanges = false;
        if (self.formData.tasks.length) {
          self.deleteTaskSteps(self.formData.tasks[self.activeTask]);
        }
      }).then(function () {
        if (self.hasSaveError) {
          console.log('saveEnd save has errors');
          // self.alertError.text = 'There were errors during the upload';
          self.alertError.visible = true;
          _this3.upload.visible = false;
        } else {
          console.log('saveEnd success');
          self.alertSuccess.visible = true;
          _this3.upload.visible = false;
          setTimeout(function () {
            self.$router.push({ name: 'Audits' });
          }, 3000);
        }
      }).catch(function (response) {
        console.log('ERRR have catch', response);
        // self.alertError.text = 'There were errors during the upload';
        self.alertError.text = self.getErrorText(response);
        self.alertError.visible = true;
        _this3.upload.visible = false;
      });
    },
    deleteAudit: function deleteAudit() {
      var self = this;
      if (this.formData.id) {
        this.sendDeleteAudit(this.formData.id).then(function () {
          self.alertSuccess.text = 'Audit successfully deleted';
          self.alertSuccess.title = 'Well done!';
          self.alertSuccess.visible = true;
          setTimeout(function () {
            self.$router.push({ name: 'Audits' });
          }, 3000);
        });
      }
    },
    sendDeleteAudit: function sendDeleteAudit(id) {
      return this.$http.patch('audit-templates/' + id + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('audit del err', response);
          self.alertError.text = self.getErrorText(response);
          return response.status;
        }
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          self.onLogout();
        }
        self.alertError.text = self.getErrorText(response);
        return response;
      });
    },
    deleteTask: function deleteTask(task, index) {
      if (task.id) {
        this.sendDeleteTask(task);
      }
      this.formData.tasks.splice(index, 1);
      self.haveItemChanges = false;
    },
    sendDeleteTask: function sendDeleteTask(task) {
      return this.$http.patch('audit-task-templates/' + task.id + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('task del err', response);
          self.alertError.text = self.getErrorText(response);
          return response.status;
        }
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          self.onLogout();
        }
        self.alertError.text = self.getErrorText(response);
        return response;
      });
    },
    saveTasks: function saveTasks(tasks) {
      var count = 0;
      var self = this;
      function saveTask(task, resolve) {
        self.saveAuditItemVideo(task).then(function () {
          return self.sendSaveTask(task);
        }).then(function (response) {
          if (response !== 201 && response !== 200) {
            console.log('sendSavetasks has err', response);
            self.hasSaveError = true;
          } else {
            return self.saveTaskSteps(task.steps, task.id);
          }
          return null;
        }).then(function () {
          count++;
          if (count === tasks.length) {
            self.sendUpdateAuditTasks(self.formData);
            resolve();
          }
        }).catch(function (response) {
          self.alertError.text = self.getErrorText(response);
          self.hasSaveError = true;
          count++;
          if (count === tasks.length) {
            self.sendUpdateAuditTasks(self.formData);
            resolve();
          }
        });
      }
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!tasks.length) resolve();
        for (var i = 0; i < tasks.length; i++) {
          saveTask(tasks[i], resolve);
        }
      });
    },
    saveTask: function saveTask(task) {
      var _this4 = this;

      var self = this;
      if (!this.validateTask(task)) {
        this.alertError.visible = true;
        // this.alertError.text = 'Missing needed data.
        // All basic info fields and at least one audit question are mandatory.';
        this.activeTaskNext = null;
        return;
      }
      self.alertError.text = 'There were errors during the upload';
      self.hasSaveError = false;
      this.upload.total = task.steps.filter(function (item) {
        return item.picture;
      }).length;
      this.upload.total += task.description_file ? 1 : 0;
      this.upload.uploaded = 0;
      this.upload.image = this.upload.total !== 0;
      this.upload.visible = true;
      self.saveAuditItemVideo(task).then(function () {
        return self.sendSaveTask(task);
      }).then(function (response) {
        if (response !== 200 && response !== 201) {
          self.hasSaveError = true;
          self.alertError.text = self.getErrorText(response);
          console.log('saveTask err', response);
        } else {
          return self.saveTaskSteps(task.steps, task.id);
        }
        return null;
      }).then(function () {
        return self.deleteTaskSteps(task);
      }).then(function () {
        if (self.hasSaveError) return null;
        return _this4.sendUpdateAuditTasks(self.formData);
      }).then(function () {
        if (self.hasSaveError) {
          console.log('saveEnd save has errors');

          self.alertError.visible = true;
          self.upload.visible = false;
          _this4.activeTaskNext = null;
        } else {
          console.log('saveEnd success');
          self.alertSuccess.visible = true;
          self.upload.visible = false;
          self.haveItemChanges = false;
          if (_this4.activeTaskNext !== null) {
            _this4.activeTask = _this4.activeTaskNext;
          }
        }
      }).catch(function (response) {
        console.log('ERRR have catch', response);
        self.alertError.text = self.getErrorText(response);
        self.alertError.visible = true;
        self.upload.visible = false;
        _this4.activeTaskNext = null;
      });
    },
    saveTaskSteps: function saveTaskSteps(steps, taskId) {
      var self = this;
      if (!steps.length) {
        return null;
      }
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var count = 0;

        var _loop = function _loop(i) {
          self.saveAuditItemVideo(steps[i]).then(function () {
            return self.sendSaveStep(steps[i], taskId);
          }).then(function (response) {
            if (response !== 201 && response !== 200) {
              console.log('sendSaveStep has err', response);
              self.hasSaveError = true;
            }
            count++;
            if (count === steps.length) {
              resolve();
            }
          }).catch(function (response) {
            self.alertError.text = self.getErrorText(response);
            return response;
          });
        };

        for (var i = 0; i < steps.length; i++) {
          _loop(i);
        }
      });
    },
    sendUpdateAuditPicture: function sendUpdateAuditPicture(audit) {
      var _this5 = this;

      if (!audit.id) return null;
      if (!audit.picture && audit.picture_url) return 200;
      var formData = new FormData();
      formData.append('picture', audit.picture);
      // Deprecated
      // if (this.duplicate) {
      //   if (audit.picture) {
      //     let blob = new Blob([audit.picture], { type: 'image/jpeg' });
      //     // let fileOfBlob = new File([blob], 'photo.jpg', { type: 'image/jpeg' });
      //     // form.append("upload", fileOfBlob);
      //     // formData.append('picture', fileOfBlob);
      //     formData.append('picture', blob, 'photo.jpg');
      //   }
      // } else {
      //   formData.append('picture', audit.picture);
      // }
      return this.$http.patch('audit-templates/' + audit.id + '/', formData, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('audit err', response);
          return response.status;
        }
        if (audit.picture) _this5.upload.uploaded++;
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this5.onLogout();
        }
        _this5.alertError.text = _this5.getErrorText(response);
        return response;
      });
    },
    discardTaskChanges: function discardTaskChanges(taskIndex) {
      if (!this.formData.tasks[taskIndex].id) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.formData.tasks[taskIndex], this.emptyTask);
        this.formData.tasks[taskIndex].steps = [];
        this.haveItemChanges = false;
        if (this.activeTaskNext !== null) {
          this.activeTask = this.activeTaskNext;
        }
        return;
      }
      for (var i = 0; i < this.audit.tasks.length; i++) {
        if (this.audit.tasks[i].id !== this.formData.tasks[taskIndex].id) {
          continue;
        }
        var task = this.formData.tasks[taskIndex];
        task.id = this.audit.tasks[i].id;
        task.name = this.audit.tasks[i].name;
        task.description = this.audit.tasks[i].description;
        task.description_file = '';
        task.description_file_url = this.audit.tasks[i].description_file;
        task.picture = '';
        task.picture_url = this.audit.tasks[i].picture;
        task.index = this.audit.tasks[i].index;
        task.weight = this.audit.tasks[i].weight;
        task.tags = this.audit.tasks[i].tags;
        task.tagsValue = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.audit.tasks[i].tagsValue));
        task.steps = [];
        for (var j = 0; j < this.audit.tasks[i].steps.length; j++) {
          this.addEmptyStep(task);
          task.steps[j].id = this.audit.tasks[i].steps[j].id;
          task.steps[j].description = this.audit.tasks[i].steps[j].description;
          task.steps[j].order = this.audit.tasks[i].steps[j].index;
          task.steps[j].picture = '';
          task.steps[j].picture_url = this.audit.tasks[i].steps[j].picture;
        }
      }
      this.haveItemChanges = false;
      if (this.activeTaskNext !== null) {
        this.activeTask = this.activeTaskNext;
      }
    },
    getCompany: function getCompany() {
      var _this6 = this;

      this.$http.get('audit-report/82/?period=days&previous=13', {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        return response.status;
      });

      var assignDefaultRoles = function assignDefaultRoles() {
        _this6.userRoles.push({
          name: 'Basic user',
          id: 'basic'
        });
        _this6.userRoles.push({
          name: 'Shift leader',
          id: 'shift_leader'
        });
        _this6.userRoles.push({
          name: 'Manager',
          id: 'manager'
        });
      };
      var id = null;
      if (this.authUser && this.authUser.company && this.authUser.company.id) {
        id = this.authUser.company.id;
      }
      if (this.$route.params.companyId) {
        id = this.$route.params.companyId;
      }
      if (!id) {
        assignDefaultRoles();
        return null;
      }
      return this.$http.get('companies/' + id + '/', {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          assignDefaultRoles();
          return response.status;
        }
        _this6.userRoles = [];
        _this6.userRoles.push({
          name: response.body.basic_role_display_name || 'Basic user',
          id: 'basic'
        });
        _this6.userRoles.push({
          name: response.body.shift_leader_role_display_name || 'Shift leader',
          id: 'shift_leader'
        });
        _this6.userRoles.push({
          name: response.body.manager_role_display_name || 'Manager',
          id: 'manager'
        });
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this6.onLogout();
        }
      });
    },
    sendUpdateAuditTasks: function sendUpdateAuditTasks(audit) {
      var _this7 = this;

      if (!audit.id) return null;
      var data = { tasks: [] };
      var index = 1;
      for (var i = 0; i < audit.tasks.length; i++) {
        if (audit.tasks[i].id) {
          data.tasks.push(audit.tasks[i].id);
          audit.tasks[i].index = index++;
        }
      }
      return this.$http.patch('audit-templates/' + audit.id + '/', data, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('audit err', response);
          return response.status;
        }
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this7.onLogout();
        }
        _this7.alertError.text = _this7.getErrorText(response);
        return response;
      });
    },
    sendSaveAuditTemplate: function sendSaveAuditTemplate(audit) {
      var self = this;
      var data = {
        name: audit.name,
        area: audit.area.length ? audit.area[0].id : null,
        role: audit.role,
        score_type: audit.score_type,
        min_task_score: audit.lowScore,
        max_task_score: audit.highScore,
        // picture: audit.picture,
        tasks: [],
        double_signature_required: audit.signatureCount === 2,
        signature_required: audit.signatureCount > 0
      };
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      var index = 1;
      for (var i = 0; i < audit.tasks.length; i++) {
        if (audit.tasks[i].id) {
          data.tasks.push(audit.tasks[i].id);
          audit.tasks[i].index = index++;
        }
      }
      if (!audit.id) {
        return this.$http.post('audit-templates/', data, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
        }).then(function (response) {
          if (response.status !== 201) {
            console.log('audit err', response);
            self.alertError.text = self.getErrorText(response);
            return response.status;
          }
          audit.id = response.body.id;
          return self.sendUpdateAuditPicture(audit);
        }).catch(function (response) {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
      }
      if (audit.picture_url && !audit.picture) delete data.picture;
      return this.$http.patch('audit-templates/' + audit.id + '/', data, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('audit err', response);
          self.alertError.text = self.getErrorText(response);
          return response.status;
        }
        return self.sendUpdateAuditPicture(audit);
      }).catch(function (response) {
        if (response.status === 401) {
          self.onLogout();
        }
        self.alertError.text = self.getErrorText(response);
        return response;
      });
    },
    sendSaveTask: function sendSaveTask(task) {
      var _this8 = this;

      var self = this;
      var data = {
        type: 'audit',
        name: task.name,
        description: task.description,
        description_file: task.description_file,
        picture: task.selectedContent === 'image' ? task.picture : '',
        video: task.selectedContent === 'video' && task.video_url ? task.video_url : '',
        video_thumbnail: task.selectedContent === 'video' && task.video_url ? task.video_thumbnail : '',
        weight: task.weight,
        index: task.index,
        // tags: task.tags,
        tags: ''
      };
      for (var i = 0; i < task.tagsValue.length; i++) {
        if (i !== 0) {
          data.tags = data.tags + ', ';
        }
        data.tags = '' + data.tags + task.tagsValue[i].name;
      }
      if (!data.weight && data.weight !== 0) {
        data.weight = 1;
      }
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      if (!task.id) {
        var _formData = new FormData();
        for (var key in data) {
          _formData.append(key, data[key]);
        }
        return this.$http.post('audit-task-templates/', _formData, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
        }).then(function (response) {
          if (response.status !== 201) {
            console.log('task err', response);
            self.alertError.text = self.getErrorText(response);
            console.log(self.alertError.text);
            return response.status;
          }
          task.id = response.body.id;
          if (data.picture) _this8.upload.uploaded++;
          if (data.description_file) _this8.upload.uploaded++;
          return response.status;
        }).catch(function (response) {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
      }
      if (task.picture_url && !task.picture) delete data.picture;
      if (task.description_file_url && !task.description_file) delete data.description_file;
      var formData = new FormData();
      for (var _key in data) {
        formData.append(_key, data[_key]);
      }
      return this.$http.patch('audit-task-templates/' + task.id + '/', formData, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('task err', response);
          self.alertError.text = self.getErrorText(response);
          console.log(self.alertError.text);
          return response.status;
        }
        if (data.picture) _this8.upload.uploaded++;
        if (data.description_file) _this8.upload.uploaded++;
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          self.onLogout();
        }
        self.alertError.text = self.getErrorText(response);
        return response;
      });
    },
    sendSaveStep: function sendSaveStep(step, taskId) {
      var _this9 = this;

      var data = {
        description: step.description,
        picture: step.selectedContent === 'image' ? step.picture : '',
        video: step.selectedContent === 'video' && step.video_url ? step.video_url : '',
        video_thumbnail: step.selectedContent === 'video' && step.video_url ? step.video_thumbnail : '',
        index: step.order,
        template: taskId
      };
      if (!step.id) {
        var _formData2 = new FormData();
        for (var key in data) {
          _formData2.append(key, data[key]);
        }
        return this.$http.post('task-steps/', _formData2, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
          // emulateJSON: true,
        }).then(function (response) {
          if (response.status !== 201) {
            console.log('task step err', response);
            self.alertError.text = self.getErrorText(response);
            return response.status;
          }
          step.id = response.body.id;
          if (data.picture) _this9.upload.uploaded++;
          return response.status;
        }).catch(function (response) {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
      }
      if (step.picture_url && !step.picture) delete data.picture;
      var formData = new FormData();
      for (var _key2 in data) {
        formData.append(_key2, data[_key2]);
      }
      return this.$http.patch('task-steps/' + step.id + '/', formData, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('task step err', response);
          self.alertError.text = self.getErrorText(response);
          return response.status;
        }
        if (data.picture) _this9.upload.uploaded++;
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          self.onLogout();
        }
        self.alertError.text = self.getErrorText(response);
        return response;
      });
    },
    deleteTaskSteps: function deleteTaskSteps(task) {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!task.stepsMustDelete.length) return resolve();
        var count = 0;
        for (var i = 0; i < task.stepsMustDelete.length; i++) {
          self.sendDeleteTaskStep(task.stepsMustDelete[i]).then(function (response) {
            if (response.status !== 200) {
              console.log('sendDeleteTaskStep has err', response);
              self.hasSaveError = true;
            }
            count++;
            if (count === task.stepsMustDelete.length) {
              task.stepsMustDelete = [];
              resolve();
            }
          });
        }
        return null;
      });
    },
    sendDeleteTaskStep: function sendDeleteTaskStep(stepId) {
      return this.$http.patch('task-steps/' + stepId + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('DELETE step err ', response);
          return response;
        }
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          self.onLogout();
        }
        self.alertError.text = self.getErrorText(response);
        return response;
      });
    },
    getTags: function getTags() {
      var _this10 = this;

      var url = 'tags/';
      if (this.$route.params.companyId) {
        url = url + '?company=' + this.$route.params.companyId;
      }
      this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return;
        }
        response.body.forEach(function (tagItem) {
          var tag = {
            name: tagItem.name,
            code: tagItem.name.substring(0, 2) + Math.floor(Math.random() * 10000000)
          };
          if (!_this10.tagsOptions.some(function (item) {
            return item.name === tag.name;
          })) {
            _this10.tagsOptions.push(tag);
          }
        });
      }).catch(function (response) {
        if (response.status === 401) {
          _this10.onLogout();
        }
      });
    },
    getAudit: function getAudit(id) {
      var _this11 = this;

      this.$http.get('audit-templates/' + id + '/', {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return;
        }
        _this11.is_performed = response.body.is_performed;
        _this11.audit = response.body;
        _this11.fillAllData();
        _this11.processLoading = false;

        // return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this11.onLogout();
        }
      });
    },
    getWorkingAreas: function getWorkingAreas() {
      var _this12 = this;

      var url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = url + '&company=' + this.$route.params.companyId;
      }
      this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return;
        }
        _this12.areas = response.body;
        // return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this12.onLogout();
        }
      });
    },
    getAreaById: function getAreaById(id) {
      var area = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.areas;

      for (var i = 0; i < area.length; i++) {
        if (area[i].id === id) {
          return area[i];
        }
        var res = this.getAreaById(id, area[i].subareas);
        if (res) {
          return res;
        }
      }
      return null;
    },
    downloadImage: function downloadImage(url) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, {
        headers: __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common,
        responseType: 'arraybuffer'
      }).then(function (resp) {
        if (resp.status !== 200) {
          return null;
        }
        return resp.data;
      }).catch(function (response) {
        console.log('download complite error', response);
        if (response.status === 401) {
          _this13.onLogout();
        }
        _this13.alertError.text = _this13.getErrorText(response);
        return null;
      });
    },
    fillAllData: function fillAllData() {
      if (!this.audit && !this.duplicate) return;
      this.formData.id = this.auditId;
      // Deprecated
      // if (this.duplicate) this.formData.id = 0;
      this.formData.name = this.audit.name;
      this.formData.role = this.audit.role;
      this.formData.area = this.audit.area && this.areas.length ? [this.getAreaById(this.audit.area)] : [];
      this.formData.picture_url = this.audit.picture;
      // Deprecated
      // if (this.duplicate) {
      //   if (this.formData.picture_url) {
      //     this.downloadImage(this.formData.picture_url)
      //     .then((resp) => {
      //       if (resp) {
      //         this.formData.picture = resp;
      //       }
      //     })
      //     .catch((resp) => {
      //       console.log('err', resp);
      //     });
      //   }
      // }
      if (this.audit.signature_required) {
        this.formData.signatureCount = this.audit.double_signature_required ? 2 : 1;
      } else {
        this.formData.signatureCount = 0;
      }
      this.formData.score_type = this.audit.score_type;
      this.formData.lowScore = this.audit.min_task_score;
      this.formData.highScore = this.audit.max_task_score;
      this.formData.tasks = [];
      for (var i = 0; i < this.audit.tasks.length; i++) {
        // Deprecated
        // if (this.duplicate) continue;
        this.addEmptyTask();
        var task = this.formData.tasks[i];
        task.id = this.audit.tasks[i].id;
        task.name = this.audit.tasks[i].name;
        task.description = this.audit.tasks[i].description;
        task.description_file_url = this.audit.tasks[i].description_file;
        task.weight = this.audit.tasks[i].weight;
        task.picture_url = this.audit.tasks[i].picture;
        task.picture_url = this.audit.tasks[i].picture;
        task.thumbnail_url = this.audit.tasks[i].video_thumbnail;
        task.video_url = this.audit.tasks[i].video;
        if (task.picture_url) {
          task.selectedContent = 'image';
        }
        if (task.video_url) {
          task.picture_url = '';
          task.selectedContent = 'video';
        }
        task.index = this.audit.tasks[i].index;
        if (!this.audit.tasks[i].tags) this.audit.tasks[i].tags = '';
        task.tags = this.audit.tasks[i].tags;
        var tags = task.tags.split(', ');
        for (var tagIndex = 0; tagIndex < tags.length; tagIndex++) {
          if (tags[tagIndex]) {
            this.addTag(task, tags[tagIndex]);
          }
        }
        this.audit.tasks[i].tagsValue = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(task.tagsValue));
        task.steps = [];
        for (var j = 0; j < this.audit.tasks[i].steps.length; j++) {
          this.addEmptyStep(task);
          task.steps[j].id = this.audit.tasks[i].steps[j].id;
          task.steps[j].description = this.audit.tasks[i].steps[j].description;
          task.steps[j].order = this.audit.tasks[i].steps[j].index;
          task.steps[j].picture_url = this.audit.tasks[i].steps[j].picture;
          task.steps[j].thumbnail_url = this.audit.tasks[i].steps[j].video_thumbnail;
          task.steps[j].video_url = this.audit.tasks[i].steps[j].video;
          if (task.steps[j].picture_url) {
            task.steps[j].selectedContent = 'image';
          }
          if (task.steps[j].video_url) {
            task.steps[j].picture_url = '';
            task.steps[j].selectedContent = 'video';
          }
        }
      }
      this.haveItemChanges = false;
    },
    validateSteps: function validateSteps(task) {
      for (var i = 0; i < task.steps.length; i++) {
        task.steps[i].valid = true;
      }
      for (var _i2 = 0; _i2 < task.steps.length; _i2++) {
        if (task.steps[_i2].order <= 0) {
          task.steps[_i2].valid = false;
        }
        var currentOrder = task.steps[_i2].order;
        for (var j = _i2 + 1; j < task.steps.length; j++) {
          if (+task.steps[j].order === currentOrder) {
            task.steps[_i2].valid = false;
            task.steps[j].valid = false;
          }
        }
      }
    },
    validateAudit: function validateAudit() {
      this.alertError.title = 'Error!';
      this.alertError.text = 'Missing needed data. All basic info fields and at least one audit question are mandatory.';
      this.needFill = true;
      if (!this.formData.name) {
        this.alertError.text = 'Please fill field "Title"';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.role) {
        this.alertError.text = 'Please select role';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.area.length) {
        this.alertError.text = 'Please select working area';
        this.alertError.visible = true;
        return false;
      }
      var tasksIsValid = true;
      for (var i = 0; i < this.formData.tasks.length; i++) {
        tasksIsValid = tasksIsValid && this.validateTask(this.formData.tasks[i]);
      }
      return tasksIsValid;
    },
    validateTask: function validateTask(task) {
      if (!task.name) {
        this.alertError.text = 'Please fill audit item title';
        return false;
      }
      // if (!task.description) {
      //   this.alertError.text = 'Please fill audit item description';
      //   return false;
      // }
      task.video_require = false;
      if (task.selectedContent === 'video' && (task.video_thumbnail || task.thumbnail_url) && !(task.video || task.video_url)) {
        task.video_require = true;
        this.alertError.text = 'Please add video file';
        this.alertError.visible = true;
        return false;
      }
      if (task.selectedContent === 'video' && !(task.video_thumbnail || task.thumbnail_url) && (task.video || task.video_url)) {
        task.video_require = true;
        this.alertError.text = 'Please add thumbnail image';
        this.alertError.visible = true;
        return false;
      }
      if (!task.description_file) {
        for (var i = 0; i < task.steps.length; i++) {
          // if (!task.steps[i].description) {
          //   this.alertError.text = 'Please fill audit item step description';
          //   return false;
          // }
          if (!task.steps[i].valid) {
            this.alertError.text = 'Please correct instructions for the audit question';
            return false;
          }
        }
      }
      for (var _i3 = 0; _i3 < task.steps.length; _i3++) {
        var step = task.steps[_i3];
        step.video_require = false;
        if (step.selectedContent === 'video' && (step.video_thumbnail || step.thumbnail_url) && !(step.video || step.video_url)) {
          step.video_require = true;
          this.alertError.text = 'Please add video file';
          this.alertError.visible = true;
          return false;
        }
        if (step.selectedContent === 'video' && !(step.video_thumbnail || step.thumbnail_url) && (step.video || step.video_url)) {
          step.video_require = true;
          this.alertError.text = 'Please add thumbnail image';
          this.alertError.visible = true;
          return false;
        }
      }
      return true;
    },
    onScoreChange: function onScoreChange(e) {
      console.log(e.target.name);
      if (e.target.name === 'lowScore') {
        if (!this.formData.lowScore && this.formData.lowScore !== 0 || this.formData.lowScore < 0) {
          this.formData.lowScore = 0;
        }
        if (this.formData.lowScore > 9) {
          this.formData.lowScore = 9;
        }
        if (this.formData.lowScore >= this.formData.highScore) {
          this.formData.lowScore = this.formData.highScore - 1;
        }
        return;
      }
      if (!this.formData.highScore || this.formData.highScore > 10) {
        this.formData.highScore = 10;
      }
      if (this.formData.highScore < 1) {
        this.formData.highScore = 1;
      }
      if (this.formData.lowScore >= this.formData.highScore) {
        this.formData.highScore = this.formData.lowScore + 1;
      }
    },
    handleDragStart: function handleDragStart(e, item, index) {
      e.target.style.opacity = '0.4';
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text', index.toString());
      this.dragSrcEl = index;
    },
    handleDragEnd: function handleDragEnd(e) {
      e.target.style.opacity = '';
    },
    handleDrop: function handleDrop(e, index) {
      console.log('handleDrop()', index);
      if (e.stopPropagation) {
        e.stopPropagation(); // Stops some browsers from redirecting.
      }
      // Don't do anything if dropping the same column we're dragging.
      if (this.dragSrcEl !== index) {
        this.dragSrcEl = index;
        index = e.dataTransfer.getData('text');
        if (index < this.dragSrcEl) {
          this.formData.tasks.splice(+this.dragSrcEl + 1, 0, this.formData.tasks[index]);
          this.formData.tasks.splice(index, 1);
        } else {
          this.formData.tasks.splice(+this.dragSrcEl, 0, this.formData.tasks[index]);
          this.formData.tasks.splice(+index + 1, 1);
        }
        if (this.activeTask === +this.dragSrcEl) {
          if (this.haveItemChanges) {
            this.activeTask = +index;
            this.$refs.leavingItemConfirm.show();
          }
        } else {
          this.activeTask = +this.dragSrcEl;
        }
      }
      return false;
    },
    handleDragOver: function handleDragOver(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
      // console.log('handleDragOver()', index);
    },
    getErrorText: function getErrorText(response) {
      console.log('getErrorText', response);
      var result = 'There were errors during the upload (' + response.status + ')';
      if (response.status === 400) {
        if (!response.body) {
          return 'Large file';
        }
        for (var key in response.body) {
          return key + ': ' + response.body[key];
        }
      }
      if (response.status === 401) {
        return 'Invalid authorization, please relogin';
      }
      if (response.status === 404) {
        return 'Not found (404)';
      }
      if (response.status === 500) {
        return 'Internal server error';
      }
      return result;
    },
    onChangeAuditTask: function onChangeAuditTask() {
      this.haveItemChanges = true;
    }
  },
  computed: {},
  created: function created() {
    // this.createUserRoles();
    this.getTags();
    this.getCompany();
    // this.addEmptyTask();
    this.getWorkingAreas();
    this.auditId = this.$route.params.auditId;
    if (this.auditId) {
      this.processLoading = true;
      this.getAudit(this.auditId);
    }
  },

  watch: {
    $route: function $route(to, from) {
      if (to.name === 'Audit Configuration Change' || to.name === 'Audit Configuration Change SuperUser') {
        this.processLoading = true;
        this.auditId = to.params.auditId;
        this.formData.id = to.params.auditId;
        this.getAudit(to.params.auditId);
      }
    },
    areas: function areas() {
      this.updateSuggestArea();
      if (this.audit) {
        this.formData.area = this.audit.area && this.areas.length ? [this.getAreaById(this.audit.area)] : [];
      }
    },
    activeTaskNext: function activeTaskNext(val, prev) {
      if (val === null || val === this.activeTask) return;
      if (this.haveItemChanges && val !== null) {
        this.$refs.leavingItemConfirm.show();
      } else {
        this.activeTask = val;
      }
    }
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_debounce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_debounce__);




var spinner = __webpack_require__(10).spinner;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'audits',
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_1__header___, spinner: spinner },
  props: ['onLogout', 'access_token', 'authUser'],
  mounted: function mounted() {},
  data: function data() {
    return {
      formData: {
        audits: [],
        auditsFields: {
          index: {
            label: '#',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          id: {
            label: 'ID',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          name: {
            label: 'Text',
            tdClass: 'text-left',
            thClass: 'text-center'
          },
          area: {
            label: 'Working area',
            tdClass: 'text-left',
            thClass: 'text-center'
          },
          permission: {
            label: 'Permission',
            // tdClass: 'text-left',
            thClass: 'text-center'
          }
        }
      },
      currentPage: 1,
      perPage: 10,
      areas: [],
      filter: '',
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Audits',
        active: true
      }],
      processLoading: true
    };
  },

  methods: {
    isInFilter: function isInFilter(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item).toLowerCase().indexOf(this.filter.toLowerCase()) + 1;
    },
    getAddAuditUrl: function getAddAuditUrl() {
      return "" + '/constructor/AuditConstructor';
    },
    onRowClick: function onRowClick(item) {
      this.$router.push({ name: 'Audit Configuration Change', params: { auditId: item.id } });
    },
    getAuditsTemplatesList: function getAuditsTemplatesList() {
      var _this = this;

      var url = 'audit-templates/';
      if (this.$route.params.companyId) {
        url = url + '?company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        _this.formData.audits = response.body;
        _this.processLoading = false;
        return response.body;
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
      });
    },
    getWorkingAreas: function getWorkingAreas() {
      var _this2 = this;

      var url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = url + '&company=' + this.$route.params.companyId;
      }
      this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        _this2.areas = response.body;
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this2.onLogout();
        }
      });
    },
    getWorkingAreasListById: function getWorkingAreasListById(id, areas) {
      var result = [];
      for (var i = 0; i < areas.length; i++) {
        if (areas[i].id == id) {
          return result = [areas[i]];
        }
        result = this.getWorkingAreasListById(id, areas[i].subareas);
        if (result.length) {
          result.unshift(areas[i]);
          return result;
        }
      }
      return result;
    }
  },
  computed: {},
  created: function created() {
    var self = this;
    this.getAuditsTemplatesList();
    this.getWorkingAreas();
  },

  directives: {
    debounce: __WEBPACK_IMPORTED_MODULE_2_v_debounce___default.a
  }
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* eslint-disable prefer-arrow-callback */

/*! Copyright (c) 2016 Naufal Rabbani (http://github.com/BosNaufal)
 * Licensed Under MIT (http://opensource.org/licenses/MIT)
 *
 * Vue 2 Autocomplete @ Version 0.0.1
 *
 */

var debounce = function debounce(callback, delay) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var timeout = void 0;
  return function () {
    var context = this;
    //      const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      callback.apply(context, args);
    }, delay);
  };
};
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    id: String,
    className: String,
    placeholder: String,
    // Intial Value
    initValue: {
      type: String,
      default: ''
    },
    // Anchor of list
    anchor: {
      type: String,
      required: true
    },
    // Label of list
    label: String,
    // Debounce time
    debounce: Number,
    // ajax URL will be fetched
    url: {
      type: String
      //        required: true,
    },
    // query param
    param: {
      type: String,
      default: 'q'
    },
    // Custom Params
    customParams: Object,
    // minimum length
    min: {
      type: Number,
      default: 0
    },
    suggest: Array,
    // Process the result before retrieveng the result array.
    process: Function,
    // Callback
    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    additionalData: Object
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: ''
    };
  },

  methods: {
    // Netralize Autocomplete
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },

    // Get the original data
    cleanUp: function cleanUp(data) {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    },
    input: function input(val) {
      this.showList = val.length > 1;
      // Callback Event
      if (this.onInput) {
        this.onInput(val);
      }
      // Debounce the "getData" method.
      if (!this.debouncedGetData || this.debounce !== this.oldDebounce) {
        this.oldDebounce = this.debounce;
        this.debouncedGetData = this.debounce ? debounce(this.getData.bind(this), this.debounce) : this.getData;
      }
      // Get The Data
      this.debouncedGetData(val);
    },
    showAll: function showAll() {
      this.json = this.suggest;
      //        this.json = [];
      //        this.getData('');
      // Callback Event
      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    hideAll: function hideAll(e) {
      var _this = this;

      // Callback Event
      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        // Callback Event
        if (_this.onHide) {
          _this.onHide();
        }
        _this.showList = false;
      }, 250);
    },
    focus: function focus(e) {
      this.focusList = 0;
      // Callback Event
      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    keydown: function keydown(e) {
      var key = e.keyCode;
      // Disable when list isn't showing up
      if (!this.showList) return;
      switch (key) {
        case 40:
          // down
          this.focusList += 1;
          break;
        case 38:
          // up
          this.focusList -= 1;
          break;
        case 13:
          // enter
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          this.clearInput();
          break;
        case 27:
          // esc
          this.showList = false;
          this.clearInput();
          break;
        default:
          break;
      }
      // When cursor out of range
      var listLength = this.json.length - 1;
      var tmp = this.focusList < 0 ? listLength : this.focusList;
      this.focusList = this.focusList > listLength ? 0 : tmp;
    },
    activeClass: function activeClass(i) {
      return {
        'focus-list': i === this.focusList
      };
    },
    selectList: function selectList(data) {
      var clean = this.cleanUp(data);
      // Put the selected data to type (model)
      this.type = clean[this.anchor];
      this.showList = false;

      /**
       * Callback Event
       * Deep clone of the original object
       */
      if (this.onSelect) {
        this.onSelect(clean, data, this.additionalData);
      }
      this.clearInput();
    },
    getData: function getData(val) {
      var self = this;
      this.json = this.suggest.filter(function (item) {
        return item[self.anchor].toLowerCase().indexOf(val.toLowerCase()) + 1;
        // return true;
      });
    },

    //      getData(val) {
    //        const self = this;
    //        if (val.length < this.min) return;
    //        if (this.url != null) {
    //          // Callback Event
    //          if (this.onBeforeAjax) {
    //            this.onBeforeAjax(val);
    //          }
    //          const ajax = new XMLHttpRequest();
    //          let params = '';
    //          if (this.customParams) {
    //            Object.keys(this.customParams).forEach((key) => {
    //              params += `&${key}=${this.customParams[key]}`;
    //            });
    //          }
    //          ajax.open('GET', `${this.url}?${this.param}=${val}${params}`, true);
    //          ajax.send();
    //          ajax.addEventListener('progress', function (data) {
    //            if (data.lengthComputable) {
    //              // Callback Event
    //              if (this.onAjaxProgress) {
    //                this.onAjaxProgress(data);
    //              }
    //            }
    //          });
    //          ajax.addEventListener('loadend', function () {
    //            const json = JSON.parse(this.responseText);
    //            // Callback Event
    //            if (this.onAjaxLoaded) {
    //              this.onAjaxLoaded(json);
    //            }
    //            self.json = self.process ? self.process(json) : json;
    //          });
    //        }
    //      },
    setValue: function setValue(val) {
      this.type = val;
    }
  },
  created: function created() {
    // Sync parent model with initValue Props
    this.type = this.initValue ? this.initValue : null;
  }
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__header___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__autocomplete_vue_autocomplete_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__autocomplete_vue_autocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__autocomplete_vue_autocomplete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__areaCheckbox___ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__areaCheckbox____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__areaCheckbox___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__thumbnail__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__thumbnail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__thumbnail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__uploading__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__uploading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__uploading__);










var alert = __webpack_require__(10).alert;
var spinner = __webpack_require__(10).spinner;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'checklist-config',
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_4__header___, Autocomplete: __WEBPACK_IMPORTED_MODULE_5__autocomplete_vue_autocomplete_vue___default.a, AreaCheckbox: __WEBPACK_IMPORTED_MODULE_6__areaCheckbox____default.a, alert: alert, spinner: spinner, Thumbnail: __WEBPACK_IMPORTED_MODULE_7__thumbnail___default.a, Uploading: __WEBPACK_IMPORTED_MODULE_8__uploading___default.a },
  props: ['onLogout', 'access_token', 'authUser', 'duplicate'],
  mounted: function mounted() {},
  data: function data() {
    return {
      formData: {
        id: null,
        name: '',
        picture: '',
        picture_url: '',
        role: 'basic',
        area: [],
        double_signature_required: false,
        tasks: []
      },
      activeTask: null,
      activeTaskNext: null,
      showTasks: true,
      emptyTask: {
        id: null,
        name: '',
        description: '',
        selectedContent: '',
        picture: '',
        picture_url: '',
        video: '',
        video_url: '',
        video_thumbnail: '',
        thumbnail_url: null,
        video_require: false,
        description_file: '',
        description_file_url: '',
        steps: [],
        stepsMustDelete: [],
        index: 0
      },
      emptyStep: {
        id: null,
        order: 1,
        description: '',
        valid: true,
        picture_urlChanged: false,
        selectedContent: '',
        picture: '',
        picture_url: '',
        video: '',
        video_url: '',
        video_thumbnail: '',
        thumbnail_url: null,
        video_require: false
      },
      suggestArea: [],
      userRoles: [],
      areas: [],
      checklist: null,
      checklistId: null,
      processLoading: false,
      areaFromList: false,
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Checklists',
        to: "" + '/constructor/Checklists'
      }, {
        text: 'Constructor',
        active: true
      }],
      haveItemChanges: false,
      needFill: false,
      hasSaveError: false,
      alertError: {
        text: 'Some fields are not filled',
        title: 'Error!',
        visible: false
      },
      alertSuccess: {
        text: 'Saved successfully',
        title: 'Well Done!',
        visible: false
      },
      upload: {
        total: 1,
        uploaded: 0,
        image: true,
        visible: false
      },
      dragSrcEl: null
    };
  },

  methods: {
    handleVideoFileChange: function handleVideoFileChange(e) {
      if (e.target.files && e.target.files[0] && e.target.files[0].size > 50000000) {
        e.target.value = '';
        this.alertError.text = 'Maximum allowed video size is 50 MB.';
        this.alertError.visible = true;
        return;
      }
    },
    addEmptyStep: function addEmptyStep(task) {
      var maxStepOrder = 0;
      var self = this;
      var orders = [];
      var orderCount = 1;
      for (var i = 0; i < task.steps.length; i++) {
        orders.push(+task.steps[i].order);
        if (maxStepOrder < task.steps[i].order) {
          maxStepOrder = task.steps[i].order;
        }
      }
      for (var _i = 1; _i <= +maxStepOrder + 1; _i++) {
        if (orders.indexOf(_i) === -1) {
          orderCount = _i;
          break;
        }
      }
      task.steps.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.emptyStep)));
      task.steps[task.steps.length - 1].order = orderCount;
    },
    addEmptyTask: function addEmptyTask() {
      this.formData.tasks.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.emptyTask)));
      // this.addEmptyStep(this.formData.tasks[this.formData.tasks.length - 1]);
      console.log('add task', this.formData.tasks);
      if (this.activeTask === null) {
        this.activeTask = 0;
      }
    },
    removeStep: function removeStep(task, index) {
      if (task.steps[index].id) {
        task.stepsMustDelete.push(task.steps[index].id);
      }
      task.steps.splice(index, 1);
    },
    processJSON: function processJSON(json) {
      return json.results;
    },
    getDataSearchArea: function getDataSearchArea(data, area) {
      this.formData.area = [area.area];
    },
    getUserAreaPath: function getUserAreaPath(area) {
      var result = [];
      for (var i = 0; i < area.length; i++) {
        var res = this.getUserAreaPath(area[i].subareas);
        for (var j = 0; j < res.length; j++) {
          result.push({ name: area[i].name + '/' + res[j].name, area: res[j].area });
        }
        if (res.length === 0) {
          result.push({ name: area[i].name, area: area[i] });
        }
      }
      return result;
    },
    updateSuggestArea: function updateSuggestArea() {
      this.suggestArea = [];
      var areaPaths = this.getUserAreaPath(this.areas);
      for (var i = 0; i < areaPaths.length; i++) {
        this.suggestArea.push(areaPaths[i]);
      }
    },
    clearChecklistItemVideo: function clearChecklistItemVideo(e, step, index) {
      if (step.video_url) {
        step.video_url = '';
        this.$refs.checklistItemVideoFile[index].reset();
        e.preventDefault();
        return;
      }
      if (!step.video) {
        return;
      }
      this.$refs.checklistItemVideoFile[index].reset();
      e.preventDefault();
    },
    clearStepVideo: function clearStepVideo(e, step, index) {
      if (step.video_url) {
        step.video_url = '';
        this.$refs.stepvideofile[index].reset();
        e.preventDefault();
        return;
      }
      if (!step.video) {
        return;
      }
      this.$refs.stepvideofile[index].reset();
      e.preventDefault();
    },
    clearPdfFile: function clearPdfFile(e, index) {
      if (this.formData.tasks[index].description_file_url) {
        this.formData.tasks[index].description_file_url = '';
        this.$refs['pdffile' + index][0].reset();
        e.preventDefault();
        return;
      }
      if (!this.formData.tasks[index].description_file) {
        return;
      }
      this.$refs['pdffile' + index][0].reset();
      e.preventDefault();
    },
    changePdfFile: function changePdfFile(e, index) {
      if (!this.formData.tasks[index].description_file) {
        return null;
      }
      if (this.formData.tasks[index].description_file && this.formData.tasks[index].description_file.size > 5000000) {
        this.$refs['pdffile' + index][0].reset();
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
      }
      return null;
    },
    calculateImagesCount: function calculateImagesCount() {
      var result = 0;
      if (this.formData.picture) {
        console.log('this.formData.picture');
        result++;
      }
      for (var i = 0; i < this.formData.tasks.length; i++) {
        if (this.formData.tasks[i].picture) result++;
        if (this.formData.tasks[i].description_file) result++;
        result += this.formData.tasks[i].steps.filter(function (item) {
          return item.picture;
        }).length;
      }
      console.log('calculateImagesCount', result);
      return result;
    },
    uploadVideo: function uploadVideo(data) {
      var _this = this;

      var uploadData = {
        filename: data.name
      };
      if (this.$route.params.companyId) {
        uploadData.company = this.$route.params.companyId;
      }
      return this.$http.post('upload/', uploadData, {
        method: 'POST',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          _this.alertError.text = _this.getErrorText(response);
          return response.status;
        }
        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(response.body.upload_url, data, {
          method: 'PUT',
          headers: __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common
          // {
          //   'content-type': 'video/mp4',
          // },
          // emulateJSON: true,
        }).then(function (resp) {
          if (response.status !== 200) {
            _this.alertError.text = _this.getErrorText(resp);
            return resp.status;
          }
          return response.body.final_url;
        }).catch(function (response) {
          if (response.status === 401) {
            _this.onLogout();
          }
          _this.alertError.text = _this.getErrorText(response);
          return response;
        });
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
        _this.alertError.text = _this.getErrorText(response);
        return response;
      });
    },
    saveChecklistItemVideo: function saveChecklistItemVideo(item) {
      if (!item.video || item.selectedContent !== 'video') {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          resolve(false);
        });
      }
      return this.uploadVideo(item.video).then(function (urlVideo) {
        console.log('uploadUrlVideo', urlVideo);
        item.video_url = urlVideo;
        return null;
      });
    },

    // duplicateChecklist() {
    //   this.$router.push({ name: this.$route.name.replace('Change', 'Duplicate') });
    //   location.reload();
    //   // this.$router.go(this.$router.currentRoute);
    // },
    duplicateChecklist: function duplicateChecklist() {
      var _this2 = this;

      return this.$http.post('checklist-templates/' + this.checklistId + '/duplicate/', {}, {
        method: 'POST',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('checklist duplication err', response);
          _this2.alertError.text = _this2.getErrorText(response);
          return response.status;
        }
        console.log('DUPLICATE RESPONSE', response);
        _this2.$router.push({ name: 'Checklist Configuration Change',
          params: { checklistId: response.body.id } });
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this2.onLogout();
        }
        _this2.alertError.text = _this2.getErrorText(response);
        return response;
      });
    },
    saveChecklist: function saveChecklist() {
      var _this3 = this;

      var self = this;
      if (!this.validateChecklist()) {
        this.alertError.visible = true;
        return;
      }
      this.hasSaveError = false;
      // return;
      this.upload.total = this.calculateImagesCount();
      this.upload.uploaded = 0;
      this.upload.image = this.upload.total !== 0;
      this.upload.visible = true;
      this.sendSaveChecklistTemplate(self.formData).then(function (response) {
        if (response !== 200 && response !== 201) {
          self.hasSaveError = true;
          console.log('sendSaveChecklistTemplate err', response);
        } else _this3.needFill = false;
        if (self.duplicate) {
          setTimeout(function () {
            _this3.$router.push({
              name: _this3.$route.name.replace('Duplicate', 'Change'),
              params: {
                companyId: _this3.$route.params.companyId,
                checklistId: _this3.formData.id
              }
            });
          }, 3000);
        }
      }).then(function () {
        return self.saveTasks(self.formData.tasks);
      }).then(function () {
        self.haveItemChanges = false;
        if (self.formData.tasks.length) {
          self.deleteTaskSteps(self.formData.tasks[self.activeTask]);
        }
      }).then(function () {
        if (self.hasSaveError) {
          console.log('saveEnd save has errors');
          self.alertError.text = 'There were errors during the upload';
          self.alertError.visible = true;
          _this3.upload.visible = false;
        } else {
          console.log('saveEnd success');
          self.alertSuccess.visible = true;
          _this3.upload.visible = false;
          setTimeout(function () {
            self.$router.push({ name: 'Checklists' });
          }, 3000);
        }
      }).catch(function (response) {
        console.log('ERRR have catch', response);
        self.alertError.text = 'There were errors during the upload';
        self.alertError.visible = true;
        _this3.upload.visible = false;
      });
    },
    deleteChecklist: function deleteChecklist() {
      var self = this;
      if (this.formData.id) {
        this.sendDeleteChecklist(this.formData.id).then(function () {
          self.alertSuccess.text = 'Checklist successfully deleted';
          self.alertSuccess.title = 'Well done!';
          self.alertSuccess.visible = true;
          setTimeout(function () {
            self.$router.push({ name: 'Checklists' });
          }, 3000);
        });
      }
    },
    sendDeleteChecklist: function sendDeleteChecklist(id) {
      var _this4 = this;

      return this.$http.patch('checklist-templates/' + id + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('checklist del err', response);
          return response.status;
        }
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this4.onLogout();
        }
        if (response.status === 401) {
          _this4.onLogout();
        }
        _this4.alertError.text = _this4.getErrorText(response);
        return response;
      });
    },
    deleteTask: function deleteTask(task, index) {
      if (task.id) {
        this.sendDeleteTask(task);
      }
      this.formData.tasks.splice(index, 1);
      this.haveItemChanges = false;
    },
    sendDeleteTask: function sendDeleteTask(task) {
      return this.$http.patch('task-templates/' + task.id + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('task del err', response);
          return response.status;
        }
        return response.status;
      }).catch(function (response) {
        self.alertError.text = self.getErrorText(response);
        return response;
      });
    },
    saveTasks: function saveTasks(tasks) {
      var count = 0;
      var self = this;
      function saveTask(task, resolve) {
        self.saveChecklistItemVideo(task).then(function () {
          return self.sendSaveTask(task);
        }).then(function (response) {
          if (response !== 201 && response !== 200) {
            console.log('sendSavetasks has err', response);
            self.hasSaveError = true;
          } else {
            return self.saveTaskSteps(task.steps, task.id);
          }
          return null;
        }).then(function () {
          count++;
          if (count === tasks.length) {
            self.sendUpdateChecklistTasks(self.formData);
            resolve();
          }
        }).catch(function () {
          self.hasSaveError = true;
          count++;
          if (count === tasks.length) {
            self.sendUpdateChecklistTasks(self.formData);
            resolve();
          }
        });
      }
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!tasks.length) resolve();
        for (var i = 0; i < tasks.length; i++) {
          saveTask(tasks[i], resolve);
        }
      });
    },
    saveTask: function saveTask(task) {
      var _this5 = this;

      var self = this;
      this.alertError.text = '';
      if (!this.validateTask(task)) {
        this.alertError.visible = true;
        if (!this.alertError.text) {
          this.alertError.text = 'Missing needed data. All basic info fields and at least one checklist item are mandatory.';
        }
        this.activeTaskNext = null;
        return;
      }
      self.hasSaveError = false;
      this.upload.total = task.steps.filter(function (item) {
        return item.picture;
      }).length;
      this.upload.total += task.description_file ? 1 : 0;
      this.upload.uploaded = 0;
      this.upload.image = this.upload.total !== 0;
      this.upload.visible = true;
      self.saveChecklistItemVideo(task).then(function () {
        return self.sendSaveTask(task);
      }).then(function (response) {
        if (response !== 200 && response !== 201) {
          self.hasSaveError = true;
          console.log('saveTask err', response);
        } else {
          return self.saveTaskSteps(task.steps, task.id);
        }
        return null;
      }).then(function () {
        return self.deleteTaskSteps(task);
      }).then(function () {
        if (self.hasSaveError) return null;
        return _this5.sendUpdateChecklistTasks(self.formData);
      }).then(function () {
        if (self.hasSaveError) {
          console.log('saveEnd save has errors');
          self.alertError.text = 'There were errors during the upload';
          self.alertError.visible = true;
          self.upload.visible = false;
          _this5.activeTaskNext = null;
        } else {
          console.log('saveEnd success');
          self.alertSuccess.visible = true;
          self.upload.visible = false;
          self.haveItemChanges = false;
          if (_this5.activeTaskNext !== null) {
            _this5.activeTask = _this5.activeTaskNext;
          }
        }
      }).catch(function (response) {
        console.log('ERRR have catch', response);
        self.alertError.text = 'There were errors during the upload';
        self.alertError.visible = true;
        self.upload.visible = false;
        _this5.activeTaskNext = null;
      });
    },
    saveTaskSteps: function saveTaskSteps(steps, taskId) {
      var self = this;
      if (!steps.length) {
        return null;
      }
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var count = 0;

        var _loop = function _loop(i) {
          self.saveChecklistItemVideo(steps[i]).then(function () {
            return self.sendSaveStep(steps[i], taskId);
          }).then(function (response) {
            if (response !== 201 && response !== 200) {
              console.log('sendSaveStep has err', response);
              self.hasSaveError = true;
            }
            count++;
            if (count === steps.length) {
              resolve();
            }
          }).catch(function (response) {
            self.alertError.text = self.getErrorText(response);
            return response;
          });
        };

        for (var i = 0; i < steps.length; i++) {
          _loop(i);
        }
      });
    },
    sendUpdateChecklistPicture: function sendUpdateChecklistPicture(checklist) {
      var _this6 = this;

      if (checklist.id) {
        if (!checklist.picture && checklist.picture_url) {
          return 200;
        }
        var formData = new FormData();
        formData.append('picture', checklist.picture);
        // Deprecated
        // if (this.duplicate) {
        //   if (checklist.picture) {
        //     let blob = new Blob([checklist.picture], { type: 'image/jpeg' });
        //     // let fileOfBlob = new File([blob], 'photo.jpg', { type: 'image/jpeg' });
        //     // form.append("upload", fileOfBlob);
        //     // formData.append('picture', fileOfBlob);
        //     formData.append('picture', blob, 'photo.jpg');
        //   }
        // } else {
        //   formData.append('picture', checklist.picture);
        // }
        return this.$http.patch('checklist-templates/' + checklist.id + '/', formData, {
          method: 'PATCH',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
        }).then(function (response) {
          if (response.status !== 200) {
            console.log('checklist err', response);
            return response.status;
          }
          if (checklist.picture) _this6.upload.uploaded++;
          return response.status;
        }).catch(function (response) {
          if (response.status === 401) {
            _this6.onLogout();
          }
          _this6.alertError.text = _this6.getErrorText(response);
          return response;
        });
      }
      return null;
    },
    discardTaskChanges: function discardTaskChanges(taskIndex) {
      if (!this.formData.tasks[taskIndex].id) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.formData.tasks[taskIndex], this.emptyTask);
        this.formData.tasks[taskIndex].steps = [];
        this.haveItemChanges = false;
        if (this.activeTaskNext !== null) {
          this.activeTask = this.activeTaskNext;
        }
        return;
      }
      for (var i = 0; i < this.checklist.tasks.length; i++) {
        if (this.checklist.tasks[i].id !== this.formData.tasks[taskIndex].id) {
          continue;
        }
        var task = this.formData.tasks[taskIndex];
        task.id = this.checklist.tasks[i].id;
        task.name = this.checklist.tasks[i].name;
        task.description = this.checklist.tasks[i].description;
        task.description_file = '';
        task.description_file_url = this.checklist.tasks[i].description_file;
        task.picture = '';
        task.picture_url = this.checklist.tasks[i].picture;
        task.index = this.checklist.tasks[i].index;
        task.steps = [];
        for (var j = 0; j < this.checklist.tasks[i].steps.length; j++) {
          this.addEmptyStep(task);
          task.steps[j].id = this.checklist.tasks[i].steps[j].id;
          task.steps[j].description = this.checklist.tasks[i].steps[j].description;
          task.steps[j].order = this.checklist.tasks[i].steps[j].index;
          task.steps[j].picture = '';
          task.steps[j].picture_url = this.checklist.tasks[i].steps[j].picture;
        }
      }
      this.haveItemChanges = false;
      if (this.activeTaskNext !== null) {
        this.activeTask = this.activeTaskNext;
      }
    },
    getCompany: function getCompany() {
      var _this7 = this;

      function assignDefaultRoles() {
        this.userRoles.push({
          name: 'Basic user',
          id: 'basic'
        });
        this.userRoles.push({
          name: 'Shift leader',
          id: 'shift_leader'
        });
        this.userRoles.push({
          name: 'Manager',
          id: 'manager'
        });
      }
      var id = null;
      if (this.authUser && this.authUser.company && this.authUser.company.id) {
        id = this.authUser.company.id;
      }
      if (this.$route.params.companyId) {
        id = this.$route.params.companyId;
      }
      if (!id) {
        assignDefaultRoles();
        return null;
      }
      return this.$http.get('companies/' + id + '/', {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          assignDefaultRoles();
          return response.status;
        }
        _this7.userRoles = [];
        console.log('response body companies', response.body);
        _this7.userRoles.push({
          name: response.body.basic_role_display_name || 'Basic user',
          id: 'basic'
        });
        _this7.userRoles.push({
          name: response.body.shift_leader_role_display_name || 'Shift leader',
          id: 'shift_leader'
        });
        _this7.userRoles.push({
          name: response.body.manager_role_display_name || 'Manager',
          id: 'manager'
        });
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this7.onLogout();
        }
      });;
    },
    sendUpdateChecklistTasks: function sendUpdateChecklistTasks(checklist) {
      var _this8 = this;

      if (!checklist.id) return null;
      var data = { tasks: [] };
      var index = 1;
      for (var i = 0; i < checklist.tasks.length; i++) {
        if (checklist.tasks[i].id) {
          data.tasks.push(checklist.tasks[i].id);
          checklist.tasks[i].index = index++;
        }
      }
      return this.$http.patch('checklist-templates/' + checklist.id + '/', data, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('checklist err', response);
          return response.status;
        }
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this8.onLogout();
        }
        self.alertError.text = self.getErrorText(response);
        return response;
      });
    },
    sendSaveChecklistTemplate: function sendSaveChecklistTemplate(checklist) {
      var self = this;
      var data = {
        name: checklist.name,
        area: checklist.area.length ? checklist.area[0].id : null,
        double_signature_required: checklist.double_signature_required,
        role: checklist.role,
        // picture: checklist.picture,
        tasks: []
      };
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      var index = 1;
      for (var i = 0; i < checklist.tasks.length; i++) {
        if (checklist.tasks[i].id) {
          data.tasks.push(checklist.tasks[i].id);
          checklist.tasks[i].index = index++;
        }
      }
      if (!checklist.id) {
        return this.$http.post('checklist-templates/', data, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
        }).then(function (response) {
          if (response.status !== 201) {
            console.log('checklist err', response);
            return response.status;
          }
          checklist.id = response.body.id;
          return self.sendUpdateChecklistPicture(checklist);
        }).catch(function (response) {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
      }
      if (checklist.picture_url && !checklist.picture) delete data.picture;
      return this.$http.patch('checklist-templates/' + checklist.id + '/', data, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('checklist err', response);
          return response.status;
        }
        return self.sendUpdateChecklistPicture(checklist);
      }).catch(function (response) {
        if (response.status === 401) {
          self.onLogout();
        }
        self.alertError.text = self.getErrorText(response);
        return response;
      });
    },
    sendSaveTask: function sendSaveTask(task) {
      var _this9 = this;

      var data = {
        type: 'checklist',
        name: task.name,
        description: task.description,
        description_file: task.description_file,
        picture: task.selectedContent === 'image' ? task.picture : '',
        video: task.selectedContent === 'video' && task.video_url ? task.video_url : '',
        video_thumbnail: task.selectedContent === 'video' && task.video_url ? task.video_thumbnail : '',
        index: task.index
      };
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      if (!task.id) {
        var _formData = new FormData();
        for (var key in data) {
          _formData.append(key, data[key]);
        }
        return this.$http.post('task-templates/', _formData, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
        }).then(function (response) {
          if (response.status !== 201) {
            console.log('task err', response);
            return response.status;
          }
          task.id = response.body.id;
          if (data.picture) _this9.upload.uploaded++;
          return response.status;
        }).catch(function (response) {
          if (response.status === 401) {
            _this9.onLogout();
          }
          _this9.alertError.text = _this9.getErrorText(response);
          return response;
        });
      }
      if (task.picture_url && !task.picture) delete data.picture;
      if (task.description_file_url && !task.description_file) delete data.description_file;
      var formData = new FormData();
      for (var _key in data) {
        formData.append(_key, data[_key]);
      }
      return this.$http.patch('task-templates/' + task.id + '/', formData, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('task err', response);
          return response.status;
        }
        if (data.picture) _this9.upload.uploaded++;
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this9.onLogout();
        }
        _this9.alertError.text = _this9.getErrorText(response);
        return response;
      });
    },
    sendSaveStep: function sendSaveStep(step, taskId) {
      var _this10 = this;

      var data = {
        description: step.description,
        picture: step.selectedContent === 'image' ? step.picture : '',
        video: step.selectedContent === 'video' && step.video_url ? step.video_url : '',
        video_thumbnail: step.selectedContent === 'video' && step.video_url ? step.video_thumbnail : '',
        index: step.order,
        template: taskId
      };
      if (!step.id) {
        var _formData2 = new FormData();
        for (var key in data) {
          _formData2.append(key, data[key]);
        }
        return this.$http.post('task-steps/', _formData2, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
          // emulateJSON: true,
        }).then(function (response) {
          if (response.status !== 201) {
            console.log('task step err', response);
            return response.status;
          }
          step.id = response.body.id;
          if (data.picture) _this10.upload.uploaded++;
          return response.status;
        }).catch(function (response) {
          if (response.status === 401) {
            _this10.onLogout();
          }
          _this10.alertError.text = _this10.getErrorText(response);
          return response;
        });
      }
      if (step.picture_url && !step.picture) delete data.picture;
      var formData = new FormData();
      for (var _key2 in data) {
        formData.append(_key2, data[_key2]);
      }
      return this.$http.patch('task-steps/' + step.id + '/', formData, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('task step err', response);
          return response.status;
        }
        if (data.picture) _this10.upload.uploaded++;
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this10.onLogout();
        }
        _this10.alertError.text = _this10.getErrorText(response);
        return response;
      });
    },
    deleteTaskSteps: function deleteTaskSteps(task) {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!task.stepsMustDelete.length) return resolve();
        var count = 0;
        for (var i = 0; i < task.stepsMustDelete.length; i++) {
          self.sendDeleteTaskStep(task.stepsMustDelete[i]).then(function (response) {
            if (response.status !== 200) {
              console.log('sendDeleteTaskStep has err', response);
              self.hasSaveError = true;
            }
            count++;
            if (count === task.stepsMustDelete.length) {
              task.stepsMustDelete = [];
              resolve();
            }
          });
        }
        return null;
      });
    },
    sendDeleteTaskStep: function sendDeleteTaskStep(stepId) {
      var _this11 = this;

      return this.$http.patch('task-steps/' + stepId + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('DELETE step err ', response);
          return response;
        }
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this11.onLogout();
        }
        _this11.alertError.text = _this11.getErrorText(response);
        return response;
      });
    },
    getChecklist: function getChecklist(id) {
      var _this12 = this;

      this.$http.get('checklist-templates/' + id + '/', {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return;
        }
        _this12.checklist = response.body;
        _this12.fillAllData();
        _this12.processLoading = false;

        // return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this12.onLogout();
        }
      });
    },
    getWorkingAreas: function getWorkingAreas() {
      var _this13 = this;

      var url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = url + '&company=' + this.$route.params.companyId;
      }
      this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return;
        }
        _this13.areas = response.body;
        // return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this13.onLogout();
        }
      });
    },
    getAreaById: function getAreaById(id) {
      var area = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.areas;

      for (var i = 0; i < area.length; i++) {
        if (area[i].id === id) {
          return area[i];
        }
        var res = this.getAreaById(id, area[i].subareas);
        if (res) {
          return res;
        }
      }
      return null;
    },
    downloadImage: function downloadImage(url) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, {
        headers: __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common,
        responseType: 'arraybuffer'
      }).then(function (resp) {
        if (resp.status !== 200) {
          return null;
        }
        return resp.data;
      }).catch(function (response) {
        console.log('download complite error', response);
        if (response.status === 401) {
          _this14.onLogout();
        }
        _this14.alertError.text = _this14.getErrorText(response);
        return null;
      });
    },
    fillAllData: function fillAllData() {
      if (!this.checklist) return;
      this.formData.id = this.checklistId;
      // Deprecated
      // if (this.duplicate) this.formData.id = 0;
      this.formData.name = this.checklist.name;
      this.formData.role = this.checklist.role;
      this.formData.area = this.checklist.area && this.areas.length ? [this.getAreaById(this.checklist.area)] : [];
      this.formData.double_signature_required = this.checklist.double_signature_required;
      this.formData.picture_url = this.checklist.picture;
      // Depecated
      // if (this.duplicate) {
      //   if (this.formData.picture_url) {
      //     this.downloadImage(this.formData.picture_url)
      //     .then((resp) => {
      //       if (resp) {
      //         this.formData.picture = resp;
      //       }
      //     })
      //     .catch((resp) => {
      //       console.log('err', resp);
      //     });
      //   }
      // }
      this.formData.tasks = [];
      for (var i = 0; i < this.checklist.tasks.length; i++) {
        // Deprecated
        // if (this.duplicate) continue;
        this.addEmptyTask();
        var task = this.formData.tasks[i];
        task.id = this.checklist.tasks[i].id;
        task.name = this.checklist.tasks[i].name;
        task.description = this.checklist.tasks[i].description;
        task.description_file_url = this.checklist.tasks[i].description_file;
        task.picture_url = this.checklist.tasks[i].picture;
        task.thumbnail_url = this.checklist.tasks[i].video_thumbnail;
        task.video_url = this.checklist.tasks[i].video;
        if (task.picture_url) {
          task.selectedContent = 'image';
        }
        if (task.video_url) {
          task.picture_url = '';
          task.selectedContent = 'video';
        }
        task.index = this.checklist.tasks[i].index;
        task.steps = [];
        for (var j = 0; j < this.checklist.tasks[i].steps.length; j++) {
          this.addEmptyStep(task);
          task.steps[j].id = this.checklist.tasks[i].steps[j].id;
          task.steps[j].description = this.checklist.tasks[i].steps[j].description;
          task.steps[j].order = this.checklist.tasks[i].steps[j].index;
          task.steps[j].picture_url = this.checklist.tasks[i].steps[j].picture;
          task.steps[j].thumbnail_url = this.checklist.tasks[i].steps[j].video_thumbnail;
          task.steps[j].video_url = this.checklist.tasks[i].steps[j].video;
          if (task.steps[j].picture_url) {
            task.steps[j].selectedContent = 'image';
          }
          if (task.steps[j].video_url) {
            task.steps[j].picture_url = '';
            task.steps[j].selectedContent = 'video';
          }
        }
      }
      this.haveItemChanges = false;
    },
    validateSteps: function validateSteps(task) {
      for (var i = 0; i < task.steps.length; i++) {
        task.steps[i].valid = true;
      }
      for (var _i2 = 0; _i2 < task.steps.length; _i2++) {
        var currentOrder = +task.steps[_i2].order;
        for (var j = _i2 + 1; j < task.steps.length; j++) {
          if (task.steps[j].order === currentOrder) {
            task.steps[_i2].valid = false;
            task.steps[j].valid = false;
          }
        }
      }
    },
    validateChecklist: function validateChecklist() {
      this.alertError.title = 'Error!';
      this.alertError.text = 'Missing needed data. All basic info fields and at least one checklist item are mandatory.';
      this.needFill = true;
      if (!this.formData.name) {
        this.alertError.text = 'Please fill field "Title"';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.role) {
        this.alertError.text = 'Please select role';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.area.length) {
        this.alertError.text = 'Please select working area';
        this.alertError.visible = true;
        return false;
      }
      var tasksIsValid = true;
      for (var i = 0; i < this.formData.tasks.length; i++) {
        tasksIsValid = tasksIsValid && this.validateTask(this.formData.tasks[i]);
      }
      return tasksIsValid;
      // return true;
    },
    validateTask: function validateTask(task) {
      if (!task.name) {
        this.alertError.text = 'Please fill checklist item title';
        return false;
      }
      // if (!task.description) {
      //   this.alertError.text = 'Please fill checklist item description';
      //   return false;
      // }
      task.video_require = false;
      if (task.selectedContent === 'video' && (task.video_thumbnail || task.thumbnail_url) && !(task.video || task.video_url)) {
        task.video_require = true;
        this.alertError.text = 'Please add video file';
        this.alertError.visible = true;
        return false;
      }
      if (task.selectedContent === 'video' && !(task.video_thumbnail || task.thumbnail_url) && (task.video || task.video_url)) {
        task.video_require = true;
        this.alertError.text = 'Please add thumbnail image';
        this.alertError.visible = true;
        return false;
      }
      if (!task.description_file) {
        for (var i = 0; i < task.steps.length; i++) {
          // if (!task.steps[i].description) {
          //   this.alertError.text = 'Please fill checklist item step description';
          //   return false;
          // }
          if (!task.steps[i].valid) {
            this.alertError.text = 'Please correct instructions for the checklist item';
            return false;
          }
        }
      }
      for (var _i3 = 0; _i3 < task.steps.length; _i3++) {
        var step = task.steps[_i3];
        step.video_require = false;
        if (step.selectedContent === 'video' && (step.video_thumbnail || step.thumbnail_url) && !(step.video || step.video_url)) {
          step.video_require = true;
          this.alertError.text = 'Please add video file';
          this.alertError.visible = true;
          return false;
        }
        if (step.selectedContent === 'video' && !(step.video_thumbnail || step.thumbnail_url) && (step.video || step.video_url)) {
          step.video_require = true;
          this.alertError.text = 'Please add thumbnail image';
          this.alertError.visible = true;
          return false;
        }
      }
      return true;
    },
    handleDragStart: function handleDragStart(e, item, index) {
      e.target.style.opacity = '0.4';
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text', index.toString());
      this.dragSrcEl = index;
    },
    handleDragEnd: function handleDragEnd(e) {
      e.target.style.opacity = '';
    },
    handleDrop: function handleDrop(e, index) {
      console.log('handleDrop()', index);
      if (e.stopPropagation) {
        e.stopPropagation(); // Stops some browsers from redirecting.
      }
      // Don't do anything if dropping the same column we're dragging.
      if (this.dragSrcEl !== index) {
        this.dragSrcEl = index;
        index = e.dataTransfer.getData('text');
        if (index < this.dragSrcEl) {
          this.formData.tasks.splice(+this.dragSrcEl + 1, 0, this.formData.tasks[index]);
          this.formData.tasks.splice(index, 1);
        } else {
          this.formData.tasks.splice(+this.dragSrcEl, 0, this.formData.tasks[index]);
          this.formData.tasks.splice(+index + 1, 1);
        }
        if (this.activeTask === +this.dragSrcEl) {
          if (this.haveItemChanges) {
            this.activeTask = +index;
            this.$refs.leavingItemConfirm.show();
          }
        } else {
          this.activeTask = +this.dragSrcEl;
        }
      }
      return false;
    },
    handleDragOver: function handleDragOver(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
    },
    getErrorText: function getErrorText(response) {
      var result = 'There were errors during the upload (' + response.status + ')';
      if (response.status === 400) {
        if (!response.body) {
          return 'Large file';
        }
        for (var key in response.body) {
          return key + ': ' + response.body[key];
        }
      }
      if (response.status === 401) {
        return 'Invalid authorization, please relogin';
      }
      if (response.status === 404) {
        return 'Not found (404)';
      }
      if (response.status === 500) {
        return 'Internal server error';
      }
      return result;
    },
    onChangeChecklistTask: function onChangeChecklistTask() {
      this.haveItemChanges = true;
    }
  },
  computed: {},
  created: function created() {
    // this.createUserRoles();
    this.getCompany();
    // this.addEmptyTask();
    this.getWorkingAreas();
    this.checklistId = this.$route.params.checklistId;
    if (this.checklistId) {
      this.processLoading = true;
      this.getChecklist(this.checklistId);
    }
  },

  watch: {
    $route: function $route(to, from) {
      if (to.name === 'Checklist Configuration Change' || to.name === 'Checklist Configuration Change SuperUser') {
        this.processLoading = true;
        this.checklistId = to.params.checklistId;
        this.formData.id = to.params.checklistId;
        this.getChecklist(to.params.checklistId);
      }
    },
    areas: function areas() {
      this.updateSuggestArea();
      if (this.checklist) {
        this.formData.area = this.checklist.area && this.areas.length ? [this.getAreaById(this.checklist.area)] : [];
      }
    },
    activeTaskNext: function activeTaskNext(val, prev) {
      if (val === null || val === this.activeTask) return;
      if (this.haveItemChanges && val !== null) {
        this.$refs.leavingItemConfirm.show();
      } else {
        this.activeTask = val;
      }
    }
  }
});

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_debounce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_debounce__);




var spinner = __webpack_require__(10).spinner;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'checklists',
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_1__header___, spinner: spinner },
  props: ['onLogout', 'access_token', 'authUser'],
  mounted: function mounted() {},
  data: function data() {
    return {
      formData: {
        checklists: [],
        checklistsFields: {
          index: {
            label: '#',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          id: {
            label: 'ID',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          name: {
            label: 'Text',
            tdClass: 'text-left',
            thClass: 'text-center'
          },
          area: {
            label: 'Working area',
            tdClass: 'text-left',
            thClass: 'text-center'
          },
          permission: {
            label: 'Permission',
            // tdClass: 'text-left',
            thClass: 'text-center'
          }
        }
      },
      currentPage: 1,
      perPage: 10,
      areas: [],
      filter: '',
      roles: {
        basic: 'Basic user',
        shift_leader: 'Shift Leader',
        manager: 'Manager'
      },
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Checklists',
        active: true
      }],
      processLoading: true
    };
  },

  methods: {
    isInFilter: function isInFilter(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item).toLowerCase().indexOf(this.filter.toLowerCase()) + 1;
    },
    getAddChecklistUrl: function getAddChecklistUrl() {
      return "" + '/constructor/ChecklistConstructor';
    },
    onRowClick: function onRowClick(item) {
      this.$router.push({ name: 'Checklist Configuration Change', params: { checklistId: item.id } });
    },
    getChecklistsTemplatesList: function getChecklistsTemplatesList() {
      var _this = this;

      var url = 'checklist-templates/';
      if (this.$route.params.companyId) {
        url = url + '?company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        _this.formData.checklists = response.body;
        _this.processLoading = false;
        return response.body;
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
      });
    },
    getWorkingAreas: function getWorkingAreas() {
      var _this2 = this;

      var url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = url + '&company=' + this.$route.params.companyId;
      }
      this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        _this2.areas = response.body;
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this2.onLogout();
        }
      });
    },
    getWorkingAreasListById: function getWorkingAreasListById(id, areas) {
      var result = [];
      for (var i = 0; i < areas.length; i++) {
        if (areas[i].id == id) {
          return result = [areas[i]];
        }
        result = this.getWorkingAreasListById(id, areas[i].subareas);
        if (result.length) {
          result.unshift(areas[i]);
          return result;
        }
      }
      return result;
    }
  },
  computed: {},
  created: function created() {
    var self = this;
    this.getChecklistsTemplatesList();
    this.getWorkingAreas();
  },

  directives: {
    debounce: __WEBPACK_IMPORTED_MODULE_2_v_debounce___default.a
  }
});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_debounce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_debounce__);




var spinner = __webpack_require__(10).spinner;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'companies',
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_1__header___, spinner: spinner },
  props: ['onLogout', 'access_token', 'authUser'],
  mounted: function mounted() {},
  data: function data() {
    return {
      companiesFields: {
        index: {
          label: '#',
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        name: {
          label: 'Company name',
          tdClass: 'text-left',
          thClass: 'text-center'
        },
        admin: {
          label: 'Company admin',
          tdClass: 'text-left',
          thClass: 'text-center'
        },
        phone: {
          label: 'Phone',
          // tdClass: 'text-left',
          thClass: 'text-center'
        },
        email: {
          label: 'Username',
          tdClass: 'text-left',
          thClass: 'text-center'
        },
        edit: {
          label: '',
          tdClass: 'text-left',
          thClass: 'text-center'
        }
      },
      companies: [],
      processLoading: false,
      filter: ''
    };
  },

  methods: {
    isInFilter: function isInFilter(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item).toLowerCase().indexOf(this.filter.toLowerCase()) + 1;
    },
    onAddCompany: function onAddCompany(e) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (id) {
        this.$router.push({ name: 'Change Company SuperUser', params: { companyId: id } });
      } else {
        this.$router.push({ name: 'Add Company SuperUser', params: { companyId: null } });
      }
    },
    onClickCompany: function onClickCompany(e, id) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.$router.push("" + '/company/' + id);
    },
    getCompanies: function getCompanies() {
      var _this = this;

      return this.$http.get('companies/', {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return null;
        }
        _this.companies = response.body;
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
      });
    }
  },
  computed: {},
  created: function created() {
    var _this2 = this;

    this.processLoading = true;
    this.getCompanies().then(function () {
      _this2.processLoading = false;
    }).catch(function () {
      _this2.processLoading = false;
    });
  },

  directives: {
    debounce: __WEBPACK_IMPORTED_MODULE_2_v_debounce___default.a
  }
});

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__thumbnail__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__thumbnail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__thumbnail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uploading__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uploading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__uploading__);




var alert = __webpack_require__(10).alert;
var spinner = __webpack_require__(10).spinner;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'company-config',
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_0__header___, alert: alert, spinner: spinner, Thumbnail: __WEBPACK_IMPORTED_MODULE_1__thumbnail___default.a, Uploading: __WEBPACK_IMPORTED_MODULE_2__uploading___default.a },
  props: ['onLogout', 'access_token', 'authUser'],
  mounted: function mounted() {},
  data: function data() {
    return {
      company: {
        id: null,
        name: '',
        picture: '',
        picture_url: '',
        logoff_after: ''
      },
      formData: {
        id: '',
        first_name: '',
        last_name: '',
        username: '',
        email: '',
        password: '',
        phone: '',
        confirmPassword: '',
        company: null,
        role: 'manager'
      },
      haveChanges: false,
      breadCrumbItems: [{
        text: 'Companies',
        to: "" + '/companies'
      }, {
        text: 'Add company',
        active: true
      }],
      processLoading: false,
      hasSaveError: false,
      needFill: false,
      alertError: {
        text: 'Some required fields are not filled',
        title: 'Error!',
        visible: false
      },
      alertSuccess: {
        text: 'User created',
        title: 'Success!',
        visible: false
      },
      upload: {
        total: 1,
        uploaded: 0,
        image: true,
        visible: false
      }
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.haveChanges) {
      this.$refs.leavingConfirm.show();
      next(false);
    } else {
      next();
    }
  },

  methods: {
    minTotime: function minTotime(mins) {
      var hours = '';
      var minutes = '';
      if (mins > 1439) {
        hours = 23;
        minutes = 59;
      } else {
        hours = Math.floor(mins / 60);
        minutes = mins - hours * 60;
      }
      var result = hours < 10 ? '0' + hours : hours;
      result += ':' + (minutes < 10 ? '0' + minutes : minutes);
      return result;
    },
    timeToMin: function timeToMin(time) {
      var hours = parseInt(time.split(':')[0]);
      var minutes = parseInt(time.split(':')[1]);
      var result = hours * 60 + minutes;
      return result;
    },
    discardChanges: function discardChanges() {
      this.haveChanges = false;
      this.$router.push({
        name: this.$router.history.pending.name,
        params: this.$router.history.pending.params
      });
    },
    getCompanyInfo: function getCompanyInfo(id) {
      var _this = this;

      function getFileNameFromUrl(url) {
        if (!url) return null;
        var name = url.split('/');
        return name[name.length - 1];
      }
      return this.$http.get('companies/' + id + '/', {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          _this.processLoading = false;
          return;
        }
        _this.company.id = response.body.id;
        _this.company.name = response.body.name;
        _this.company.picture_url = response.body.picture;
        _this.company.picture_name = getFileNameFromUrl(response.body.picture);
        _this.company.logoff_after = _this.minTotime(response.body.logoff_after);
        if (response.body.manager) {
          _this.formData.first_name = response.body.manager.first_name;
          _this.formData.last_name = response.body.manager.last_name;
          _this.formData.username = response.body.manager.username;
          _this.formData.phone = response.body.manager.phone;
          _this.formData.email = response.body.manager.email;
          _this.formData.id = response.body.manager.id;
        }
        setTimeout(function () {
          _this.haveChanges = false;
        }, 1);
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
      });
    },
    validateEmail: function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validateData: function validateData() {
      if (this.timeToMin(this.company.logoff_after) < 60) {
        this.alertError.text = 'Minimum logoff time is 01:00';
        this.alertError.visible = true;
        return false;
      }
      if (!this.company.name) {
        this.alertError.text = 'Please fill company name';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.first_name) {
        this.alertError.text = 'Please fill first name';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.last_name) {
        this.alertError.text = 'Please fill last name';
        this.alertError.visible = true;
        return false;
      }
      if (this.formData.email && !this.validateEmail(this.formData.email)) {
        this.alertError.text = 'Invalid Email';
        this.alertError.visible = true;
        return null;
      }
      if (!this.formData.username && !this.validateEmail(this.formData.email)) {
        this.alertError.text = 'Please fill Username or Email';
        this.alertError.visible = true;
        return null;
      }
      // if (!this.formData.username) {
      //   this.alertError.text = 'Please fill username';
      //   this.alertError.visible = true;
      //   return false;
      // }
      // if (!this.formData.first_name ||
      //     !this.formData.last_name ||
      //     !this.formData.username) {
      //   return false;
      // }
      if (this.formData.id && this.formData.password.length !== 0 && this.formData.password !== this.formData.confirmPassword) {
        this.alertError.text = "Passwords don't match";
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (!this.formData.id && this.formData.password.length === 0) {
        this.alertError.text = 'Password mandatory';
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (!this.formData.id && (this.formData.password.length === 0 || this.formData.password !== this.formData.confirmPassword)) {
        this.alertError.text = "Passwords don't match";
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (this.formData.password.length !== 0 && (this.formData.password.length < 6 || !/(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])/.test(this.formData.password))) {
        this.alertError.text = 'Please, check your password. It is short or missing required characters!';
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      return true;
    },
    saveData: function saveData() {
      var _this2 = this;

      var self = this;
      this.needFill = false;
      this.hasSaveError = false;
      if (!this.validateData()) {
        this.needFill = true;
        return;
      }
      // this.alertError.text = 'There were errors during the upload';
      this.upload.image = false;
      this.upload.total = 1;
      this.upload.uploaded = 0;
      this.upload.visible = true;
      this.sendCompany().then(function (response) {
        if (response !== 200 && response !== 201) {
          self.hasSaveError = true;
          return null;
        }
        if (_this2.company.id) {
          self.upload.image = false;
          return _this2.sendUser();
        }
        return null;
      }).then(function (response) {
        if (response !== 200 && response !== 201) {
          self.hasSaveError = true;
          self.alertError.visible = true;
        } else {
          if (response === 201) {
            return _this2.sendCompany();
          }
          return 200;
        }
        return null;
      }).then(function (response) {
        if (response !== 200 && response !== 201) {
          self.hasSaveError = true;
          self.alertError.visible = true;
          _this2.upload.visible = false;
          return null;
        }
        self.alertSuccess.visible = true;
        _this2.upload.visible = false;
        _this2.haveChanges = false;
        if (_this2.$router.history.pending) {
          _this2.$router.push({
            name: _this2.$router.history.pending.name,
            params: _this2.$router.history.pending.params
          });
        }
        return null;
      }).catch(function (response) {
        self.alertError.text = self.getErrorText(response);
        self.alertError.visible = true;
        _this2.upload.visible = false;
        return response;
      });
    },
    cancelData: function cancelData() {
      // this.haveChanges = false;
      this.$router.push({ name: 'Companies SuperUser' });
    },
    sendCompany: function sendCompany() {
      var _this3 = this;

      var data = {
        name: this.company.name,
        logoff_after: this.timeToMin(this.company.logoff_after),
        manager: this.formData.id
      };
      if (this.company.picture) {
        this.upload.image = true;
        this.upload.uploaded = 0;
        data.picture = this.company.picture;
      }
      if (!this.company.picture && !this.company.picture_url) {
        data.picture = null;
        this.upload.image = false;
      }
      var formData = new FormData();
      for (var key in data) {
        formData.append(key, data[key]);
      }
      if (!this.company.id) {
        return this.$http.post('companies/', data.picture ? formData : data, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
          // emulateJSON: true,
        }).then(function (response) {
          if (response.status !== 201) {
            console.log(response);
            _this3.alertError.text = _this3.getErrorText(response);
            return response.status;
          }
          _this3.company.id = response.body.id;
          _this3.company.picture = '';
          _this3.company.picture_url = response.body.picture;
          return response.status;
        }).catch(function (response) {
          if (response.status === 401) {
            _this3.onLogout();
          }
          _this3.alertError.text = _this3.getErrorText(response);
          _this3.alertError.visible = true;
          return response;
        });
      }
      return this.$http.patch('companies/' + this.company.id + '/', data.picture ? formData : data, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          _this3.alertError.text = _this3.getErrorText(response);
          return response.status;
        }
        _this3.company.picture = '';
        _this3.company.picture_url = response.body.picture;
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this3.onLogout();
        }
        _this3.alertError.text = _this3.getErrorText(response);
        _this3.alertError.visible = true;
        return response;
      });
    },
    sendUser: function sendUser() {
      var _this4 = this;

      var data = {
        first_name: this.formData.first_name,
        last_name: this.formData.last_name,
        password: this.formData.password,
        role: 'manager',
        username: this.formData.username,
        email: this.formData.email,
        company: this.company.id,
        phone: this.formData.phone
      };
      if (!this.formData.id) {
        return this.$http.post('users/', data, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
          // emulateJSON: true,
        }).then(function (response) {
          if (response.status !== 201) {
            console.log(response);
            _this4.alertError.text = _this4.getErrorText(response);
            return response.status;
          }
          _this4.formData.id = response.body.id;
          return response.status;
        }).catch(function (response) {
          if (response.status === 401) {
            _this4.onLogout();
          }
          _this4.alertError.text = _this4.getErrorText(response);
          _this4.alertError.visible = true;
          return response;
        });
      }
      if (!data.password) {
        delete data.password;
      }
      return this.$http.patch('users/' + this.formData.id + '/', data, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          _this4.alertError.text = _this4.getErrorText(response);
          return response.status;
        }
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this4.onLogout();
        }
        _this4.alertError.text = _this4.getErrorText(response);
        _this4.alertError.visible = true;
        return response;
      });
    },
    getErrorText: function getErrorText(response) {
      var result = 'There were errors during the upload (' + response.status + ')';
      if (response.status === 400) {
        if (!response.body) {
          return 'Large file';
        }
        for (var key in response.body) {
          return key + ': ' + response.body[key];
        }
      }
      if (response.status === 401) {
        return 'Invalid authorization, please relogin';
      }
      if (response.status === 404) {
        return 'Not found (404)';
      }
      if (response.status === 500) {
        return 'Internal server error';
      }
      return result;
    }
  },
  computed: {},
  watch: {
    'company.name': function companyName() {
      this.haveChanges = true;
    },
    'company.picture': function companyPicture() {
      this.haveChanges = true;
    },
    'formData.first_name': function formDataFirst_name() {
      this.haveChanges = true;
    },
    'formData.last_name': function formDataLast_name() {
      this.haveChanges = true;
    },
    'formData.username': function formDataUsername() {
      this.haveChanges = true;
    },
    'formData.email': function formDataEmail() {
      this.haveChanges = true;
    },
    'formData.password': function formDataPassword() {
      this.haveChanges = true;
    },
    'formData.phone': function formDataPhone() {
      this.haveChanges = true;
    }
  },
  created: function created() {
    var _this5 = this;

    if (this.$route.params.companyId) {
      this.company.id = this.$route.params.companyId;
      this.processLoading = true;
      this.getCompanyInfo(this.company.id).then(function () {
        _this5.processLoading = false;
      }).catch(function () {
        _this5.processLoading = false;
      });
    }
  }
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  props: ['authUser', 'access_token'],
  mounted: function mounted() {},
  data: function data() {
    return {
      company: null,
      samlProviders: []
      // authUser: this.authUser,
    };
  },

  methods: {
    getSamlLogoutUrl: function getSamlLogoutUrl(upn, providers) {
      if (upn.indexOf('@') > -1) {
        var userSuffix = upn.split('@')[1];
        for (var i = 0; i < providers.length; i++) {
          for (var ii = 0; ii < providers[i].suffixes.length; ii++) {
            if (userSuffix === providers[i].suffixes[ii]) {
              return providers[i].logout_url;
            }
          }
        }
      }
    },
    samlLogout: function samlLogout() {
      var providers = localStorage.getItem('samlProviders');
      this.samlProviders = providers ? JSON.parse(providers) : null;

      if (this.samlProviders && this.authUser.upn) {
        var logoutUrl = this.getSamlLogoutUrl(this.authUser.upn, this.samlProviders);
        window.open(logoutUrl, '_blank');
      }
    },
    userLogout: function userLogout() {
      this.$router.push({ name: 'logout', query: { logoutPortal: true } });
    },
    getHomeUrl: function getHomeUrl() {
      return "" + '/';
    },
    getCompany: function getCompany() {
      var _this = this;

      var id = this.$route.params.companyId;
      if (!id) return;
      this.$http.get('companies/' + id + '/', {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          return;
        }
        _this.company = {};
        _this.company.id = response.body.id;
        _this.company.name = response.body.name;
        _this.company.picture = response.body.picture;
      });
    }
  },
  created: function created() {
    this.getCompany();
  },

  computed: {}
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header_index__);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_0__header_index__ },
  props: ['onLogout'],
  mounted: function mounted() {},
  data: function data() {
    return {
      authUser: null,
      access_token: '',
      items: [[{ name: 'Working areas', url: "" + '/configuration/workingAreas', active: true }, { name: 'Days, times & Shifts', url: "" + '/configuration/shifts' }, { name: 'Users & Permissions', url: "" + '/configuration/usersPermissions' }, { name: 'Roles', url: "" + '/configuration/roles' }, { name: 'Settings', url: "" + '/configuration/settings' }], [{ name: 'Task constructor', url: "" + '/constructor/TaskConstructor' }, { name: 'Task constructor (new)', url: "" + '/constructor/new_task' }, { name: 'Checklists constructor', url: "" + '/constructor/ChecklistConstructor' }, { name: 'Checklist constructor (new)', url: "" + '/constructor/new_checklist' }, { name: 'Audits constructor', url: "" + '/constructor/AuditConstructor' }, { name: 'Audit constructor (new)', url: "" + '/constructor/new_audit' }], [{ name: 'Tasks', url: "" + '/constructor/tasks' }, { name: 'Tasks (new)', url: "" + '/constructor/new_tasks' }, { name: 'Checklists', url: "" + '/constructor/checklists' }, { name: 'Checklists (new)', url: "" + '/constructor/new_checklists' }, { name: 'Audits', url: "" + '/constructor/audits' }, { name: 'Audits (new)', url: "" + '/constructor/new_audits' }, { name: 'Actions', url: "" + '/' }]],
      fields: [{ name: { label: 'Configuration' } }, { name: { label: 'Constructors' } }, { name: { label: 'Data' } }],
      breadCrumbItems: [{
        text: 'Companies',
        to: "" + '/companies'
      }, {
        text: 'Home',
        active: true
      }]
      // currentPage: 1,
      // perPage: 5,
      // filter: null,
    };
  },

  methods: {
    // redirect: function(url) {
    //   this.$router.push(url);
    // },

  },
  computed: {},
  created: function created() {
    var token = localStorage.getItem('access_token');
    var authUser = localStorage.getItem('authUser');
    this.access_token = token || '';
    this.authUser = authUser ? JSON.parse(authUser) : null;
    if (this.authUser && this.authUser.role == 'shift_leader') {
      this.items.splice(0, 1);
      this.fields.splice(0, 1);
    }
  }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_index__);



var alert = __webpack_require__(10).alert;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_1__header_index__, alert: alert },
  props: ['onLogout'],
  mounted: function mounted() {
    this.getAuthProviders();
    this.checkSamlRedirect();
  },
  data: function data() {
    return {
      authData: {
        loginInput: this.loginInput,
        passwordInput: this.passwordInput
      },
      alertError: {
        text: 'Incorrect login or password',
        title: 'Error!',
        visible: false
      },
      alertSuccess: {
        text: 'User created',
        title: 'Success!',
        visible: false
      },
      alertWarning: {
        text: 'You seem to be logged in at another location. And was redirected to the login for security reasons.',
        title: 'Warning!',
        visible: false
      },
      loginProviders: [],
      user: {},
      showLoginMain: false
    };
  },

  methods: {
    // login($event, authData) {
    //   this.$emit('loginSend', [authData.loginInput, authData.passwordInput]);
    // },
    sendAuth: function sendAuth() {
      var _this = this;

      this.$http.post('authorize/', { username: this.authData.loginInput, password: this.authData.passwordInput, app: 'cms' }, {
        method: 'POST',
        headers: {}
      }).then(function (response) {
        if (response.status !== 200) {
          _this.alertError.text = 'Incorrect login or password';
          _this.alertError.visible = true;
          return;
        }
        if (response.body.user && response.body.user.role === 'basic') {
          _this.alertError.text = 'Access denied to basic user';
          _this.alertError.visible = true;
          return;
        }
        _this.$emit('onLogin', response.body.access_token, response.body.user);
      }).catch(function (response) {
        if (response.status === 403) {
          _this.alertError.text = 'Incorrect login or password';
        } else {
          _this.alertError.text = 'Error code ' + response.status;
        }
        _this.alertError.visible = true;
      });
    },
    getAuthProviders: function getAuthProviders() {
      var _this2 = this;

      this.$http.get('auth_providers/', {
        method: 'GET',
        headers: {}
      }).then(function (response) {
        if (response.status !== 200) {
          _this2.alertError.text = 'Can not get auth providers';
          _this2.alertError.visible = true;
          return;
        }
        _this2.loginProviders = response.body;
        localStorage.setItem('samlProviders', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.loginProviders));
      }).catch(function (response) {
        _this2.alertError.text = 'Can not get auth providers. Error code: ' + response.status;
        _this2.alertError.visible = true;
      });
    },
    getAuthUser: function getAuthUser(token, userId) {
      var _this3 = this;

      this.$http.get('users/' + userId + '/', {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          _this3.alertError.text = 'Could not fetch User information';
          _this3.alertError.visible = true;
          return;
        }
        if (response.body && response.body.role === 'basic') {
          _this3.alertError.text = 'Access denied to basic user';
          _this3.alertError.visible = true;
          return;
        }
        _this3.user = response.body;
        _this3.$emit('onLogin', token, _this3.user);
      });
    },
    checkSamlRedirect: function checkSamlRedirect() {
      var authed = this.$route.query.authorized;
      var idp = this.$route.query.idp;
      var token = this.$route.query.token;
      var userId = this.$route.query.id;
      this.$router.replace({ query: { '': '' } });
      authed = authed ? authed.toLowerCase() : '';
      idp = idp ? idp.toLowerCase() : '';
      if (authed === 'false') {
        if (idp) {
          this.forceSamlLogout(idp);
        }
        this.alertError.text = 'Incorrect login or password';
        this.alertError.visible = true;
        return;
      }
      if (token && userId) {
        this.getAuthUser(token, userId);
      }
    },
    checkSuffix: function checkSuffix() {
      var login = this.authData.loginInput;
      if (login.indexOf('@') > -1) {
        var userSuffix = login.split('@')[1];
        for (var i = 0; i < this.loginProviders.length; i++) {
          for (var ii = 0; ii < this.loginProviders[i].suffixes.length; ii++) {
            if (userSuffix === this.loginProviders[i].suffixes[ii]) {
              window.location.href = this.loginProviders[i].login_cms_url;
              return;
            }
          }
        }
      }
      this.showLoginMain = true;
    },
    forceSamlLogout: function forceSamlLogout(idp) {
      var providers = JSON.parse(localStorage.samlProviders);
      for (var i = 0; i < providers.length; i++) {
        if (providers[i].name.toLowerCase() === idp) {
          window.open(providers[i].logout_url, '_blank');
        }
      }
    }
  },
  computed: {},
  created: function created() {
    var _this4 = this;

    if (this.$route.params.redirectedOnError) {
      setTimeout(function () {
        return _this4.alertWarning.visible = true;
      }, 1);
    }
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'logout',
  components: {},
  props: ['onLogout', 'authUser', 'access_token'],
  mounted: function mounted() {},
  data: function data() {
    return {};
  },

  methods: {
    getSamlLogoutUrl: function getSamlLogoutUrl(upn, providers) {
      if (upn.indexOf('@') > -1) {
        var userSuffix = upn.split('@')[1];
        for (var i = 0; i < providers.length; i++) {
          for (var ii = 0; ii < providers[i].suffixes.length; ii++) {
            if (userSuffix === providers[i].suffixes[ii]) {
              return providers[i].logout_url;
            }
          }
        }
      }
    },
    samlLogout: function samlLogout() {
      var providers = localStorage.getItem('samlProviders');
      this.samlProviders = providers ? JSON.parse(providers) : null;
      console.log(this.authUser);
      if (this.samlProviders && this.authUser.upn) {
        var logoutUrl = this.getSamlLogoutUrl(this.authUser.upn, this.samlProviders);
        window.open(logoutUrl, '_blank');
      }
    }
  },
  computed: {},
  created: function created() {
    this.samlLogout();
    this.$emit('logout');
    //localStorage.clear();
    //sessionStorage.clear();
    //document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
    localStorage.setItem("remove_access_token", true);
    localStorage.setItem("remove_authUser", true);

    if (this.$route.query.logoutPortal) {
      window.location.href = "%PORTAL_URL%" + "/logout";
    } else {
      this.$router.push({ name: 'login' });
    }
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header___);



var alert = __webpack_require__(10).alert;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'roles',
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_1__header___, alert: alert },
  props: ['onLogout', 'access_token', 'authUser'],
  mounted: function mounted() {},
  data: function data() {
    return {
      formData: {
        manager_role_display_name: '',
        shift_leader_role_display_name: '',
        basic_role_display_name: ''
      },
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Roles',
        active: true
      }],
      alertError: {
        text: 'An errors occurred.',
        title: 'Error!',
        visible: false
      },
      alertSuccess: {
        text: 'Roles were saved',
        title: 'Success!',
        visible: false
      }
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      var url = 'companies/';
      if (this.$route.params.companyId) {
        url = '' + url + this.$route.params.companyId + '/';
      } else {
        url = '' + url + this.authUser.company.id + '/';
      }
      this.$http.patch(url, this.formData, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        _this.updateCompany();
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
      });;
    },
    updateCompany: function updateCompany() {
      var _this2 = this;

      var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var url = 'companies/';
      if (this.$route.params.companyId) {
        url = '' + url + this.$route.params.companyId + '/';
      } else {
        url = '' + url + this.authUser.company.id + '/';
      }
      this.$http.get(url, {
        method: 'get',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return response;
        }
        _this2.alertSuccess.visible = update;
        if (_this2.authUser && !_this2.$route.params.companyId) {
          _this2.authUser.company = response.body;
          localStorage.setItem('authUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.authUser));
        }
        if (response.body.manager_role_display_name) {
          _this2.formData.manager_role_display_name = response.body.manager_role_display_name;
        }
        if (response.body.shift_leader_role_display_name) {
          _this2.formData.shift_leader_role_display_name = response.body.shift_leader_role_display_name;
        }
        if (response.body.basic_role_display_name) {
          _this2.formData.basic_role_display_name = response.body.basic_role_display_name;
        }
      }).catch(function (response) {
        if (response.status === 401) {
          _this2.onLogout();
        }
        _this2.alertError.visible = true;
      });
    }
  },
  created: function created() {
    if (this.authUser && this.authUser.company) {
      this.formData.basic_role_display_name = this.authUser.company.basic_role_display_name;
      this.formData.shift_leader_role_display_name = this.authUser.company.shift_leader_role_display_name;
      this.formData.manager_role_display_name = this.authUser.company.manager_role_display_name;
    }
    this.updateCompany(false);
  },

  computed: {}
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_timepicker__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__header___);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'shifts',
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_2__header___, VueTimepicker: __WEBPACK_IMPORTED_MODULE_1_vue2_timepicker___default.a },
  props: ['onLogout', 'access_token', 'authUser'],
  mounted: function mounted() {},
  data: function data() {
    return {
      currentItem: {
        key: null,
        index: null
      },
      timeStart: {
        HH: '00',
        mm: '00'
      },
      timeEnd: {
        HH: '00',
        mm: '00'
      },
      addShiftStr: '+ add shifts',
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Days, times, shifts',
        active: true
      }],
      items: [],
      itemsArea: [],
      fields: {
        monday: {
          label: 'Monday',
          value: 2,
          class: 'td'
        },
        tuesday: {
          label: 'Tuesday',
          value: 3,
          class: 'td'
        },
        wednesday: {
          label: 'Wednesday',
          value: 4,
          class: 'td'
        },
        thursday: {
          label: 'Thursday',
          value: 5,
          class: 'td'
        },
        friday: {
          label: 'Friday',
          value: 6,
          class: 'td'
        },
        saturday: {
          label: 'Saturday',
          value: 7,
          class: 'td'
        },
        sunday: {
          label: 'Sunday',
          value: 1,
          class: 'td'
        }
      },
      shifts: null,
      shiftsArea: null,
      areaId: null,
      custom_shifts: false,
      toogleCompanyShifts: 1,
      toogleCompanyShiftsOptions: [{
        text: 'Company shifts',
        value: 1
      }, {
        text: 'Area shifts',
        value: 2
      }],
      emptyShifts: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: []
      }
    };
  },

  methods: {
    log: function log(str) {
      console.log(str);
    },
    resetTimes: function resetTimes() {
      this.timeStart = { HH: '06', mm: '00' };
      this.timeEnd = { HH: '06', mm: '00' };
    },
    makeTimesFromString: function makeTimesFromString(str) {
      var times = str.split('-');
      this.timeStart = { HH: times[0].split(':')[0], mm: times[0].split(':')[1] };
      this.timeEnd = { HH: times[1].split(':')[0], mm: times[1].split(':')[1] };
    },
    onClickAddShift: function onClickAddShift(key) {
      // this.shifts[key].push(this.timeStart.HH + ':' + this.timeStart.mm + '-' +
      //                       this.timeEnd.HH + ':' + this.timeEnd.mm);
      this.sendNewShift(key, [this.timeStart.HH + ':' + this.timeStart.mm, this.timeEnd.HH + ':' + this.timeEnd.mm]);
      // this.updateTableData();
    },
    onClickDelete: function onClickDelete(key, index) {
      // this.shifts[key].splice(index, 1);
      // this.updateTableData();
      this.sendDeleteShift(key, index);
    },
    onClickEdit: function onClickEdit(key, index) {
      // this.shifts[key][index] = this.timeStart.HH + ':' + this.timeStart.mm + '-' +
      //                           this.timeEnd.HH + ':' + this.timeEnd.mm;
      // this.updateTableData();
      this.sendEditShift(key, index, {
        start: this.timeStart.HH + ':' + this.timeStart.mm,
        end: this.timeEnd.HH + ':' + this.timeEnd.mm
      });
    },
    sortShifts: function sortShifts(shifts) {
      shifts.sort(function (a, b) {
        if (a.start == b.start) {
          return a.end > b.end;
        }
        return a.start > b.start;
      });
    },
    updateTableData: function updateTableData() {
      this.items = [];
      for (var key in this.shifts) {
        for (var i = 0; i < this.shifts[key].length; i++) {
          if (this.items.length <= i) {
            this.items.push({});
          }
          this.items[i][key] = this.shifts[key][i].time;
        };
        if (this.items.length <= this.shifts[key].length) {
          this.items.push({});
        }
        // this.items[this.shifts[key].length][key] = this.addShiftStr;
      }
    },
    updateTableDataArea: function updateTableDataArea() {
      this.itemsArea = [];
      for (var key in this.shiftsArea) {
        for (var i = 0; i < this.shiftsArea[key].length; i++) {
          if (this.itemsArea.length <= i) {
            this.itemsArea.push({});
          }
          this.itemsArea[i][key] = this.shiftsArea[key][i].time;
        }
        if (this.itemsArea.length <= this.shiftsArea[key].length) {
          this.itemsArea.push({});
        }
        // this.items[this.shifts[key].length][key] = this.addShiftStr;
      }
    },
    sendDeleteShift: function sendDeleteShift(key, index) {
      var _this = this;

      var shiftId = 0;
      if (!this.areaId) {
        shiftId = this.shifts[key][index].id;
      } else {
        shiftId = this.shiftsArea[key][index].id;
      }
      this.$http.patch('shifts/' + shiftId + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        _this.getShiftList(_this.areaId);
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
      });
    },
    sendEditShift: function sendEditShift(key, index, time) {
      var _this2 = this;

      var data = {
        // id: this.shifts[key][index].id,
        // day: this.fields[key].value,
        start: time.start,
        end: time.end
      };
      var shiftId = 0;
      if (!this.areaId) {
        shiftId = this.shifts[key][index].id;
      } else {
        shiftId = this.shiftsArea[key][index].id;
      }
      this.$http.patch('shifts/' + shiftId + '/', data, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        _this2.getShiftList(_this2.areaId);
      }).catch(function (response) {
        if (response.status === 401) {
          _this2.onLogout();
        }
      });
    },
    sendNewShift: function sendNewShift(key, times) {
      var _this3 = this;

      var data = {
        day: this.fields[key].value,
        start: times[0],
        end: times[1],
        area: this.areaId
      };
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      this.$http.post('shifts/', data, {
        method: 'POST',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 201) {
          console.log(response);
          return;
        }
        _this3.getShiftList(_this3.areaId);
      }).catch(function (response) {
        if (response.status === 401) {
          _this3.onLogout();
        }
      });
    },
    getShiftList: function getShiftList(areaId) {
      var _this4 = this;

      var url = 'shifts/';
      if (areaId) {
        url = url + '?area=' + areaId;
      } else {
        if (this.$route.params.companyId) {
          url = url + '?company=' + this.$route.params.companyId;
        }
      }

      this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        if (!areaId) {
          _this4.shifts = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this4.emptyShifts));
        } else {
          _this4.shiftsArea = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this4.emptyShifts));
        }
        _this4.sortShifts(response.body);
        for (var i = 0; i < response.body.length; i++) {
          for (var key in _this4.fields) {
            if (_this4.fields[key].value == response.body[i].day) {
              var time = response.body[i].start.split(':')[0] + ':' + response.body[i].start.split(':')[1] + '-' + response.body[i].end.split(':')[0] + ':' + response.body[i].end.split(':')[1];
              var newData = {
                id: response.body[i].id,
                time: time
              };
              if (!areaId) {
                if (!response.body[i].area) {
                  _this4.shifts[key].push(newData);
                }
              } else {
                _this4.shiftsArea[key].push(newData);
              }
            }
          }
        }
        if (!areaId) {
          _this4.updateTableData();
        } else {
          _this4.updateTableDataArea();
        }
      }).catch(function (response) {
        if (response.status === 401) {
          _this4.onLogout();
        }
      });
    },
    changeWorkingAreaCustomShift: function changeWorkingAreaCustomShift() {
      var _this5 = this;

      console.log('change custom', this.custom_shifts, this.toogleCompanyShifts === 2);
      // return;
      this.$http.patch('areas/' + this.areaId + '/', { custom_shifts: this.toogleCompanyShifts === 2 }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return;
        }
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this5.onLogout();
        }
      });
    }
  },
  computed: {},
  created: function created() {
    this.shifts = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.emptyShifts));
    this.shiftsArea = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.emptyShifts));
    this.areaId = this.$route.params.areaId ? this.$route.params.areaId : null;
    this.custom_shifts = this.$route.params.custom_shifts;
    if (this.custom_shifts === true) {
      this.toogleCompanyShifts = 2;
    }
    // this.items.push(
    //   {
    //     monday: this.addShiftStr,
    //     tuesday: this.addShiftStr,
    //     wednesday: this.addShiftStr,
    //     thursday: this.addShiftStr,
    //     friday: this.addShiftStr,
    //     saturday: this.addShiftStr,
    //     sunday: this.addShiftStr,
    //   },
    // );
    this.updateTableData();
    this.updateTableDataArea();
    this.getShiftList();
    if (this.areaId) {
      this.getShiftList(this.areaId);
    }
  },

  watch: {
    toogleCompanyShifts: function toogleCompanyShifts() {
      this.changeWorkingAreaCustomShift();
    }
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__header___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__autocomplete_vue_autocomplete_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__autocomplete_vue_autocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__autocomplete_vue_autocomplete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__areaCheckbox___ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__areaCheckbox____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__areaCheckbox___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__thumbnail__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__thumbnail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__thumbnail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__uploading__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__uploading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__uploading__);












var alert = __webpack_require__(10).alert;
var spinner = __webpack_require__(10).spinner;
// const datepicker = require('vue-strap').datepicker;


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'task-config',
  props: ['onLogout', 'access_token', 'authUser', 'duplicate'],
  components: {
    headerBlock: __WEBPACK_IMPORTED_MODULE_5__header___,
    Autocomplete: __WEBPACK_IMPORTED_MODULE_6__autocomplete_vue_autocomplete_vue___default.a,
    AreaCheckbox: __WEBPACK_IMPORTED_MODULE_7__areaCheckbox____default.a,
    alert: alert,
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker___default.a,
    spinner: spinner,
    Thumbnail: __WEBPACK_IMPORTED_MODULE_8__thumbnail___default.a,
    Uploading: __WEBPACK_IMPORTED_MODULE_9__uploading___default.a
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      formData: {
        name: '',
        description: '',
        role: 'basic',
        selectedContent: '',
        picture: '',
        img: null,
        video: '',
        video_url: '',
        video_thumbnail: '',
        img_thumbnail: null,
        video_require: false,
        deeplink: {
          active: false,
          item: 'checklist',
          id: null,
          badId: false,
          name: null
        },
        description_file: '',
        description_file_url: '',
        instructionSteps: [],
        workAreas: [],
        suggestArea: []
      },

      weekDays: [{ label: 'Monday', value: 2 }, { label: 'Tuesday', value: 3 }, { label: 'Wednesday', value: 4 }, { label: 'Thursday', value: 5 }, { label: 'Friday', value: 6 }, { label: 'Saturday', value: 7 }, { label: 'Sunday', value: 1 }],

      deeplinks: [{ name: 'audit', id: 1 }, { name: 'checklist', id: 1 }],
      areas: [],
      taskTemplates: [],
      checklists: [],
      audits: [],
      // areasChecked: '',
      shifts: {
        sunday: [],
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: []

      },
      emptyStep: {
        id: null,
        order: 1,
        description: '',
        picture: '',
        valid: true,
        img: '',
        imgChanged: false,
        selectedContent: '',
        video: '',
        video_url: '',
        video_thumbnail: '',
        img_thumbnail: null,
        video_require: false
      },
      emptyWorkArea: {
        area: [],
        areaFromList: false,
        scheduler: {
          id: null,
          fromDate: null,
          toDate: null,
          forever: true,
          tabIndex: 0,
          byShift: {
            fields: {},
            items: [],
            isNotChecked: true
          },
          weekly: {
            recurWeek: 1,
            selected: [1, 2, 3, 4, 5, 6, 7],
            is_once_per_week: true
          },
          monthly: {
            // type: 1,
            is_once_per_month: true,
            recurDay: {
              day: 1,
              month: 1
            },
            recurWeekDay: {
              every: 1,
              weekDay: 1,
              month: 1
            }

          },
          oneDay: {
            date: null,
            weekday: 'monday',
            shifts: [],
            fields: {},
            field: {},
            items: [],
            item: [],
            isNotChecked: true
          },
          type: {
            selected: 0,
            options: [{ text: 'Recurring', value: 0 }, { text: 'On one day', value: 1 }]
          }
        }
      },
      weekdays: [],
      weekNumbersItem: [{ text: 'First', value: 1 }, { text: 'Second', value: 2 }, { text: 'Third', value: 3 }, { text: 'Fourth', value: 4 }],
      userRoles: [],
      hasSaveError: false,
      needFill: false,
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Tasks',
        to: "" + '/constructor/Tasks'
      }, {
        text: 'Constructor',
        active: true
      }],
      alertError: {
        text: 'Some fields are not filled',
        title: 'Error!',
        visible: false
      },
      alertSuccess: {
        text: 'Saved successfully, tab will be closed in 3 seconds',
        title: '',
        visible: false
      },
      upload: {
        total: 1,
        uploaded: 0,
        image: true,
        visible: false
      },
      taskId: null,
      processLoading: false,
      stepsMustDelete: [],
      recurrenciesMustDelete: []
    };
  },

  methods: {
    readURL: function readURL(input, item) {
      if (input.files && input.files[0]) {
        // item.pictureBugFixer = input.files[0];
        var reader = new FileReader();
        reader.onload = function (e) {
          // $('#icon').attr('src', e.target.result);
          item.img = e.target.result;
        };

        reader.readAsDataURL(input.files[0]);
      }
    },
    handleVideoFileChange: function handleVideoFileChange(e) {
      if (e.target.files && e.target.files[0] && e.target.files[0].size > 50000000) {
        e.target.value = '';
        this.alertError.text = 'Maximum allowed video size is 50 MB.';
        this.alertError.visible = true;
        return;
      }
    },

    // createUserRoles() {
    //   if (this.authUser && this.authUser.company) {
    //     this.userRoles.push({
    //       name: this.authUser.company.basic_role_display_name || 'Basic user',
    //       id: 'basic',
    //     });
    //     this.userRoles.push({
    //       name: this.authUser.company.shift_leader_role_display_name || 'Shift leader',
    //       id: 'shift_leader',
    //     });
    //     this.userRoles.push({
    //       name: this.authUser.company.manager_role_display_name || 'Manager',
    //       id: 'manager',
    //     });
    //   }
    // },
    getCompany: function getCompany() {
      var _this = this;

      function assignDefaultRoles() {
        this.userRoles.push({
          name: 'Basic user',
          id: 'basic'
        });
        this.userRoles.push({
          name: 'Shift leader',
          id: 'shift_leader'
        });
        this.userRoles.push({
          name: 'Manager',
          id: 'manager'
        });
      }
      var id = null;
      if (this.authUser && this.authUser.company && this.authUser.company.id) {
        id = this.authUser.company.id;
      }
      if (this.$route.params.companyId) {
        id = this.$route.params.companyId;
      }
      if (!id) {
        assignDefaultRoles();
        return null;
      }
      return this.$http.get('companies/' + id + '/', {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          assignDefaultRoles();
          _this.alertError.text = _this.getErrorText(response);
          return response.status;
        }
        _this.userRoles = [];
        _this.userRoles.push({
          name: response.body.basic_role_display_name || 'Basic user',
          id: 'basic'
        });
        _this.userRoles.push({
          name: response.body.shift_leader_role_display_name || 'Shift leader',
          id: 'shift_leader'
        });
        _this.userRoles.push({
          name: response.body.manager_role_display_name || 'Manager',
          id: 'manager'
        });
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
      });
    },
    createShiftsField: function createShiftsField() {
      var fields = this.emptyWorkArea.scheduler.byShift.fields;
      var index = 1;
      fields.monday = null;
      fields.tuesday = null;
      fields.wednesday = null;
      fields.thursday = null;
      fields.friday = null;
      fields.saturday = null;
      fields.sunday = null;

      for (var key in this.shifts) {
        fields[key] = {
          label: key.charAt(0).toUpperCase() + key.slice(1) + '\n                  <div class="select-shift-table__header">\n                  Select all shifts</div>',
          name: key.charAt(0).toUpperCase() + key.slice(1),
          value: index,
          class: 'td',
          allSelected: false
        };
        this.weekdays.push({
          text: key.charAt(0).toUpperCase() + key.slice(1),
          value: index
        });
        index++;
      }
      this.emptyWorkArea.scheduler.oneDay.fields = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(fields));
    },
    updateShiftsTableData: function updateShiftsTableData() {
      var _this2 = this;

      var fromIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var _loop = function _loop(workAreasIndex) {
        var byShift = _this2.formData.workAreas[workAreasIndex].scheduler.byShift;
        var oneDay = _this2.formData.workAreas[workAreasIndex].scheduler.oneDay;
        byShift.items = [];

        var _loop2 = function _loop2(key) {
          var self = _this2;
          var shiftsList = _this2.shifts[key].filter(function (item) {
            if (!self.formData.workAreas[workAreasIndex].area.length) {
              return false;
            }
            if (!self.formData.workAreas[workAreasIndex].area[0].custom_shifts) {
              return item.area === null;
            }
            return item.area == self.formData.workAreas[workAreasIndex].area[0].id;
          });
          for (var i = 0; i < shiftsList.length; i++) {
            if (byShift.items.length <= i) {
              byShift.items.push({});
            }
            byShift.items[i][key] = {
              value: shiftsList[i].time,
              id: shiftsList[i].id,
              checked: shiftsList[i].checked
            };
          }
        };

        for (var key in _this2.shifts) {
          _loop2(key);
        }
        oneDay.items = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(byShift.items));
        _this2.updateOneDayShifts(oneDay);
      };

      for (var workAreasIndex = fromIndex; workAreasIndex < this.formData.workAreas.length; workAreasIndex++) {
        _loop(workAreasIndex);
      }
    },
    updateOneDayShifts: function updateOneDayShifts(item) {
      function clearChecked(items) {
        for (var key in items) {
          items[key].checked = false;
        }
      }
      if (!item.date) {
        return;
      }
      var weekday = new Date(item.date).getDay();
      if (!isNaN(weekday) && weekday != null) {
        // if (weekday === 0) {
        //   weekday = 7;
        // }
        weekday += 1;
        console.log(weekday);
        item.field = {};
        item.item = [];
        item.isNotChecked = true;
        for (var key in item.fields) {
          if (item.fields[key].value == weekday) {
            item.field[key] = item.fields[key];
            for (var i = 0; i < item.items.length && item.items[i][key]; i++) {
              clearChecked(item.items[i]);
              item.item.push(item.items[i]);
            }
            console.log(key);
            return;
          }
        }
      }
    },
    onClickShift: function onClickShift(items, key, index) {
      var item = items.items[index][key];
      item.checked = !item.checked;
      var flagAllChecked = this.isSelectedAllShifts(items, key);
      items.fields[key].allSelected = flagAllChecked;
      items.items.push({});
      items.items.splice(items.items.length - 1, 1);
      items.isNotChecked = true && !items.fields[key].allSelected;
      if (!items.isNotChecked) return;
      for (var i = 0; i < items.items.length; i++) {
        for (var weekdayKey in items.items[i]) {
          if (items.items[i][weekdayKey] && items.items[i][weekdayKey].checked) {
            items.isNotChecked = false;
          }
        }
      }
    },
    isSelectedAllShifts: function isSelectedAllShifts(item, key) {
      var flagAllChecked = true;
      for (var i = 0; i < item.items.length; i++) {
        if (item.items[i][key]) {
          flagAllChecked = flagAllChecked && item.items[i][key].checked;
        }
      }
      return flagAllChecked;
    },
    onSelectAllShifts: function onSelectAllShifts(key, item) {
      var flagAllChecked = this.isSelectedAllShifts(item, key);
      for (var i = 0; i < item.items.length; i++) {
        if (item.items[i][key]) {
          item.items[i][key].checked = !flagAllChecked;
        }
      }
      item.fields[key].allSelected = !flagAllChecked;
      item.items.push({});
      item.items.splice(item.items.length - 1, 1);
      item.isNotChecked = true;
      if (!item.isNotChecked) return;
      for (var _i = 0; _i < item.items.length; _i++) {
        for (var weekDayKey in item.items[_i]) {
          if (item.items[_i][weekDayKey] && item.items[_i][weekDayKey].checked) {
            item.isNotChecked = false;
          }
        }
      }
    },
    addOneMoreArea: function addOneMoreArea() {
      this.formData.workAreas.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.emptyWorkArea)));
      this.updateShiftsTableData(this.formData.workAreas.length - 1);
    },
    deleteOneArea: function deleteOneArea(index) {
      if (this.formData.workAreas[index].scheduler.id) {
        this.recurrenciesMustDelete.push(this.formData.workAreas[index].scheduler.id);
      }
      this.formData.workAreas.splice(index, 1);
    },
    addNewStep: function addNewStep() {
      var maxStepOrder = 0;
      var self = this;
      var orders = [];
      var orderCount = 1;
      for (var i = 0; i < self.formData.instructionSteps.length; i++) {
        orders.push(+self.formData.instructionSteps[i].order);
        if (maxStepOrder < self.formData.instructionSteps[i].order) {
          maxStepOrder = self.formData.instructionSteps[i].order;
        }
      }
      for (var _i2 = 1; _i2 <= +maxStepOrder + 1; _i2++) {
        if (orders.indexOf(_i2) === -1) {
          orderCount = _i2;
          break;
        }
      }
      self.formData.instructionSteps.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.emptyStep)));
      self.formData.instructionSteps[self.formData.instructionSteps.length - 1].order = orderCount;
    },
    removeStep: function removeStep(index) {
      if (this.formData.instructionSteps[index].id) {
        this.stepsMustDelete.push(this.formData.instructionSteps[index].id);
      }
      this.formData.instructionSteps.splice(index, 1);
    },
    processJSON: function processJSON(json) {
      return json.results;
    },
    getDataSearchArea: function getDataSearchArea(data, area, item) {
      item.area = [area.area];
      this.updateShiftsTableData();
    },

    // updateAreaCheckBoxByValue(item, area) {
    //
    // },
    updateDeeplinkData: function updateDeeplinkData() {
      if (!this.formData.deeplink.active) {
        this.formData.deeplink.id = null;
        this.formData.deeplink.item = 'checklist';
        this.formData.deeplink.badId = false;
        this.formData.deeplink.name = null;
      }
    },
    clearDeeplinkId: function clearDeeplinkId() {
      this.formData.deeplink.id = null;
      this.formData.deeplink.id = null;
      this.formData.deeplink.badId = false;
      this.formData.deeplink.name = null;
      // Using direct change because of jQuery breaking
      // v-model connection not updating input value from model
      var deeplink = document.getElementById('deeplink-id');
      deeplink.value = null;
    },
    checkDeeplinkId: function checkDeeplinkId() {
      var items = [];
      switch (this.formData.deeplink.item) {
        case 'task':
          items = this.taskTemplates;
          break;
        case 'audit':
          items = this.audits;
          break;
        case 'checklist':
          items = this.checklists;
          break;
        default:
          break;
      }
      console.log(items);
      this.formData.deeplink.badId = true;
      this.formData.deeplink.name = null;
      for (var i = 0; i < items.length; i++) {
        console.log(items[i].id);
        console.log(this.formData.deeplink.id);
        if (items[i].id === parseInt(this.formData.deeplink.id, 10)) {
          this.formData.deeplink.badId = false;
          this.formData.deeplink.name = items[i].name;
        }
      }
    },
    validateSteps: function validateSteps() {
      for (var i = 0; i < this.formData.instructionSteps.length; i++) {
        this.formData.instructionSteps[i].valid = true;
      }
      for (var _i3 = 0; _i3 < this.formData.instructionSteps.length; _i3++) {
        var currentOrder = this.formData.instructionSteps[_i3].order;
        for (var j = _i3 + 1; j < this.formData.instructionSteps.length; j++) {
          if (+this.formData.instructionSteps[j].order === currentOrder) {
            this.formData.instructionSteps[_i3].valid = false;
            this.formData.instructionSteps[j].valid = false;
          }
        }
      }
    },
    validateFormData: function validateFormData() {
      this.alertError.title = 'Error!';
      for (var i = 0; i < this.formData.instructionSteps.length; i++) {
        if (!this.formData.instructionSteps[i].valid) {
          this.alertError.text = 'Please correct instructions for the tasks';
          this.alertError.visible = true;
          return false;
        }
      }
      this.alertError.text = 'Some fields are not filled';
      this.needFill = true;
      if (!this.formData.name) {
        this.alertError.text = 'Please fill field "Title"';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.description) {
        this.alertError.text = 'Please fill field "Description"';
        this.alertError.visible = true;
        return false;
      }
      if (this.formData.selectedContent === 'video' && (this.formData.video_thumbnail || this.formData.img_thumbnail) && !(this.formData.video || this.formData.video_url)) {
        this.formData.video_require = true;
        this.alertError.text = 'Please add video file';
        this.alertError.visible = true;
        return false;
      }
      if (this.formData.selectedContent === 'video' && !(this.formData.video_thumbnail || this.formData.img_thumbnail) && (this.formData.video || this.formData.video_url)) {
        this.formData.video_require = true;
        this.alertError.text = 'Please add thumbnail image';
        this.alertError.visible = true;
        return false;
      }
      this.formData.video_require = false;
      this.checkDeeplinkId();
      if (this.formData.deeplink.active && this.formData.deeplink.badId) {
        this.alertError.text = 'Please correct "Deeplink to"';
        this.alertError.visible = true;
        return false;
      }
      // if (!this.formData.description_file && !this.formData.description_file_url) {
      //   for (let i = 0; i < this.formData.instructionSteps.length; i++) {
      //     if (!this.formData.instructionSteps[i].description) {
      //       this.alertError.text = 'WOOO!"';
      //       this.alertError.visible = true;
      //       return false;
      //     }
      //   }
      // }
      for (var _i4 = 0; _i4 < this.formData.instructionSteps.length; _i4++) {
        var step = this.formData.instructionSteps[_i4];
        step.video_require = false;
        if (step.selectedContent === 'video' && (step.video_thumbnail || step.img_thumbnail) && !(step.video || step.video_url)) {
          step.video_require = true;
          this.alertError.text = 'Please add video file';
          this.alertError.visible = true;
          return false;
        }
        if (step.selectedContent === 'video' && !(step.video_thumbnail || step.img_thumbnail) && (step.video || step.video_url)) {
          step.video_require = true;
          this.alertError.text = 'Please add thumbnail image';
          this.alertError.visible = true;
          return false;
        }
      }

      for (var _i5 = 0; _i5 < this.formData.workAreas.length; _i5++) {
        var workArea = this.formData.workAreas[_i5];
        if (!workArea.area.length) {
          this.alertError.text = 'Please select field "Working area"';
          this.alertError.visible = true;
          return false;
        }
        if (workArea.scheduler.type.selected === 0) {
          if (workArea.scheduler.fromDate === null && workArea.scheduler.toDate === null) {
            workArea.scheduler.forever = true;
          }
          if (!workArea.scheduler.forever && (workArea.scheduler.fromDate === null || Date(workArea.scheduler.fromDate) === 'Invalid Date')) {
            this.alertError.text = 'Please fill field "From date"';
            this.alertError.visible = true;
            return false;
          }
          if (!workArea.scheduler.forever && (workArea.scheduler.toDate === null || Date(workArea.scheduler.toDate) === 'Invalid Date')) {
            workArea.scheduler.toDate = null;
          }
          if (workArea.scheduler.tabIndex === 0) {
            var shifts = [];
            for (var j = 0; j < workArea.scheduler.byShift.items.length; j++) {
              for (var key in workArea.scheduler.byShift.items[j]) {
                if (workArea.scheduler.byShift.items[j][key].checked) {
                  shifts.push(workArea.scheduler.byShift.items[j][key].id);
                }
              }
            }
            if (!shifts.length) {
              this.alertError.text = 'Please select shifts';
              this.alertError.visible = true;
              return false;
            }
          }
          if (workArea.scheduler.tabIndex === 1 && (workArea.scheduler.weekly.recurWeek < 1 || !workArea.scheduler.weekly.is_once_per_week && !workArea.scheduler.weekly.selected.length)) {
            this.alertError.text = 'Please correct "Weekly"';
            this.alertError.visible = true;
            return false;
          }
          if (workArea.scheduler.tabIndex === 2) {
            var checkedFirst = document.getElementById('monthlyType-' + _i5 + '-1').checked;
            if (checkedFirst) {
              if (workArea.scheduler.monthly.recurDay.day < 1 || workArea.scheduler.monthly.recurDay.month < 1) {
                this.alertError.text = 'Please correct "Monthly"';
                this.alertError.visible = true;
                return false;
              }
            } else if (workArea.scheduler.monthly.recurWeekDay.month < 1) {
              this.alertError.text = 'Please correct "Monthly"';
              this.alertError.visible = true;
              return false;
            }
          }
        } else {
          if (!workArea.scheduler.oneDay.date) {
            this.alertError.text = 'Please enter date in recurrence';
            this.alertError.visible = true;
            return false;
          }
          var shift = [];
          for (var _j = 0; _j < workArea.scheduler.oneDay.item.length; _j++) {
            for (var _key in workArea.scheduler.oneDay.item[_j]) {
              if (workArea.scheduler.oneDay.item[_j][_key].checked) {
                shift.push(workArea.scheduler.oneDay.item[_j][_key].id);
              }
            }
          }
          // if (!shift.length) {
          //   this.alertError.text = 'Please select shift or change the date';
          //   this.alertError.visible = true;
          //   return false;
          // }
        }
      }
      this.needFill = false;
      return true;
    },
    deleteTask: function deleteTask() {
      this.$refs.delete_task.show();
    },
    taskMustDelete: function taskMustDelete() {
      var self = this;
      function allOk() {
        self.alertSuccess.text = 'Task successfully deleted, tab will be closed in 3 seconds';
        self.alertSuccess.visible = true;
        setTimeout(function () {
          window.close();
          //self.$router.push({ name: 'Tasks' });
        }, 3000);
      }
      function haveError() {
        self.alertError.text = 'Task did not deleted';
        self.alertError.visible = true;
        /*setTimeout(() => {
          self.$router.push({ name: 'Tasks' });
        }, 3000);*/
      }
      if (!this.taskId) {
        allOk();
        return;
      }
      this.sendDeleteTask().then(function (response) {
        if (response.status !== 200) {
          haveError();
          return;
        }
        allOk();
      }).catch(function () {
        haveError();
      });
    },
    sendDeleteTask: function sendDeleteTask() {
      var _this3 = this;

      return this.$http.patch('task-templates/' + this.taskId + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          return response;
        }
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this3.onLogout();
        }
        return response;
      });
    },
    convertDate: function convertDate(date) {
      function formatXX(val) {
        if (val < 10) return '0' + val;
        return '' + val;
      }
      if (!date) {
        return null;
      }
      var newDate = new Date(date);
      var result = String(newDate.getFullYear()) + '-' + formatXX(newDate.getMonth() + 1) + '-' + formatXX(newDate.getDate());
      return result;
    },
    calculateImagesCount: function calculateImagesCount() {
      var result = 0;
      if (this.formData.picture) {
        console.log('this.formData.picture');
        result++;
      }
      if (this.formData.description_file) {
        result++;
      }
      result += this.formData.instructionSteps.filter(function (item) {
        return item.picture;
      }).length;
      console.log('calculateImagesCount', result);
      return result;
    },
    uploadVideo: function uploadVideo(data) {
      var _this4 = this;

      var uploadData = {
        filename: data.name
      };
      if (this.$route.params.companyId) {
        uploadData.company = this.$route.params.companyId;
      }
      return this.$http.post('upload/', uploadData, {
        method: 'POST',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          _this4.alertError.text = _this4.getErrorText(response);
          return response.status;
        }
        return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(response.body.upload_url, data, {
          method: 'PUT',
          headers: __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common
          // {
          //   'content-type': 'video/mp4',
          // },
          // emulateJSON: true,
        }).then(function (resp) {
          if (response.status !== 200) {
            _this4.alertError.text = _this4.getErrorText(resp);
            return resp.status;
          }
          return response.body.final_url;
        }).catch(function (response) {
          if (response.status === 401) {
            _this4.onLogout();
          }
          _this4.alertError.text = _this4.getErrorText(response);
          return response;
        });
      }).catch(function (response) {
        if (response.status === 401) {
          _this4.onLogout();
        }
        _this4.alertError.text = _this4.getErrorText(response);
        return response;
      });
    },
    saveTaskVideo: function saveTaskVideo() {
      var _this5 = this;

      if (!this.formData.video || this.formData.selectedContent !== 'video') {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          resolve(false);
        });
      }
      return this.uploadVideo(this.formData.video).then(function (urlVideo) {
        console.log('uploadUrlVideo', urlVideo);
        _this5.formData.video_url = urlVideo;
        return null;
      });
    },

    // Deprecated
    // duplicateTask() {
    //   this.$router.push({ name: this.$route.name.replace('Change', 'Duplicate') });
    //   location.reload();
    //   // this.$router.go(this.$router.currentRoute);
    // },
    duplicateTask: function duplicateTask() {
      var _this6 = this;

      return this.$http.post('task-templates/' + this.taskId + '/duplicate/', {}, {
        method: 'POST',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('task duplication err', response);
          _this6.alertError.text = _this6.getErrorText(response);
          return response.status;
        }
        console.log('DUPLICATE RESPONSE', response);
        _this6.navigateTo(_this6.taskId, response.body.id);
        /*this.$router.push({ name: 'Task Configuration Change',
          params: { taskId: response.body.id } });*/
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this6.onLogout();
        }
        _this6.alertError.text = _this6.getErrorText(response);
        return response;
      });
    },
    saveTask: function saveTask() {
      var _this7 = this;

      var flagStandHere = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var self = this;
      // return self.saveTaskRecurrency(this.taskId);
      if (!this.validateFormData()) {
        return;
      }
      this.hasSaveError = false;
      // return;
      this.upload.total = this.calculateImagesCount();
      this.upload.uploaded = 0;
      this.upload.image = this.upload.total !== 0;
      this.upload.visible = true;
      this.saveTaskVideo().then(function () {
        return _this7.sendAddTaskTemplate();
      }).then(function (response) {
        if (response) {
          self.taskId = response;
          // if (!self.formData.description_file) {
          return self.saveTaskSteps(self.taskId);
          // }
        }
        console.log('sendAddTaskTemplate err', response);
        self.hasSaveError = true;
        return null;
      }).then(function () {
        return self.deleteTaskSteps(self.taskId);
      }).then(function () {
        if (self.taskId) {
          return self.saveTaskRecurrency(self.taskId);
        }
        console.log('err NO taskID after post/patch task', self.taskId);
        self.hasSaveError = true;
        _this7.upload.visible = false;
        return null;
      }).then(function () {
        if (self.hasSaveError) {
          console.log('saveEnd save has errors');
          self.alertError.text = 'There were errors during the upload';
          self.alertError.visible = true;
          _this7.upload.visible = false;
        } else {
          console.log('saveEnd success');
          if (flagStandHere) {
            self.alertSuccess.text = 'Saved successfully, a new tab will open in 3 seconds to add another Task';
          } else {
            self.alertSuccess.text = 'Saved successfully, tab will be closed in 3 seconds';
          }
          self.alertSuccess.visible = true;
          _this7.upload.visible = false;
          setTimeout(function () {
            //self.$router.push({ name: (flagStandHere) ? 'Task Configuration' : 'Tasks' });
            //location.reload();
            if (flagStandHere) {
              self.navigateTo(self.taskId, null);
            } else {
              window.close();
            }
            // this.$router.go(this.$router.currentRoute);
          }, 3000);
        }
      }).catch(function (response) {
        console.log('ERRR have catch', response);
        self.alertError.text = 'There were errors during the upload';
        self.alertError.visible = true;
        _this7.upload.visible = false;
      });
      // this.saveTaskRecurrency(taskId);
    },
    navigateTo: function navigateTo(taskIdToReplace, newTaskId) {
      var newUrl = window.location.href;
      var replacement = '';
      if (newTaskId) {
        replacement = '/' + newTaskId;
      }

      if (taskIdToReplace) {
        newUrl = newUrl.replace('/' + taskIdToReplace, replacement);
      }

      var win = window.open(newUrl, '_blank');
      win.focus();
      window.close();
    },
    saveTaskStepVideo: function saveTaskStepVideo(index) {
      var _this8 = this;

      if (!this.formData.instructionSteps[index].video) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          resolve(false);
        });
      }
      return this.uploadVideo(this.formData.instructionSteps[index].video).then(function (urlVideo) {
        _this8.formData.instructionSteps[index].video_url = urlVideo;
        return null;
      });
    },
    saveTaskSteps: function saveTaskSteps(taskId) {
      var self = this;
      if (!self.formData.instructionSteps.length) {
        return null;
      }
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var count = 0;

        var _loop3 = function _loop3(i) {
          self.saveTaskStepVideo(i).then(function () {
            return self.sendAddTaskStep(taskId, i);
          }).then(function (response) {
            if (response !== 201 && response !== 200) {
              console.log('sendAddTaskStep has err', response);
              self.hasSaveError = true;
            }
            count++;
            if (count === self.formData.instructionSteps.length) {
              resolve();
            }
          });
        };

        for (var i = 0; i < self.formData.instructionSteps.length; i++) {
          _loop3(i);
        }
      });
    },
    deleteTaskSteps: function deleteTaskSteps() {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!self.stepsMustDelete.length) return resolve();
        var count = 0;
        for (var i = 0; i < self.stepsMustDelete.length; i++) {
          self.sendDeleteTaskStep(self.stepsMustDelete[i]).then(function (response) {
            if (response.status !== 200) {
              console.log('sendDeleteTaskStep has err', response);
              self.hasSaveError = true;
            }
            count++;
            if (count === self.stepsMustDelete.length) {
              self.stepsMustDelete = [];
              resolve();
            }
          });
        }
        return null;
      });
    },
    saveTaskRecurrency: function saveTaskRecurrency(taskId) {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (self.formData.workAreas.length === 0) return resolve();
        var count = 0;
        var mustSaveCount = self.recurrenciesMustDelete.length + self.formData.workAreas.length;
        for (var i = 0; i < self.recurrenciesMustDelete.length; i++) {
          self.sendDeleteRecurrency(taskId, self.recurrenciesMustDelete[i]).then(function (response) {
            if (response != 201 && response != 200) {
              console.log('sendDeleteRecurrency has err', response);
              self.hasSaveError = true;
            }
            count++;
            if (count === mustSaveCount) {
              resolve();
            }
          });
        }
        for (var _i6 = 0; _i6 < self.formData.workAreas.length; _i6++) {
          self.sendAddRecurrency(taskId, _i6).then(function (response) {
            if (response != 201 && response != 200) {
              console.log('sendAddRecurrency has err', response);
              self.hasSaveError = true;
            }
            count++;
            if (count === mustSaveCount) {
              resolve();
            }
          });
        }
      });
    },
    sendDeleteRecurrency: function sendDeleteRecurrency(taskId, recurId) {
      var _this9 = this;

      return this.$http.patch('task-templates/' + taskId + '/recurrencies/' + recurId + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('recurrencies err', response);
          _this9.alertError.text = _this9.getErrorText(response);
          return response.status;
        }
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this9.onLogout();
        }
        _this9.alertError.text = _this9.getErrorText(response);
        return response;
      });
    },
    sendAddRecurrency: function sendAddRecurrency(taskId, recurIndex) {
      var _this10 = this;

      var self = this;
      // no recurrency, shifts, week, month
      var workArea = this.formData.workAreas[recurIndex];

      var type = 'no recurrency';
      if (workArea.scheduler.type.selected === 0) {
        switch (workArea.scheduler.tabIndex) {
          case 0:
            type = 'shifts';
            break;
          case 1:
            type = 'week';
            break;
          case 2:
            type = 'month';
            break;
          default:
            break;
        }
      }
      var shifts = [];
      for (var i = 0; i < workArea.scheduler.byShift.items.length; i++) {
        for (var key in workArea.scheduler.byShift.items[i]) {
          if (workArea.scheduler.byShift.items[i][key].checked) {
            shifts.push(workArea.scheduler.byShift.items[i][key].id);
          }
        }
      }
      // let shift = [];
      var oneTimeShifts = [];
      for (var _i7 = 0; _i7 < workArea.scheduler.oneDay.item.length; _i7++) {
        for (var _key2 in workArea.scheduler.oneDay.item[_i7]) {
          if (workArea.scheduler.oneDay.item[_i7][_key2].checked) {
            oneTimeShifts.push(workArea.scheduler.oneDay.item[_i7][_key2].id);
            // shift.push(workArea.scheduler.oneDay.item[i][key].id);
          }
        }
      }
      // shift = (shift.length) ? shift[0] : '';
      var data = {
        area: workArea.area && workArea.area.length ? workArea.area[0].id : null,
        type: type,
        date: this.convertDate(workArea.scheduler.oneDay.date),
        start_date: workArea.scheduler.forever ? null : this.convertDate(workArea.scheduler.fromDate),
        end_date: workArea.scheduler.forever ? null : this.convertDate(workArea.scheduler.toDate),
        // shift,
        one_time_shifts: oneTimeShifts,
        shifts: shifts,
        week: workArea.scheduler.weekly.recurWeek,
        // weekday: workArea.scheduler.weekly.selected,
        weekday0: workArea.scheduler.weekly.selected.indexOf(1) + 1 > 0,
        weekday1: workArea.scheduler.weekly.selected.indexOf(2) + 1 > 0,
        weekday2: workArea.scheduler.weekly.selected.indexOf(3) + 1 > 0,
        weekday3: workArea.scheduler.weekly.selected.indexOf(4) + 1 > 0,
        weekday4: workArea.scheduler.weekly.selected.indexOf(5) + 1 > 0,
        weekday5: workArea.scheduler.weekly.selected.indexOf(6) + 1 > 0,
        weekday6: workArea.scheduler.weekly.selected.indexOf(7) + 1 > 0,
        is_once_per_week: workArea.scheduler.weekly.is_once_per_week,
        is_once_per_month: workArea.scheduler.monthly.is_once_per_month,
        day: workArea.scheduler.monthly.recurDay.day,
        month: workArea.scheduler.monthly.recurDay.month,
        month_recurrency: 'day_of_month'
      };
      var monthlyType = document.getElementById('monthlyType-' + recurIndex + '-2');
      if (monthlyType && monthlyType.checked) {
        data.month_recurrency = 'weekday';
        data.weekday_number = workArea.scheduler.monthly.recurWeekDay.every;
        data.weekday = workArea.scheduler.monthly.recurWeekDay.weekDay;
        data.month = workArea.scheduler.monthly.recurWeekDay.month;
      }
      // return;
      if (!workArea.scheduler.id) {
        return this.$http.post('task-templates/' + taskId + '/recurrencies/', data, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
          // emulateJSON: true,
        }).then(function (response) {
          if (response.status !== 201) {
            console.log('recurrencies err', response);
            _this10.alertError.text = _this10.getErrorText(response);
            return response.status;
          }
          workArea.scheduler.id = response.body.id;
          return response.status;
        }).catch(function (response) {
          if (response.status === 401) {
            _this10.onLogout();
          }
          _this10.alertError.text = _this10.getErrorText(response);
          return response;
        });
      }
      return this.$http.patch('task-templates/' + taskId + '/recurrencies/' + workArea.scheduler.id + '/', data, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('recurrencies err', response);
          _this10.alertError.text = _this10.getErrorText(response);
          return response.status;
        }
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this10.onLogout();
        }
        _this10.alertError.text = _this10.getErrorText(response);
        return response;
      });
    },
    sendAddTaskStep: function sendAddTaskStep(taskId, stepIndex) {
      var _this11 = this;

      var self = this;
      var step = this.formData.instructionSteps[stepIndex];

      var data = {
        template: taskId,
        index: step.order,
        description: step.description,
        picture: step.selectedContent === 'image' ? step.picture : '',
        video: step.selectedContent === 'video' && step.video_url ? step.video_url : '',
        video_thumbnail: step.selectedContent === 'video' && step.video_url ? step.video_thumbnail : ''
      };
      var formData = new FormData();
      for (var key in data) {
        if (key !== 'picture' && key !== 'video_thumbnail') {
          formData.append(key, data[key]);
        }
      }
      if (!this.formData.instructionSteps[stepIndex].id) {
        formData.append('picture', data.picture);
        formData.append('video_thumbnail', data.video_thumbnail);
        // Deprecated
        // if (this.duplicate) {
        //   console.log('save task', data);
        //   if (data.video_thumbnail) {
        //     console.log('save task v', data);
        //     let blob = new Blob([data.video_thumbnail], { type : 'image/jpeg' });
        //     // let fileOfBlob = new File([blob], 'thumbnail.jpg', { type : 'image/jpeg' });
        //     // form.append("upload", fileOfBlob);
        //     // formData.append('video_thumbnail', fileOfBlob);
        //     formData.append('video_thumbnail', blob, 'thumbnail.jpg');
        //   }
        //   if (data.picture) {
        //     console.log('save task p', data);
        //     let blob = new Blob([data.picture], { type : 'image/jpeg' });
        //     // let fileOfBlob = new File([blob], 'photo.jpg', { type : 'image/jpeg' });
        //     // form.append("upload", fileOfBlob);
        //     // formData.append('picture', fileOfBlob);
        //     formData.append('picture', blob, 'photo.jpg');
        //   }
        // } else {
        //   formData.append('picture', data.picture);
        //   formData.append('video_thumbnail', data.video_thumbnail);
        // }
        return this.$http.post('task-steps/', formData, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
          // progress(e) {
          //   console.log('e', e);
          //   if (e.lengthComputable) {
          //     console.log((e.loaded / e.total) * 100);
          //   }
          // },
          // emulateJSON: true,
        }).then(function (response) {
          if (response.status !== 201) {
            console.log('POST step err ', response);
            _this11.alertError.text = _this11.getErrorText(response);
            return response.status;
          }
          self.formData.instructionSteps[stepIndex].id = response.body.id;
          if (data.picture) _this11.upload.uploaded++;
          return response.status;
        }).catch(function (response) {
          if (response.status === 401) {
            _this11.onLogout();
          }
          _this11.alertError.text = _this11.getErrorText(response);
          return response;
        });
      }
      console.log('step', step.selectedContent === 'picture', step.selectedContent);
      if (!(step.img && !step.picture)) {
        console.log('add picture', data);
        formData.append('picture', data.picture);
      }
      if (!(step.img_thumbnail && !step.video_thumbnail)) {
        formData.append('video_thumbnail', data.video_thumbnail);
      }
      return this.$http.patch('task-steps/' + this.formData.instructionSteps[stepIndex].id + '/', formData, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // progress(e) {
        //   console.log('e', e);
        //   if (e.lengthComputable) {
        //     console.log((e.loaded / e.total) * 100);
        //   }
        // },
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('PATCH step err', response);
          _this11.alertError.text = _this11.getErrorText(response);
          return response.status;
        }
        if (data.picture) _this11.upload.uploaded++;
        return response.status;
      }).catch(function (response) {
        if (response.status === 401) {
          _this11.onLogout();
        }
        _this11.alertError.text = _this11.getErrorText(response);
        return response;
      });
    },
    sendDeleteTaskStep: function sendDeleteTaskStep(stepId) {
      var _this12 = this;

      return this.$http.patch('task-steps/' + stepId + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('DELETE step err ', response);
          return response;
        }
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this12.onLogout();
        }
        _this12.alertError.text = _this12.getErrorText(response);
        return response;
      });
    },
    sendAddTaskTemplate: function sendAddTaskTemplate() {
      var _this13 = this;

      var form = this.formData;
      var data = {
        name: form.name,
        picture: form.selectedContent === 'image' ? form.picture : '',
        description: form.description,
        description_file: form.description_file,
        video: form.selectedContent === 'video' && form.video_url ? form.video_url : '',
        video_thumbnail: form.selectedContent === 'video' && form.video_url ? form.video_thumbnail : '',
        // area: 2,
        role: form.role
        // company_id: this.authUser.company.id,
      };
      if (!data.description_file) {
        data.description_file = '';
      }
      if (form.description_file_url) {
        delete data.description_file;
      }

      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      if (form.deeplink.active) {
        data.deeplink_to = form.deeplink.item;
        data.deeplink_id = form.deeplink.id;
      } else {
        data.deeplink_to = '';
        data.deeplink_id = '';
      }
      var formData = new FormData();
      for (var key in data) {
        if (key !== 'picture' && key !== 'video_thumbnail') {
          formData.append(key, data[key]);
        }
      }
      // return;
      if (!this.taskId) {
        formData.append('picture', data.picture);
        formData.append('video_thumbnail', data.video_thumbnail);
        // Deprecated
        // if (this.duplicate) {
        //   if (data.video_thumbnail) {
        //     let blob = new Blob([data.video_thumbnail], { type : 'image/jpeg' });
        //     // let fileOfBlob = new File([blob], 'thumbnail.jpg', { type : 'image/jpeg' });
        //     // form.append("upload", fileOfBlob);
        //     // formData.append('video_thumbnail', fileOfBlob);
        //     formData.append('video_thumbnail', blob, 'thumbnail.jpg');
        //   }
        //   if (data.picture) {
        //     let blob = new Blob([data.picture], { type : 'image/jpeg' });
        //     // let fileOfBlob = new File([blob], 'photo.jpg', { type : 'image/jpeg' });
        //     // form.append("upload", fileOfBlob);
        //     // formData.append('picture', fileOfBlob);
        //     formData.append('picture', blob, 'photo.jpg');
        //   }
        // } else {
        //   formData.append('picture', data.picture);
        //   formData.append('video_thumbnail', data.video_thumbnail);
        // }
        return this.$http.post('task-templates/', formData, {
          method: 'POST',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
          // emulateJSON: true,
        }).then(function (response) {
          if (response.status !== 201) {
            console.log('POST task err', response);
            _this13.alertError.text = _this13.getErrorText(response);
            return null;
          }
          if (data.picture) _this13.upload.uploaded++;
          if (data.video_thumbnail) _this13.upload.uploaded++;
          return response.body.id;
        }).catch(function (response) {
          if (response.status === 401) {
            _this13.onLogout();
          }
          _this13.alertError.text = _this13.getErrorText(response);
          return response;
        });
      }
      if (!(form.img && !form.picture)) {
        formData.append('picture', data.picture);
      }
      if (!(form.img_thumbnail && !form.video_thumbnail)) {
        formData.append('video_thumbnail', data.video_thumbnail);
      }
      return this.$http.patch('task-templates/' + this.taskId + '/', formData, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log('PATCH', response);
          // that.$set(that, 'moduleError', true);
          _this13.alertError.text = _this13.getErrorText(response);
          return null;
        }
        if (data.picture) _this13.upload.uploaded++;
        if (data.video_thumbnail) _this13.upload.uploaded++;
        return response.body.id;
      }).catch(function (response) {
        if (response.status === 401) {
          _this13.onLogout();
        }
        _this13.alertError.text = _this13.getErrorText(response);
        return response;
      });
    },
    getWorkingAreas: function getWorkingAreas() {
      var _this14 = this;

      var url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = url + '&company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          _this14.alertError.text = _this14.getErrorText(response);
          return;
        }
        // response.body.activeId = false;
        // this.areas = [];
        // this.areas.push(response.body);
        _this14.areas = response.body;
        // return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this14.onLogout();
        }
      });
    },
    sortShifts: function sortShifts(shifts) {
      shifts.sort(function (a, b) {
        if (a.start === b.start) {
          return a.end > b.end;
        }
        return a.start > b.start;
      });
    },
    getShiftList: function getShiftList() {
      var _this15 = this;

      var url = 'shifts/';
      if (this.$route.params.companyId) {
        url = url + '?company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          _this15.alertError.text = _this15.getErrorText(response);
          return;
        }
        _this15.shifts = {
          monday: [],
          tuesday: [],
          wednesday: [],
          thursday: [],
          friday: [],
          saturday: [],
          sunday: []
        };
        _this15.sortShifts(response.body);
        for (var i = 0; i < response.body.length; i++) {
          for (var key in _this15.formData.workAreas[0].scheduler.byShift.fields) {
            if (_this15.formData.workAreas[0].scheduler.byShift.fields[key].value === response.body[i].day) {
              var time = response.body[i].start.split(':')[0] + ':' + response.body[i].start.split(':')[1] + '-' + response.body[i].end.split(':')[0] + ':' + response.body[i].end.split(':')[1];
              var newData = {
                id: response.body[i].id,
                time: time,
                checked: false,
                area: response.body[i].area
              };
              _this15.shifts[key].push(newData);
            }
          }
        }
        _this15.updateShiftsTableData();
      }).catch(function (response) {
        if (response.status === 401) {
          _this15.onLogout();
        }
      });
    },
    selectedAreaChanged: function selectedAreaChanged(area) {
      console.log('areachanged', area[0].name);
    },
    updateSuggestArea: function updateSuggestArea() {
      this.formData.suggestArea = [];
      var areaPaths = this.getUserAreaPath(this.areas);
      for (var i = 0; i < areaPaths.length; i++) {
        this.formData.suggestArea.push(areaPaths[i]);
      }
    },
    getUserAreaPath: function getUserAreaPath(area) {
      var result = [];
      for (var i = 0; i < area.length; i++) {
        var res = this.getUserAreaPath(area[i].subareas);
        for (var j = 0; j < res.length; j++) {
          result.push({ name: area[i].name + '/' + res[j].name, area: res[j].area });
        }
        if (res.length === 0) {
          result.push({ name: area[i].name, area: area[i] });
        }
      }
      return result;
    },
    getTaskTemplatesList: function getTaskTemplatesList() {
      var _this16 = this;

      var url = 'task-templates/' + this.$route.params.taskId;
      this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return;
        }
        _this16.taskTemplates = [response.body];
        _this16.fillAllData();
      }).catch(function (response) {
        if (response.status === 401) {
          _this16.onLogout();
        }
      });
    },
    getAuditsList: function getAuditsList() {
      var _this17 = this;

      var url = 'audit-templates/';
      if (this.$route.params.companyId) {
        url = url + '?company=' + this.$route.params.companyId;
      }
      this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          _this17.alertError.text = _this17.getErrorText(response);
          return;
        }
        _this17.audits = response.body;
      }).catch(function (response) {
        if (response.status === 401) {
          _this17.onLogout();
        }
      });
    },
    getChecklistList: function getChecklistList() {
      var _this18 = this;

      var url = 'checklist-templates/';
      if (this.$route.params.companyId) {
        url = url + '?company=' + this.$route.params.companyId;
      }
      this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          _this18.alertError.text = _this18.getErrorText(response);
          return;
        }
        _this18.checklists = response.body;
      }).catch(function (response) {
        if (response.status === 401) {
          _this18.onLogout();
        }
      });
    },
    clearVideo: function clearVideo(e) {
      if (this.formData.video_url) {
        this.formData.video_url = '';
        this.$refs.videofile.reset();
        e.preventDefault();
        return;
      }
      if (!this.formData.video) {
        return;
      }
      this.$refs.videofile.reset();
      e.preventDefault();
    },
    clearStepVideo: function clearStepVideo(e, step, index) {
      if (step.video_url) {
        step.video_url = '';
        this.$refs.stepvideofile[index].reset();
        e.preventDefault();
        return;
      }
      if (!step.video) {
        return;
      }
      this.$refs.stepvideofile[index].reset();
      e.preventDefault();
    },
    clearPdfFile: function clearPdfFile(e) {
      if (this.formData.description_file_url) {
        this.formData.description_file_url = '';
        this.$refs.pdffile.reset();
        e.preventDefault();
        return;
      }
      if (!this.formData.description_file) {
        return;
      }
      this.$refs.pdffile.reset();
      e.preventDefault();
    },
    changePdfFile: function changePdfFile() {
      if (!this.formData.description_file) {
        return null;
      }
      if (this.formData.description_file && this.formData.description_file.size > 5000000) {
        this.$refs.pdffile.reset();
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
      }
      return null;
    },
    getBackUrl: function getBackUrl() {
      return "" + '/';
    },
    fillTestParam: function fillTestParam() {
      this.formData.name = 'test create task cascade 3';
      this.formData.description = 'description2';
    },
    getAreaById: function getAreaById(id) {
      var area = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.areas;

      for (var i = 0; i < area.length; i++) {
        if (area[i].id === id) {
          return area[i];
        }
        var res = this.getAreaById(id, area[i].subareas);
        if (res) {
          return res;
        }
      }
      return null;
    },
    downloadImage: function downloadImage(url) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, {
        headers: __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common,
        responseType: 'arraybuffer'
      }).then(function (resp) {
        if (resp.status !== 200) {
          return null;
        }
        return resp.data;
      }).catch(function (response) {
        console.log('download complite error', response);
        if (response.status === 401) {
          _this19.onLogout();
        }
        _this19.alertError.text = _this19.getErrorText(response);
        return null;
      });
    },
    fillAllData: function fillAllData() {
      var _this20 = this;

      // function getFilenameFromUrl(url) {
      //   if (!url) return null;
      //   let result = url.split('/');
      //   result = result[result.length - 1];
      //   return result;
      // }
      if (!this.taskId) {
        return;
      }
      for (var i = 0; i < this.taskTemplates.length; i++) {
        if (this.taskTemplates[i].id !== this.taskId) continue;
        // Deprecated
        // if (this.taskId && this.duplicate) {
        //   this.taskId = 0;
        // }
        this.formData.name = this.taskTemplates[i].name;
        this.formData.description = this.taskTemplates[i].description;
        this.formData.role = this.taskTemplates[i].role;
        // this.formData.img = getFilenameFromUrl(this.taskTemplates[i].picture);
        this.formData.img = this.taskTemplates[i].picture;
        this.formData.img_thumbnail = this.taskTemplates[i].video_thumbnail;
        this.formData.video_url = this.taskTemplates[i].video;
        if (this.formData.img) {
          this.formData.selectedContent = 'image';
        }
        if (this.formData.video_url) {
          this.formData.img = '';
          this.formData.selectedContent = 'video';
        }
        // Deprecated
        // if (this.duplicate) {
        //   if (this.formData.img) {
        //     this.downloadImage(this.formData.img)
        //     .then((resp) => {
        //       if (resp) {
        //         this.formData.picture = resp;
        //       }
        //     })
        //     .catch((resp) => {
        //       console.log('err', resp);
        //     });
        //   }
        //   if (this.formData.img_thumbnail) {
        //     this.downloadImage(this.formData.img_thumbnail)
        //     .then((resp) => {
        //       if (resp) {
        //         this.formData.video_thumbnail = resp;
        //       }
        //     })
        //     .catch((resp) => {
        //       console.log('err', resp);
        //     });
        //   }
        // }
        this.formData.description_file_url = this.taskTemplates[i].description_file;
        if (this.taskTemplates[i].deeplink_id && this.taskTemplates[i].deeplink_to) {
          this.formData.deeplink.active = true;
          this.formData.deeplink.item = this.taskTemplates[i].deeplink_to;
          this.formData.deeplink.id = this.taskTemplates[i].deeplink_id;
        }
        for (var j = 0; j < this.taskTemplates[i].steps.length; j++) {
          var step = this.taskTemplates[i].steps[j];
          while (this.formData.instructionSteps.length < j + 1) {
            this.addNewStep();
          }
          // Deprecated
          // if (!this.duplicate) {
          //   this.formData.instructionSteps[j].id = step.id;
          // }
          this.formData.instructionSteps[j].id = step.id;
          this.formData.instructionSteps[j].order = step.index;
          this.formData.instructionSteps[j].description = step.description;
          // this.formData.instructionSteps[j].img = getFilenameFromUrl(step.picture);
          this.formData.instructionSteps[j].img = step.picture;
          this.formData.instructionSteps[j].valid = true;
          this.formData.instructionSteps[j].img_thumbnail = step.video_thumbnail;
          this.formData.instructionSteps[j].video_url = step.video;
          if (this.formData.instructionSteps[j].img) {
            this.formData.instructionSteps[j].selectedContent = 'image';
          }
          if (this.formData.instructionSteps[j].video_url) {
            this.formData.instructionSteps[j].img = '';
            this.formData.instructionSteps[j].selectedContent = 'video';
          }
          // Deprecated
          // if (this.duplicate) {
          //   if (this.formData.instructionSteps[j].img) {
          //     this.downloadImage(this.formData.instructionSteps[j].img)
          //     .then((resp) => {
          //       if (resp) {
          //         this.formData.instructionSteps[j].picture = resp;
          //       }
          //     })
          //     .catch((resp) => {
          //       console.log('err', resp);
          //     });
          //   }
          //   if (this.formData.instructionSteps[j].img_thumbnail) {
          //     this.downloadImage(this.formData.instructionSteps[j].img_thumbnail)
          //     .then((resp) => {
          //       if (resp) {
          //         this.formData.instructionSteps[j].video_thumbnail = resp;
          //       }
          //     })
          //     .catch((resp) => {
          //       console.log('err', resp);
          //     });
          //   }
          // }
        }

        var _loop4 = function _loop4(_j2) {
          var recurrence = _this20.taskTemplates[i].recurrencies[_j2];
          // if (!recurrence.is_active) continue;
          console.log('recurrence', recurrence);
          if (!_this20.getAreaById(recurrence.area)) {
            console.log('no area id=', recurrence.area);
            return 'continue';
          }
          while (_this20.formData.workAreas.length < _j2 + 1) {
            _this20.addOneMoreArea();
          }
          _this20.formData.workAreas[_j2].area.push(_this20.getAreaById(recurrence.area));
          // Deprecated
          // if (!this.duplicate) {
          //   this.formData.workAreas[j].scheduler.id = recurrence.id;
          // }
          _this20.formData.workAreas[_j2].scheduler.id = recurrence.id;
          _this20.formData.workAreas[_j2].scheduler.fromDate = recurrence.start_date;
          _this20.formData.workAreas[_j2].scheduler.toDate = recurrence.end_date;
          _this20.formData.workAreas[_j2].scheduler.forever = !(recurrence.start_date || recurrence.end_date);
          if (recurrence.type === 'no recurrency') {
            _this20.formData.workAreas[_j2].scheduler.type.selected = 1;
            _this20.formData.workAreas[_j2].scheduler.oneDay.date = recurrence.date;
            _this20.formData.workAreas[_j2].scheduler.oneDay.shifts = recurrence.one_time_shifts;
          } else {
            _this20.formData.workAreas[_j2].scheduler.type.selected = 0;
            if (recurrence.type === 'shifts') {
              _this20.formData.workAreas[_j2].scheduler.tabIndex = 0;
            }
            if (recurrence.type === 'week') {
              _this20.formData.workAreas[_j2].scheduler.tabIndex = 1;
              _this20.formData.workAreas[_j2].scheduler.weekly.recurWeek = recurrence.week;
              _this20.formData.workAreas[_j2].scheduler.weekly.is_once_per_week = recurrence.is_once_per_week === true;
              _this20.formData.workAreas[_j2].scheduler.weekly.selected = [];
              for (var weekday = 0; weekday < 7; weekday++) {
                if (recurrence['weekday' + weekday]) {
                  _this20.formData.workAreas[_j2].scheduler.weekly.selected.push(weekday + 1);
                }
              }
            }
            if (recurrence.type === 'month') {
              _this20.formData.workAreas[_j2].scheduler.tabIndex = 2;
              _this20.formData.workAreas[_j2].scheduler.monthly.recurDay.day = recurrence.day;
              _this20.formData.workAreas[_j2].scheduler.monthly.recurDay.month = recurrence.month;
              _this20.formData.workAreas[_j2].scheduler.monthly.is_once_per_month = recurrence.is_once_per_month === true;
              // month_recurrency (weekday или day_of_month)
              if (recurrence.month_recurrency === 'weekday') {
                setTimeout(function () {
                  document.getElementById('monthlyType-' + _j2 + '-2').checked = true;
                }, 1);
                _this20.formData.workAreas[_j2].scheduler.monthly.recurWeekDay.every = recurrence.weekday_number;
                _this20.formData.workAreas[_j2].scheduler.monthly.recurWeekDay.weekDay = recurrence.weekday ? recurrence.weekday : 1;
                _this20.formData.workAreas[_j2].scheduler.monthly.recurWeekDay.month = recurrence.month;
              }
            }
          }
          // this.formData.workAreas[j].scheduler.shifts
        };

        for (var _j2 = 0; _j2 < this.taskTemplates[i].recurrencies.length; _j2++) {
          var _ret4 = _loop4(_j2);

          if (_ret4 === 'continue') continue;
        }
        this.updateShiftsTableData();
        for (var _j3 = 0; _j3 < this.formData.workAreas.length; _j3++) {
          var _recurrence = this.taskTemplates[i].recurrencies[_j3];
          var workArea = this.formData.workAreas[_j3].scheduler.byShift;
          for (var itemIndex = 0; itemIndex < workArea.items.length; itemIndex++) {
            for (var key in workArea.items[itemIndex]) {
              workArea.items[itemIndex][key].checked = false;
              if (_recurrence.shifts.indexOf(workArea.items[itemIndex][key].id) + 1) {
                workArea.items[itemIndex][key].checked = true;
              }
            }
          }
          var workAreaOneDay = this.formData.workAreas[_j3].scheduler.oneDay;
          for (var _itemIndex = 0; _itemIndex < workAreaOneDay.items.length; _itemIndex++) {
            for (var _key3 in workAreaOneDay.items[_itemIndex]) {
              workAreaOneDay.items[_itemIndex][_key3].checked = false;
              if (_recurrence.one_time_shifts.indexOf(workAreaOneDay.items[_itemIndex][_key3].id) + 1) {
                workAreaOneDay.items[_itemIndex][_key3].checked = true;
              }
            }
          }
        }
        this.processLoading = false;
        return;
      }
      this.processLoading = false;
      this.alertError.text = 'Task not found';
      this.alertError.visible = true;
      // setTimeout(() => this.$router.push({ name: 'Tasks' }), 3000);
    },
    getErrorText: function getErrorText(response) {
      var result = 'There were errors during the upload (' + response.status + ')';
      if (response.status === 400) {
        if (!response.body) {
          return 'Large file';
        }
        for (var key in response.body) {
          return key + ': ' + response.body[key];
        }
      }
      if (response.status === 401) {
        return 'Invalid authorization, please relogin';
      }
      if (response.status === 404) {
        return 'Not found (404)';
      }
      if (response.status === 500) {
        return 'Internal server error';
      }
      return result;
    },
    initData: function initData() {
      var _this21 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.apply(this));
      // this.fillTestParam();
      this.taskId = +this.$route.params.taskId;
      // this.taskId = 354;
      if (this.taskId) {
        this.processLoading = true;
      }
      this.getCompany();
      // this.createUserRoles();
      this.createShiftsField();
      // this.addNewStep();
      this.addOneMoreArea();
      this.getWorkingAreas().then(function () {
        return _this21.getShiftList();
      }).then(function () {
        return _this21.getTaskTemplatesList();
      }).catch(function () {
        _this21.alertError.text = 'An error occurred while loading the data. Please refresh the page.';
        _this21.alertError.visible = true;
        _this21.processLoading = false;
      });
      this.getAuditsList();
      this.getChecklistList();
    }
  },
  computed: {},
  created: function created() {
    this.initData();
  },

  watch: {
    $route: function $route(to, from) {
      if (to.name === 'Task Configuration Change' || to.name === 'Task Configuration Change SuperUser') {
        this.processLoading = true;
        this.taskId = to.params.taskId;
        this.formData.id = to.params.taskId;
        this.initData();
      }
    },
    areas: function areas() {
      this.updateSuggestArea();
    }
  }
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_debounce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_v_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_v_debounce__);




var spinner = __webpack_require__(10).spinner;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tasks',
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_1__header___, spinner: spinner },
  props: ['onLogout', 'access_token', 'authUser'],
  mounted: function mounted() {},
  data: function data() {
    return {
      formData: {
        tasks: [],
        filteredTask: [],
        taskFields: {
          index: {
            label: '#',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          id: {
            label: 'ID',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          name: {
            label: 'Text',
            tdClass: 'text-left',
            thClass: 'text-center'
          },
          area: {
            label: 'Working area',
            tdClass: 'text-left',
            thClass: 'text-center'
          },
          role: {
            label: 'Access',
            tdClass: 'text-left',
            thClass: 'text-center'
          },
          recurrence: {
            label: 'Recurrence',
            // tdClass: 'text-left',
            thClass: 'text-center'
          }
        }
      },
      currentPage: 1,
      perPage: 10,
      recurrenceFields: {
        area: {
          label: 'area'
        },
        recurrence: {
          label: 'recurr'
        }
      },
      areas: [],
      filter: '',
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Tasks',
        active: true
      }],
      roles: {
        basic: 'Basic user',
        shift_leader: 'Shift Leader',
        manager: 'Manager'
      },
      processLoading: false,
      processText: 'Loading...',
      dragSrcEl: null,
      dragBtn: false,
      mustDragToNextPage: true,
      shifts: [],
      weekdays: {
        weekday0: 'Sunday',
        weekday1: 'Monday',
        weekday2: 'Tuesday',
        weekday3: 'Wednesday',
        weekday4: 'Thursday',
        weekday5: 'Friday',
        weekday6: 'Saturday'
      },
      weekNumbersItem: [{ text: 'First', value: 1 }, { text: 'Second', value: 2 }, { text: 'Third', value: 3 }, { text: 'Fourth', value: 4 }],
      weekDaysName: [{ label: 'Monday', value: 2 }, { label: 'Tuesday', value: 3 }, { label: 'Wednesday', value: 4 }, { label: 'Thursday', value: 5 }, { label: 'Friday', value: 6 }, { label: 'Saturday', value: 7 }, { label: 'Sunday', value: 1 }]

    };
  },

  methods: {
    getWeekNumbersItem: function getWeekNumbersItem(id) {
      for (var item in this.weekNumbersItem) {
        if (this.weekNumbersItem[item].value === id) return this.weekNumbersItem[item].text;
      }
      return '';
    },
    getDaysName: function getDaysName(id) {
      for (var item in this.weekDaysName) {
        if (this.weekDaysName[item].value === id) return this.weekDaysName[item].label;
      }
      return '';
    },
    getShiftById: function getShiftById(id) {
      for (var i = 0; i < this.shifts.length; i++) {
        if (this.shifts[i].id === id) {
          return this.shifts[i];
        }
      }
      return null;
    },
    getShiftTime: function getShiftTime(shift) {
      if (!shift) return '';
      var start = shift.start.split(':');
      var end = shift.end.split(':');
      var weekday = this.getDaysName(shift.day);
      return weekday + ' ' + start[0] + ':' + start[1] + '-' + end[0] + ':' + end[1];
    },
    isInFilter: function isInFilter(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item).toLowerCase().indexOf(this.filter.toLowerCase()) + 1 > 0;
    },
    filteredIndex: function filteredIndex(item) {
      return this.formData.filteredTask.indexOf(item);
    },
    getAddTaskUrl: function getAddTaskUrl() {
      return "" + '/constructor/TaskConstructor';
    },
    onAddTaskClick: function onAddTaskClick() {
      console.log('onAddTaskClick');
      this.navigateTo("TaskConstructor", null);
    },
    onRowClick: function onRowClick(item) {
      // alert(item);
      console.log('onclick', item);
      this.navigateTo("TaskConstructor", item.id);
      // this.$router.push(this.getAddTaskUrl());
      //this.$router.push({ name: 'Task Configuration Change', params: { taskId: item.id } });
    },
    navigateTo: function navigateTo(pageName, taskId) {
      var newUrl = window.location.href;

      var replacement = "/" + pageName;
      if (taskId) {
        replacement += "/" + taskId;
      }

      newUrl = newUrl.replace('/tasks', replacement);
      newUrl = newUrl.replace('/Tasks', replacement);

      var win = window.open(newUrl, '_blank');
      win.focus();
    },
    getTaskTemplatesList: function getTaskTemplatesList() {
      var _this = this;

      var url = 'task-templates/?type=task';
      if (this.$route.params.companyId) {
        url = url + '&company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return null;
        }
        _this.formData.tasks = response.body;
        _this.formData.tasks.sort(function (a, b) {
          return a.index - b.index;
        });
        _this.formData.filteredTask = _this.formData.tasks;
        _this.processLoading = false;
        return response.body;
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
      });
    },
    getWorkingAreas: function getWorkingAreas() {
      var _this2 = this;

      var url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = url + '&company=' + this.$route.params.companyId;
      }
      this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return null;
        }
        _this2.areas = response.body;
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this2.onLogout();
        }
      });
    },


    // getRecurrence(self, task) {
    //   self.$http.get('task-templates/' + task.id + '/recurrencies/',
    //     {
    //       method: 'GET',
    //       headers: {
    //         Authorization: `Token ${this.access_token}`,
    //       },
    //       // emulateJSON: true,
    //     })
    //     .then((response) => {
    //       if (response.status !== 200) {
    //         console.log(response);
    //         return;
    //       }
    //       console.log('good recurrence', response);
    //       // task.recurrence = JSON.parse(JSON.stringify(response.body));
    //       task.recurrence = [{ area: 16, type: 'week' },{ area: 24, type: 'month' }];
    //       console.log('task ', task);
    //       // this.areas = response.body;
    //       // return response;
    //     });
    // },
    getWorkingAreasListById: function getWorkingAreasListById(id, areas) {
      var result = [];
      for (var i = 0; i < areas.length; i++) {
        if (areas[i].id == id) {
          result = [areas[i]];
          return result;
        }
        result = this.getWorkingAreasListById(id, areas[i].subareas);
        if (result.length) {
          result.unshift(areas[i]);
          return result;
        }
      }
      return result;
    },
    updateCompany: function updateCompany() {
      var _this3 = this;

      this.processText = 'Loading...';
      var url = 'companies/';
      if (this.$route.params.companyId) {
        url = '' + url + this.$route.params.companyId + '/';
      } else {
        if (this.authUser.company.id) {
          url = '' + url + this.authUser.company.id + '/';
        } else {
          return;
        }
      }
      this.$http.get(url, {
        method: 'get',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return response;
        }
        if (response.body.manager_role_display_name) {
          _this3.roles.manager = response.body.manager_role_display_name;
        }
        if (response.body.shift_leader_role_display_name) {
          _this3.roles.shift_leader = response.body.shift_leader_role_display_name;
        }
        if (response.body.basic_role_display_name) {
          _this3.roles.basic = response.body.basic_role_display_name;
        }
        return null;
      }).catch(function (response) {
        if (response.status === 401) {
          _this3.onLogout();
        }
      });
    },
    getShiftList: function getShiftList() {
      var _this4 = this;

      var url = 'shifts/';
      if (this.$route.params.companyId) {
        url = url + '?company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          _this4.alertError.text = _this4.getErrorText(response);
          return;
        }
        _this4.shifts = response.body;
      }).catch(function (response) {
        if (response.status === 401) {
          _this4.onLogout();
        }
      });
    },
    handleBtnMouseEvent: function handleBtnMouseEvent(flag) {
      this.dragBtn = flag;
    },
    handleDragStart: function handleDragStart(e, item, index) {
      if (!this.dragBtn) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        if (e.stopPropagation) {
          e.stopPropagation(); // Stops some browsers from redirecting.
        }
        return;
      }
      this.mustDragToNextPage = true;
      this.dragBtn = false;
      e.target.style.opacity = '0.4';
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text', index.toString());
      this.dragSrcEl = index;
    },
    handleDragEnd: function handleDragEnd(e, item, index) {
      e.target.style.opacity = '';
    },
    saveTaskIndex: function saveTaskIndex(task) {
      var _this5 = this;

      var data = { index: task.index };
      return this.$http.patch('task-templates/' + task.id + '/', data, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return null;
        }
        return response.body;
      }).catch(function (response) {
        if (response.status === 401) {
          _this5.onLogout();
        }
        return response;
      });
    },
    updateTaskIndex: function updateTaskIndex() {
      var _this6 = this;

      for (var i = 0; i < this.formData.tasks.length; i++) {
        this.formData.tasks[i].index = +i + 1;
      }
      var savedTasksCount = 0;
      for (var _i = 0; _i < this.formData.tasks.length; _i++) {
        this.processLoading = true;
        this.processText = 'Saving...';
        this.saveTaskIndex(this.formData.tasks[_i]).then(function (response) {
          savedTasksCount++;
          if (savedTasksCount === _this6.formData.tasks.length) {
            _this6.processLoading = false;
          }
        }).catch(function () {
          savedTasksCount++;
          if (savedTasksCount === _this6.formData.tasks.length) {
            _this6.processLoading = false;
          }
        });
      }
    },
    handleDrop: function handleDrop(e, index) {
      console.log('handleDrop()', index);
      if (e.stopPropagation) {
        e.stopPropagation(); // Stops some browsers from redirecting.
      }
      // Don't do anything if dropping the same column we're dragging.
      if (this.dragSrcEl !== index) {
        this.dragSrcEl = index;
        var newIndex = e.dataTransfer.getData('text');
        if (newIndex < this.dragSrcEl) {
          this.formData.tasks.splice(+this.dragSrcEl + 1, 0, this.formData.tasks[newIndex]);
          this.formData.tasks.splice(newIndex, 1);
        } else {
          this.formData.tasks.splice(+this.dragSrcEl, 0, this.formData.tasks[newIndex]);
          this.formData.tasks.splice(+newIndex + 1, 1);
        }
        this.activeTask = this.dragSrcEl;
        this.updateTaskIndex();
      }
      return false;
    },
    handleDragOver: function handleDragOver(e, index) {
      console.log('dragOver');
      this.mustDragToNextPage = true;
      if (e.preventDefault) {
        e.preventDefault();
      }
      // console.log('handleDragOver()', index);
    },
    handleDragEnter: function handleDragEnter(e) {},
    changePage: function changePage(isUp) {
      if (!this.mustDragToNextPage) {
        return null;
      }
      if (isUp) {
        if (this.currentPage > 1) {
          this.currentPage -= 1;
        }
      } else {
        if (this.currentPage < this.formData.tasks.length / this.perPage) {
          this.currentPage += 1;
        }
      }
      this.mustDragToNextPage = false;
      return null;
    }
  },
  computed: {},
  watch: {
    filter: function filter() {
      this.formData.filteredTask = this.formData.tasks.filter(this.isInFilter);
    }
  },
  created: function created() {
    var self = this;
    this.processLoading = true;
    this.processText = 'Loading...';
    this.updateCompany();
    this.getShiftList();
    this.getTaskTemplatesList();
    // .then(function(response) {
    //   console.log('here');
    // if (!response) {
    //   return;
    // }
    // for (var i = 0; i < self.formData.tasks.length; i++) {
    //   console.log('need recurrence', self.formData.tasks[i].id);
    //   self.getRecurrence(self, self.formData.tasks[i]);
    // }
    // });
    this.getWorkingAreas();
  },

  directives: {
    debounce: __WEBPACK_IMPORTED_MODULE_2_v_debounce___default.a
  }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var alert = __webpack_require__(10).alert;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'thumbnail',
  components: { alert: alert },
  props: ['picture', 'picture_url'],
  mounted: function mounted() {},
  data: function data() {
    return {
      pictureLocal: null,
      pictureUrlLocal: null,
      alertError: {
        text: 'Some required fields are not filled',
        title: 'Error!',
        visible: false
      }
    };
  },

  methods: {
    readURL: function readURL(input, rotateElem) {
      var self = this;
      // const elem = input.parentElement.parentElement.parentElement;
      if (input.files && input.files[0]) {
        this.pictureLocal = input.files[0];
        var reader = new FileReader();
        reader.onload = function (e) {
          // $('#icon').attr('src', e.target.result);
          self.pictureUrlLocal = e.target.result;
          self.imageOrientation(input, self, rotateElem);
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    handleFileChange: function handleFileChange(e, rotateElem) {
      // this.formData.img = e.target.files[0].name;
      this.$emit('change');
      e.preventDefault();
      if (e.target.files && e.target.files[0] && e.target.files[0].size > 5000000) {
        e.target.value = '';
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
        return;
      }
      this.readURL(e.target, rotateElem);
    },
    getOrientation: function getOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) != 0xFFD8) return callback(-2);
        var length = view.byteLength,
            offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker == 0xFFE1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) return callback(-1);
            var little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) == 0x0112) return callback(view.getUint16(offset + i * 12 + 8, little));
            }
          } else if ((marker & 0xFF00) != 0xFF00) break;else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file);
    },
    imageOrientation: function imageOrientation(input, self, img) {
      self.getOrientation(input.files[0], function (orientation) {
        // let img = document.getElementById('icon-frame');
        img.className = ' ';
        if (orientation === 6 || orientation === 5) {
          img.className += 'rotate90';
        }
        if (orientation === 8 || orientation === 7) {
          img.className += 'rotate270';
        }
        if (orientation === 3 || orientation === 4) {
          img.className += 'rotate180';
        }
      });
    },
    deletePicture: function deletePicture(e) {
      var _this = this;

      this.$emit('change');
      this.$refs.fileinput.reset();
      setTimeout(function () {
        _this.pictureUrlLocal = '';
        _this.pictureLocal = '';
        _this.$emit('update:picture', '');
      }, 1);
    }
  },
  watch: {
    pictureLocal: function pictureLocal() {
      this.$emit('update:picture', this.pictureLocal);
    },
    pictureUrlLocal: function pictureUrlLocal() {
      this.$emit('update:picture_url', this.pictureUrlLocal);
    },
    picture_url: function picture_url() {
      this.pictureUrlLocal = this.picture_url;
    }
  },
  created: function created() {
    this.pictureLocal = this.picture;
    this.pictureUrlLocal = this.picture_url;
  },

  computed: {}
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var spinner = __webpack_require__(10).spinner;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'uploading',
  components: { spinner: spinner },
  props: ['uploaded', 'total', 'visible', 'image'],
  mounted: function mounted() {},
  data: function data() {
    return {};
  },

  methods: {},
  computed: {}
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header___ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_debounce__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_debounce__);



var spinner = __webpack_require__(10).spinner;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'users-permissions',
  props: ['onLogout', 'access_token', 'authUser'],
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_0__header___, spinner: spinner },
  mounted: function mounted() {},
  data: function data() {
    return {
      usersList: [],
      tabIndex: 0,
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Users & Permissions',
        active: true
      }],

      fieldsAdmin: {
        index: {
          label: '#'
        },
        first_name: {
          label: 'First Name'
        },
        last_name: {
          label: 'Last Name'
        },
        role_display: {
          label: 'Role'
        },
        areas: {
          label: 'Access area'
        },
        upn: {
          label: 'UPN'
        }
      },
      fieldsBasic: {
        index: {
          label: '#'
        },
        first_name: {
          label: 'First Name'
        },
        last_name: {
          label: 'Last Name'
        },
        areas: {
          label: 'Access area'
        },
        upn: {
          label: 'UPN'
        }
      },
      currentPage: 1,
      perPage: 5,
      filter: null,
      areas: [],
      processLoading: false
    };
  },

  methods: {
    onAddAdminClick: function onAddAdminClick() {
      console.log('onAddAdminClick');
      this.navigateTo("AddAdmin", null);
    },
    onAddUserClick: function onAddUserClick() {
      console.log('onAddUserClick');
      this.navigateTo("AddUser", null);
    },
    onAdminRowClick: function onAdminRowClick(item, index) {
      console.log('onRowClick', item, index);
      this.navigateTo("AddAdmin", item.id);
      /*this.$router.push({
        name: 'Change Admin',
        params: { userId: item.id },
      });*/
    },
    onBasicRowClick: function onBasicRowClick(item, index) {
      console.log('onRowClick', item, index);
      this.navigateTo("AddUser", item.id);
      /*this.$router.push({
        name: 'Change User',
        params: { userId: item.id },
      });*/
    },
    navigateTo: function navigateTo(pageName, userId) {
      var newUrl = window.location.href;

      var replacement = "/" + pageName;
      if (userId) {
        replacement += "/" + userId;
      }

      newUrl = newUrl.replace('/usersPermissions', replacement);
      newUrl = newUrl.replace('/UsersPermissions', replacement);

      var win = window.open(newUrl, '_blank');
      win.focus();
    },

    // onLogout() {
    //   this.access_token = '';
    //   this.authUser = null;
    // },
    getUsersList: function getUsersList() {
      var _this = this;

      var url = 'users/';
      if (this.$route.params.companyId) {
        url = url + '?company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return null;
        }
        _this.usersList = response.body.filter(function (user) {
          return !user.is_deleted;
        });
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this.onLogout();
        }
      });
    },
    createAreasTree: function createAreasTree(areas) {
      var parrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      for (var i = 0; i < areas.length; i++) {
        areas[i].parrent = parrent;
        this.createAreasTree(areas[i].subareas, areas[i]);
      }
    },
    getAreaById: function getAreaById(id) {
      var area = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.areas;

      for (var i = 0; i < area.length; i++) {
        if (area[i].id === id) {
          return area[i];
        }
        var res = this.getAreaById(id, area[i].subareas);
        if (res) {
          return res;
        }
      }
      return null;
    },
    getUserArea: function getUserArea(areas) {
      var result = [];
      // for (let i = 0; i < areas.length; i++) {
      //   const res = this.getUserArea(areas[i].subareas);
      //   for (let j = 0; j < res.length; j++) {
      //     result.push(areas[i].name + '/' + res[j]);
      //   }
      //   if (res.length === 0) {
      //     result.push(areas[i].name);
      //   }
      // }
      for (var i = 0; i < areas.length; i++) {
        if (areas[i].is_system || !areas[i].is_active) {
          continue;
        }
        var area = this.getAreaById(areas[i].id);
        var areaPath = '';
        if (!area) continue;
        do {
          areaPath = area.name.concat(areaPath ? '/'.concat(areaPath) : '');
          area = area.parrent;
        } while (area);
        result.push(areaPath);
      }
      return result;
    },
    getWorkingAreas: function getWorkingAreas() {
      var _this2 = this;

      var url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = url + '&company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          return null;
        }
        _this2.areas = response.body;
        _this2.createAreasTree(_this2.areas);
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this2.onLogout();
        }
      });
    }
  },
  computed: {},
  created: function created() {
    var _this3 = this;

    this.processLoading = true;
    this.getWorkingAreas().then(function () {
      return _this3.getUsersList();
    }).then(function () {
      _this3.processLoading = false;
    }).catch(function () {
      _this3.processLoading = false;
    });
    if (this.$route.params.type === 'user') {
      this.tabIndex = 1;
    }
  },

  directives: {
    debounce: __WEBPACK_IMPORTED_MODULE_1_v_debounce___default.a
  }
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__header_index__);


var alert = __webpack_require__(10).alert;
var spinner = __webpack_require__(10).spinner;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'working-areas',
  props: ['onLogout', 'access_token', 'authUser'],
  components: { headerBlock: __WEBPACK_IMPORTED_MODULE_0__header_index__, alert: alert, spinner: spinner },
  mounted: function mounted() {},
  data: function data() {
    return {
      areas: {},
      areaActive: 0,
      globalArea: [],
      checkedAreas: [],
      newAreaName: '',
      newAreaLabel: '',
      newAreaPicture: '',
      addRemoveArea: {
        index: null,
        key: null
      },
      areaModal: {
        index: null,
        key: null,
        name: '',
        label: '',
        picture: '',
        title: ''
      },
      breadCrumbItems: [{
        text: 'Home',
        to: "" + '/'
      }, {
        text: 'Working areas',
        active: true
      }],
      alertError: {
        text: 'Some fields are not filled',
        title: 'Error!',
        visible: false
      },
      processLoading: false
    };
  },

  methods: {
    setWorkHours: function setWorkHours(id, customShifts) {
      this.$router.push({ name: 'Days, times, shifts', params: { areaId: id, custom_shifts: customShifts } });
    },
    showModalDeleteArea: function showModalDeleteArea($event, index, key) {
      this.areaModal.key = key;
      this.areaModal.index = index;
      this.$refs.modalDeleteArea.show();
    },
    showModalDeleteSubArea: function showModalDeleteSubArea($event, index, key) {
      this.areaModal.key = key;
      this.areaModal.index = index;
      this.$refs.modalDeleteSubArea.show();
    },
    showModalAddArea: function showModalAddArea($event, index) {
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.addRemoveArea.key = key;
      this.addRemoveArea.index = index;
      this.$refs.modalAddArea[index].show();
    },
    showModalChangeAreaName: function showModalChangeAreaName($event, index, key) {
      this.areaModal.key = key;
      this.areaModal.index = index;
      this.areaModal.name = this.globalArea[index][key].name;
      this.$refs.modalChangeNameArea.show();
    },
    showModalChangeAreaLabel: function showModalChangeAreaLabel($event, index, key) {
      this.areaModal.key = key;
      this.areaModal.index = index;
      this.areaModal.label = this.globalArea[index][key].label;
      this.$refs.modalChangeLabelArea.show();
    },
    showModalChangeAreaPicture: function showModalChangeAreaPicture($event, index, key) {
      this.areaModal.key = key;
      this.areaModal.index = index;
      this.areaModal.picture = this.globalArea[index][key].picture;
      this.$refs.pictureFileInput.reset();
      this.$refs.modalChangeAreaPicture.show();
    },
    submitDeleteArea: function submitDeleteArea() {
      var _this = this;

      this.$http.patch('areas/' + this.globalArea[this.areaModal.index][this.areaModal.key].id + '/', { is_active: false }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return null;
        }
        _this.getWorkingAreas();
        return response;
      }).catch(function (response) {

        if (response.status === 400) {
          console.log('Area could not be deleted: ' + response.body[0]);
          _this.alertError.text = 'Area could not be deleted: ' + response.body[0];
          _this.alertError.visible = true;
          _this.alertError.show();
        }

        if (response.status === 401) {
          _this.onLogout();
        }
      });
      this.$refs.modalDeleteArea.hide();
    },
    submitDeleteSubArea: function submitDeleteSubArea() {
      var _this2 = this;

      console.log(this.areaModal.index);
      console.log(this.areaModal.key);
      console.log(this.globalArea[this.areaModal.index][this.areaModal.key]);
      for (var i = 0; i < this.globalArea[this.areaModal.index][this.areaModal.key].subareas.length; i++) {
        this.$http.patch('areas/' + this.globalArea[this.areaModal.index][this.areaModal.key].subareas[i].id + '/', { is_active: false }, {
          method: 'PATCH',
          headers: {
            Authorization: 'Token ' + this.access_token
          }
          // emulateJSON: true,
        }).then(function (response) {
          if (response.status !== 200) {
            console.log(response);
            return null;
          }
          _this2.getWorkingAreas();
          return response;
        }).catch(function (response) {
          if (response.status === 400) {
            console.log('Area could not be deleted: ' + response.body[0]);
            _this2.alertError.text = 'Area could not be deleted: ' + response.body[0];
            _this2.alertError.visible = true;
            _this2.alertError.show();
          }

          if (response.status === 401) {
            _this2.onLogout();
          }
        });
      }
      this.$refs.modalDeleteSubArea.hide();
    },
    submitChangeAreaPicture: function submitChangeAreaPicture() {
      if (!this.areaModal.picture) {
        return;
      }
      console.log('change picture area', this.areaModal.picture);
      this.changeWorkingAreaPicture({
        picture: this.areaModal.picture,
        id: this.globalArea[this.areaModal.index][this.areaModal.key].id });
      this.$refs.modalChangeAreaPicture.hide();
    },
    changeImageFile: function changeImageFile() {
      if (!this.areaModal.picture) {
        return null;
      }
      if (this.areaModal.picture && this.areaModal.picture.size > 5000000) {
        this.$refs.pictureFileInput.reset();
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
      }
      return null;
    },
    changeWorkingAreaPicture: function changeWorkingAreaPicture(area) {
      var _this3 = this;

      var data = new FormData();
      data.append('picture', area.picture);
      this.$http.patch('areas/' + area.id + '/', data, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return null;
        }
        _this3.getWorkingAreas();
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this3.onLogout();
        }
      });
    },
    submitChangeAreaLabel: function submitChangeAreaLabel() {
      if (!this.areaModal.label) {
        // alert('Please enter your name');
        return;
      }
      console.log('change label area', this.areaModal.label);
      this.changeWorkingAreaLabel({
        label: this.areaModal.label,
        id: this.globalArea[this.areaModal.index][this.areaModal.key].id });
      this.$refs.modalChangeLabelArea.hide();
    },
    changeWorkingAreaLabel: function changeWorkingAreaLabel(area) {
      var _this4 = this;

      this.$http.patch('areas/' + area.id + '/', { label: area.label }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return null;
        }
        _this4.getWorkingAreas();
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this4.onLogout();
        }
      });
    },
    submitChangeArea: function submitChangeArea() {
      if (!this.areaModal.name) {
        // alert('Please enter your name');
        return;
      }
      console.log('change name area', this.areaModal.name);
      this.changeWorkingAreaName({
        name: this.areaModal.name,
        id: this.globalArea[this.areaModal.index][this.areaModal.key].id });
      this.$refs.modalChangeNameArea.hide();
    },
    changeWorkingAreaName: function changeWorkingAreaName(area) {
      var _this5 = this;

      this.$http.patch('areas/' + area.id + '/', { name: area.name, is_active: true }, {
        method: 'PATCH',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return null;
        }
        _this5.getWorkingAreas();
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this5.onLogout();
        }
      });
    },
    clearPicture: function clearPicture() {
      this.areaModal.picture = '';
    },
    clearName: function clearName() {
      this.newAreaName = '';
    },
    clearLabel: function clearLabel() {
      this.newAreaLabel = '';
    },
    submitAddNewArea: function submitAddNewArea(e, index) {
      if (!this.newAreaName) {
        // alert('Please enter your name');
        return e.cancel();
      }
      console.log('added one area', this.newAreaName, index);
      var parent = index ? this.globalArea[index - 1].activeId : null;
      parent = this.addRemoveArea.key === null ? parent : this.globalArea[index][this.addRemoveArea.key].id;
      var data = {
        name: this.newAreaName,
        description: '',
        picture: null,
        parent: parent,
        subareas: []
      };
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      console.log(this.globalArea[index]);
      this.newAreaName = '';
      // if (this.addRemoveArea.key !== null) {
      //   index++;
      //   this.globalArea.push([]);
      // }
      // this.globalArea[index].push(data);
      this.addRemoveArea.key = null;
      this.addWorkingArea(data);
      this.$refs.modalAddArea[index].hide();
      return null;
    },
    addWorkingArea: function addWorkingArea(newArea) {
      var _this6 = this;

      this.$http.post('areas/', newArea, {
        method: 'POST',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 201) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return null;
        }
        _this6.getWorkingAreas();
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this6.onLogout();
        }
      });
    },
    onClick: function onClick($event, item, index) {
      this.globalArea = this.globalArea.slice(0, index + 1);
      this.checkedAreas = this.checkedAreas.slice(0, index);
      this.checkedAreas.push(item.id);
      if (!item.subareas.length) return;

      this.areaActive = item.subareas;
      item.subareas.activeId = false;
      this.globalArea.push(item.subareas);
      setTimeout(function () {
        var elem = document.getElementById('areas-wrapper');
        if (elem) {
          elem.scrollLeft = elem.scrollWidth;
        }
      }, 1);
    },

    // onLogout() {
    //   this.access_token = '';
    //   this.authUser = null;
    //   console.log(this.$route);
    //   // this.$route.router.go(process.env.START_URL + '/');
    // },
    getWorkingAreas: function getWorkingAreas() {
      var _this7 = this;

      var url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = url + '&company=' + this.$route.params.companyId;
      }
      return this.$http.get(url, {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + this.access_token
        }
        // emulateJSON: true,
      }).then(function (response) {
        if (response.status !== 200) {
          console.log(response);
          // that.$set(that, 'moduleError', true);
          return null;
        }
        response.body.activeId = false;
        _this7.globalArea = [];
        _this7.globalArea.push(response.body);
        for (var i = 0; i < _this7.checkedAreas.length && i < _this7.globalArea.length; i++) {
          for (var j = 0; j < _this7.globalArea[i].length; j++) {
            if (_this7.checkedAreas[i] === _this7.globalArea[i][j].id && _this7.globalArea[i][j].is_active) {
              _this7.globalArea[i].activeId = _this7.globalArea[i][j].id;
              if (!_this7.globalArea[i][j].subareas.length) return null;
              _this7.areaActive = _this7.globalArea[i][j].subareas;
              _this7.globalArea[i][j].subareas.activeId = false;
              _this7.globalArea.push(_this7.globalArea[i][j].subareas);
            }
          }
        }
        setTimeout(function () {
          var elem = document.getElementById('areas-wrapper');
          if (elem) elem.scrollLeft = elem.scrollWidth;
        }, 1);
        return response;
      }).catch(function (response) {
        if (response.status === 401) {
          _this7.onLogout();
        }
      });
    },
    isHaveSubarea: function isHaveSubarea(area) {
      if (!area) {
        return false;
      }
      return area.filter(function (item) {
        return item.is_active;
      }).length;
    },
    dropdownShowen: function dropdownShowen() {},
    getMarginTopArea: function getMarginTopArea(index) {
      var result = 0;
      for (var i = 1; i <= index; i++) {
        var emptyCount = 0;
        for (var j = 0; j < this.globalArea[i - 1].length; j++) {
          if (!this.globalArea[i - 1][j].is_active) {
            emptyCount++;
            continue;
          }
          if (this.globalArea[i - 1][j].id === this.checkedAreas[i - 1]) {
            result += 56 * (j - emptyCount);
            break;
          }
        }
      }
      return result;
    }
  },
  computed: {},
  created: function created() {
    var _this8 = this;

    this.processLoading = true;
    this.getWorkingAreas().then(function () {
      _this8.processLoading = false;
    }).catch(function () {
      _this8.processLoading = false;
    });
  }
});

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 496:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 497:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 498:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30542548",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9b4726a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7b84a1e1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(552),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b23d112c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(487)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(538),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b9fb52c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f94413f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(543),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52a5f4cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(555),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dbc80d02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(553),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(537),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16435e7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(212),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(554),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(556),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(540),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(500)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(551),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-af2e481c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(542),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-475de30e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(546),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 533:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "login text-left"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": null
    },
    on: {
      "logout": function($event) {}
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "warning",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertWarning.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertWarning, "visible", $$v)
      },
      expression: "alertWarning.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertWarning.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertWarning.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendAuth()
      }
    },
    model: {
      value: (_vm.authData),
      callback: function($$v) {
        _vm.authData = $$v
      },
      expression: "authData"
    }
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authData.loginInput),
      expression: "authData.loginInput"
    }],
    staticClass: "col-sm-4 col-md-5 col-lg-4 form-control",
    attrs: {
      "placeholder": "login",
      "id": "txtUsername"
    },
    domProps: {
      "value": (_vm.authData.loginInput)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.authData, "loginInput", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.showLoginMain) ? _c('div', {
    staticClass: "saml_login_block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-button', {
    staticClass: "offset-sm-3 offset-md-4 offset-lg-3",
    attrs: {
      "variant": "primary",
      "id": "btnNext"
    },
    on: {
      "click": _vm.checkSuffix
    }
  }, [_vm._v("Next")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showLoginMain) ? _c('div', {
    staticClass: "main_login_block"
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authData.passwordInput),
      expression: "authData.passwordInput"
    }],
    staticClass: "col-sm-4 col-md-5 col-lg-4 form-control",
    attrs: {
      "type": "password",
      "placeholder": "password",
      "id": "txtPassword"
    },
    domProps: {
      "value": (_vm.authData.passwordInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.authData, "passwordInput", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('b-button', {
    staticClass: "offset-sm-3 offset-md-4 offset-lg-3",
    attrs: {
      "variant": "primary",
      "id": "btnLogin",
      "type": "submit"
    }
  }, [_vm._v("login")])], 1)]) : _vm._e()])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-sm-3 col-md-4 col-lg-3"
  }, [_c('b', [_vm._v("Login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-sm-3 col-md-4 col-lg-3"
  }, [_c('b', [_vm._v("Password")])])
}]}

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "checklists"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "debounce",
      rawName: "v-debounce",
      value: (500),
      expression: "500"
    }],
    attrs: {
      "placeholder": "Type to Search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 offset-md-1"
  }, [_c('b-button', {
    staticClass: "button-add",
    attrs: {
      "variant": "primary",
      "to": _vm.getAddChecklistUrl()
    }
  }, [_vm._v("\n          Add checklist\n        ")])], 1)]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "md",
      "total-rows": _vm.formData.checklists.filter(_vm.isInFilter).length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table text-center table-hover border"
  }, [_c('thead', [_c('tr', _vm._l((_vm.formData.checklistsFields), function(item) {
    return _c('th', {
      staticClass: "text-center align-middle"
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.formData.checklists.filter(_vm.isInFilter)), function(item, index) {
    return ((_vm.currentPage - 1) * _vm.perPage <= index && index < (_vm.currentPage) * _vm.perPage) ? [
      [_c('tr', {
        on: {
          "click": function($event) {
            return _vm.onRowClick(item)
          }
        }
      }, [_c('td', {
        staticClass: "align-middle index-cell"
      }, [_vm._v("\n              " + _vm._s(+index + 1) + "\n            ")]), _vm._v(" "), _c('td', {
        staticClass: "align-middle id-cell"
      }, [_c('b', [_vm._v(_vm._s(item.id))])]), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle text-cell"
      }, [_c('div', {
        staticClass: "cell__text"
      }, [_c('b', [_vm._v(_vm._s(item.name))])])]), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle area-cell"
      }, _vm._l((_vm.getWorkingAreasListById(item.area, _vm.areas)), function(area) {
        return _c('div', [_vm._v("\n                " + _vm._s(area ? area.name : '')), (area.id != item.area) ? _c('span', [_vm._v("/")]) : _vm._e()])
      }), 0), _vm._v(" "), _c('td', {
        staticClass: "text-center role-cell"
      }, [(item.role) ? [(_vm.authUser && _vm.authUser.company && _vm.authUser.company[item.role + '_role_display_name']) ? [_vm._v("\n                  " + _vm._s(_vm.authUser.company[item.role + '_role_display_name']) + "\n                ")] : [_vm._v("\n                  " + _vm._s(_vm.roles[item.role]) + "\n                ")]] : _vm._e()], 2)])]
    ] : _vm._e()
  })], 2)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "personal-details"
  }, [_c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('h1', {
    staticClass: "text-left"
  }, [_vm._v("Personal details")]), _vm._v(" "), _c('b-form-group', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("First name")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.first_name ? '' : 'Enter name'
    },
    model: {
      value: (_vm.formData.first_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "first_name", $$v)
      },
      expression: "formData.first_name"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Last name")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.last_name ? '' : 'Enter last name'
    },
    model: {
      value: (_vm.formData.last_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "last_name", $$v)
      },
      expression: "formData.last_name"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', [_c('div', {
    class: [(_vm.needFill && !_vm.formData.username && !_vm.formData.email) ? 'has-danger' : '', 'row']
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Username")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.username ? '' : 'Enter username'
    },
    model: {
      value: (_vm.formData.username),
      callback: function($$v) {
        _vm.$set(_vm.formData, "username", $$v)
      },
      expression: "formData.username"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (!_vm.needFill || _vm.formData.email.length == 0) ? '' : (!_vm.validateEmail(_vm.formData.email)) ? 'danger' : ''
    }
  }, [_c('div', {
    class: [(_vm.needFill && !_vm.formData.username && !_vm.formData.email) ? 'has-danger' : '', 'row']
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Email")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.email ? '' : 'Enter email',
      "state": (!_vm.needFill || _vm.formData.email.length == 0) ? '' : (!_vm.validateEmail(_vm.formData.email)) ? 'danger' : ''
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("UPN")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.upn ? '' : ''
    },
    model: {
      value: (_vm.formData.upn),
      callback: function($$v) {
        _vm.$set(_vm.formData, "upn", $$v)
      },
      expression: "formData.upn"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', [_c('div', {
    class: [(_vm.needFill && (!_vm.formData.id && !_vm.formData.passwordForm)) ? 'has-danger' : '', 'row']
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Password")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2",
    attrs: {
      "type": "password",
      "placeholder": _vm.formData.passwordForm ? '' : 'Enter password'
    },
    model: {
      value: (_vm.formData.passwordForm),
      callback: function($$v) {
        _vm.$set(_vm.formData, "passwordForm", $$v)
      },
      expression: "formData.passwordForm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 small red",
    staticStyle: {
      "padding-top": "4px"
    }
  }, [_vm._v("\n        Minimum password requirements "), _c('br'), _vm._v("6 characters, one capital, one number\n      ")])], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.formData.passwordForm.length == 0) ? '' : (_vm.formData.confirmPassword != _vm.formData.passwordForm) ? 'danger' : 'success'
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Confirm Password")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-2 ",
    attrs: {
      "type": "password",
      "placeholder": _vm.formData.confirmPassword ? '' : 'Enter password',
      "state": (_vm.formData.passwordForm.length == 0) ? '' : (_vm.formData.confirmPassword != _vm.formData.passwordForm) ? 'danger' : 'success'
    },
    model: {
      value: (_vm.formData.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.formData, "confirmPassword", $$v)
      },
      expression: "formData.confirmPassword"
    }
  })], 1)]), _vm._v(" "), (_vm.type == 'admin') ? _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('b-form-select', {
    staticClass: "col-md-2",
    attrs: {
      "options": _vm.roles
    },
    model: {
      value: (_vm.formData.role),
      callback: function($$v) {
        _vm.$set(_vm.formData, "role", $$v)
      },
      expression: "formData.role"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('p', [_c('b', [_vm._v("Profile image")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "file-select"
  }, [_vm._v("\n            Select an image to upload\n            "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileChange($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    class: _vm.formData.img ? 'img-icon' : 'img-icon-empty',
    attrs: {
      "id": "icon-frame"
    }
  }, [(_vm.formData.img) ? [_c('img', {
    staticClass: "img-thumbnail",
    attrs: {
      "id": "icon",
      "src": _vm.formData.img
    }
  })] : _vm._e()], 2)])])]), _vm._v(" "), (_vm.formData.role != 'manager') ? [_c('h1', {
    staticClass: "text-left access-level"
  }, [_vm._v("Access level")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggest": _vm.suggestArea,
      "anchor": "name",
      "process": _vm.processJSON,
      "on-select": _vm.getDataSearchArea
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 offset-md-1"
  }, [_c('div', {
    staticClass: " work-areas__area-checkbox"
  }, [_c('area-checkbox', {
    attrs: {
      "type": "checkbox",
      "areas": _vm.areas,
      "baseId": "areaCheckbox-",
      "selected": _vm.areasChecked
    },
    model: {
      value: (_vm.areasChecked),
      callback: function($$v) {
        _vm.areasChecked = $$v
      },
      expression: "areasChecked"
    }
  })], 1)])])] : _vm._e(), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.areasChecked.length) ? 'has-danger' : '', 'line']
  }, [(_vm.formData.role != 'manager') ? [_vm._m(2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "selected-areas"
  }, _vm._l((_vm.areasChecked), function(item) {
    return _c('p', [_vm._v(_vm._s(item.name))])
  }), 0)])] : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "success"
    },
    on: {
      "click": _vm.submitUser
    }
  }, [(!_vm.formData.id) ? _c('span', [_vm._v("Add " + _vm._s(_vm.type == 'admin' ? 'admin' : 'user'))]) : _c('span', [_vm._v("Save")])]), _vm._v(" "), (_vm.formData.id && _vm.mustDelete) ? _c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.confirm_delete.show()
      }
    }
  }, [_vm._v("\n      Delete\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('b-modal', {
    ref: "user_added",
    attrs: {
      "title": ""
    },
    on: {
      "ok": function($event) {
        return _vm.returnBack()
      },
      "hide": function($event) {
        return _vm.returnBack()
      }
    }
  }, [_vm._v("\n    User "), (!_vm.$route.params.userId) ? _c('span', [_vm._v("created")]) : _c('span', [_vm._v("changed")])]), _vm._v(" "), _c('b-modal', {
    ref: "confirm_delete",
    attrs: {
      "title": ""
    }
  }, [_vm._v("\n    Are you sure you want to delete this user?\n    "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.onClickDelete()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.confirm_delete.hide();
      }
    }
  }, [_vm._v("No")])], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "assign_to_user",
    attrs: {
      "title": ""
    }
  }, [_vm._v("\n    Please, select a user to whom all open actions of the deleted user will be transferred\n    "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.usersListOptions
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        _vm.deleteUser(_vm.formData.id);
        _vm.$refs.assign_to_user.hide();
      }
    }
  }, [_vm._v("Assign")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.assign_to_user.hide();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Role")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v("Search working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Selected working areas")])])
}]}

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploading",
    style: (_vm.visible ? '' : 'display: none;')
  }, [_c('div', {
    staticClass: "uploading-wrapper"
  }, [_c('div', {
    staticClass: "uploading-spinner"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "lg",
      "text": _vm.image ? '' : 'Saving...'
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  })], 1), _vm._v(" "), (_vm.image) ? _c('div', {
    staticClass: "uploading-text"
  }, [(_vm.total > 1) ? [_vm._v("\n        Uploading file " + _vm._s(_vm.uploaded) + " of " + _vm._s(_vm.total) + "\n      ")] : [_vm._v("\n        Uploading file\n      ")]], 2) : _vm._e(), _vm._v(" "), (_vm.total > 1 && _vm.image) ? _c('b-progress', {
    attrs: {
      "precision": 0,
      "max": _vm.total,
      "show-progress": "",
      "animated": ""
    },
    model: {
      value: (_vm.uploaded),
      callback: function($$v) {
        _vm.uploaded = $$v
      },
      expression: "uploaded"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section')
},staticRenderFns: []}

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "checklist-config"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('uploading', {
    attrs: {
      "uploaded": _vm.upload.uploaded,
      "total": _vm.upload.total,
      "visible": _vm.upload.visible,
      "image": _vm.upload.image
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.confirm-chklst-dup",
      modifiers: {
        "confirm-chklst-dup": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("\n          Duplicate\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveChecklist()
      }
    }
  }, [_vm._v("\n          Save\n        ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.confirm-chklst-del",
      modifiers: {
        "confirm-chklst-del": true
      }
    }],
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("\n          Delete whole Checklist\n        ")])], 1)]), _vm._v(" "), (_vm.duplicate) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirm-chklst-dup",
      "title": "Duplicate Checklist",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        return _vm.duplicateChecklist(true)
      }
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("This action will duplicate the entire content of this checklist."), _c('br'), _vm._v("Do you want to proceed?")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirm-chklst-del",
      "title": "Delete Checklist",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        return _vm.deleteChecklist()
      }
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("Are you sure you want to delete the whole checklist")])]), _vm._v(" "), _c('h2', [_vm._v("Basic information")]), _vm._v(" "), _c('div', {
    staticClass: "basic-info-wrapper"
  }, [_c('div', {
    class: [(_vm.needFill && !_vm.formData.name) ? 'has-danger' : '', 'row basic-info__title']
  }, [_vm._m(1), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-7",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.name ? '' : 'Enter checklist title',
      "maxlength": "255"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('thumbnail', {
    attrs: {
      "picture": _vm.formData.picture,
      "picture_url": _vm.formData.picture_url
    },
    on: {
      "update:picture": function($event) {
        return _vm.$set(_vm.formData, "picture", $event)
      },
      "update:picture_url": function($event) {
        return _vm.$set(_vm.formData, "picture_url", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.formData.role) ? 'has-danger' : '', 'row basic-info__title']
  }, [_vm._m(3), _vm._v(" "), _c('b-form-select', {
    staticClass: "col-md-3",
    attrs: {
      "options": _vm.userRoles,
      "value-field": "id",
      "text-field": "name"
    },
    model: {
      value: (_vm.formData.role),
      callback: function($$v) {
        _vm.$set(_vm.formData, "role", $$v)
      },
      expression: "formData.role"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row separator mt-2"
  }, [_vm._m(4), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggest": _vm.suggestArea,
      "anchor": "name",
      "process": _vm.processJSON,
      "on-select": _vm.getDataSearchArea
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.areaFromList = !_vm.areaFromList
      }
    }
  }, [_vm._v("Or select from list\n          ")])], 1), _vm._v(" "), (_vm.areaFromList) ? _c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('div', {
    staticClass: " work-areas__area-checkbox"
  }, [_c('area-checkbox', {
    attrs: {
      "type": "radio",
      "areas": _vm.areas,
      "baseId": 'areaCheckbox',
      "selected": _vm.formData.area
    },
    on: {
      "selectedAreaChanged": function($event) {}
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.formData.area.length) ? 'has-danger' : '', 'line']
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "selected-areas"
  }, _vm._l((_vm.formData.area), function(item) {
    return _c('p', [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.formData.double_signature_required),
      callback: function($$v) {
        _vm.$set(_vm.formData, "double_signature_required", $$v)
      },
      expression: "formData.double_signature_required"
    }
  })], 1), _vm._v(" "), (!_vm.formData.id) ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveChecklist()
      }
    }
  }, [_vm._v("\n        Save and continue\n      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.formData.id) ? _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-3",
    on: {
      "click": function($event) {
        _vm.showTasks = !_vm.showTasks
      }
    }
  }, [_c('b', [_vm._v("Checklist items")])])]) : _vm._e(), _vm._v(" "), (_vm.formData.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('p', {
    staticClass: "checklist-items-wrapper",
    attrs: {
      "id": "collapse-checklists"
    }
  }, [_c('b-list-group', [(!_vm.formData.tasks.length) ? _c('b-list-group-item', {
    staticClass: "list-group-checklist-item"
  }, [_vm._v("\n              There are no questions in this checklist yet\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.tasks), function(item, index) {
    return _c('b-list-group-item', {
      key: index,
      staticClass: "list-group-checklist-item draggable",
      attrs: {
        "active": index === _vm.activeTask,
        "draggable": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.activeTaskNext = index
        },
        "drop": function($event) {
          return _vm.handleDrop($event, index)
        },
        "dragstart": function($event) {
          return _vm.handleDragStart($event, item, index)
        },
        "dragend": function($event) {
          return _vm.handleDragEnd($event, item, index)
        },
        "dragover": function($event) {
          return _vm.handleDragOver($event, index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  })], 2)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "",
      "variant": "primary"
    },
    on: {
      "click": _vm.addEmptyTask
    }
  }, [_vm._v("+ Add one more checklist item")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, _vm._l((_vm.formData.tasks), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTask === index),
        expression: "activeTask === index"
      }],
      staticClass: "checklist-item-wrapper"
    }, [_c('h2', [_vm._v("Checklist item information")]), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.name) ? 'has-danger' : '', 'row basic-info__title']
    }, [_vm._m(7, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "col-md-9 form-control",
      attrs: {
        "type": "text",
        "placeholder": "Enter task title",
        "maxlength": "255"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "change": function($event) {
          return _vm.onChangeChecklistTask()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.description) ? 'has-danger' : '', 'row']
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "col-md-10 basic-info__description form-control",
      attrs: {
        "placeholder": "Enter description"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "change": function($event) {
          return _vm.onChangeChecklistTask()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row mt-1"
    }, [_c('p', {
      staticClass: "col-md-3"
    }, [_c('b', [_vm._v("Upload\n              "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'image'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'image'
        }
      }
    }, [_vm._v("photo")]), _vm._v("\n              or\n              "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'video'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'video'
        }
      }
    }, [_vm._v("video")]), _vm._v("\n              for this checklist item")]), _vm._v(" (if none, default icon will be used)")]), _vm._v(" "), (item.selectedContent == 'image') ? _c('thumbnail', {
      attrs: {
        "picture": item.picture,
        "picture_url": item.picture_url
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "picture", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "picture_url", $event)
        },
        "change": function($event) {
          return _vm.onChangeChecklistTask()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.selectedContent == 'video'),
        expression: "item.selectedContent == 'video'"
      }],
      class: [(item.video_require) ? 'has-danger' : ''],
      attrs: {
        "id": ""
      }
    }, [_c('div', {
      class: [(item.video_require) ? 'form-control' : '']
    }, [_c('thumbnail', {
      attrs: {
        "picture": item.video_thumbnail,
        "picture_url": item.thumbnail_url
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "video_thumbnail", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "thumbnail_url", $event)
        }
      }
    }), _vm._v(" "), _c('b-form-file', {
      ref: "checklistItemVideoFile",
      refInFor: true,
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "accept": ".mp4, .mov",
        "choose-label": (!item.video && !item.video_url) ? 'Choose video' : 'Remove video',
        "placeholder": item.video_url
      },
      on: {
        "change": function($event) {
          return _vm.handleVideoFileChange($event)
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.clearChecklistItemVideo($event, item, index)
        }
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "instructions"
    }, [_c('h2', [_vm._v("Instructions")]), _vm._v(" "), _c('p', [_vm._v("Enter instructions for the task that will appear in the app for this task. If left blank no instructions for this task will be shown.")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(9, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [_c('b-form-file', {
      ref: 'pdffile' + index,
      refInFor: true,
      attrs: {
        "placeholder": item.description_file_url,
        "choose-label": (!item.description_file && !item.description_file_url) ? 'Choose PDF file' : 'Remove PDF file',
        "accept": ".pdf"
      },
      nativeOn: {
        "click": function($event) {
          _vm.clearPdfFile($event, index);
          (item.description_file) ? _vm.onChangeChecklistTask(): '';
        },
        "change": function($event) {
          _vm.onChangeChecklistTask();
          _vm.changePdfFile($event, index);
        }
      },
      model: {
        value: (item.description_file),
        callback: function($$v) {
          _vm.$set(item, "description_file", $$v)
        },
        expression: "item.description_file"
      }
    })], 1)]), _vm._v(" "), (!item.steps.length) ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((!item.description_file && !item.description_file_url)),
        expression: "(!item.description_file && !item.description_file_url)"
      }],
      staticClass: "instructions__step"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "instructions__step-buttons"
    }, [_c('b-button', {
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          _vm.addEmptyStep(item);
          _vm.onChangeChecklistTask();
        }
      }
    }, [_vm._v("Add steps")])], 1)])])])] : _vm._e(), _vm._v(" "), _vm._l((item.steps), function(step, index) {
      return [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((!item.description_file && !item.description_file_url)),
          expression: "(!item.description_file && !item.description_file_url)"
        }],
        staticClass: "instructions__step"
      }, [_c('div', {
        staticClass: "row align-items-baseline"
      }, [_vm._m(10, true), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('div', {
        class: [(!step.valid) ? 'has-danger' : '', 'col-md-1']
      }, [_c('b-form-input', {
        staticStyle: {
          "width": "55px"
        },
        attrs: {
          "type": "number"
        },
        on: {
          "change": function($event) {
            _vm.validateSteps(item);
            _vm.onChangeChecklistTask();
          }
        },
        model: {
          value: (step.order),
          callback: function($$v) {
            _vm.$set(step, "order", $$v)
          },
          expression: "step.order"
        }
      })], 1), _vm._v(" "), _c('p', {
        staticClass: "col-md-5 offset-md-3"
      }, [_c('b', [_vm._v("Attach\n                    "), _c('span', {
        staticClass: "underline pointer image-video",
        class: {
          'image-video_active': step.selectedContent == 'image'
        },
        on: {
          "click": function($event) {
            step.selectedContent = 'image'
          }
        }
      }, [_vm._v("photo")]), _vm._v("\n                    or\n                    "), _c('span', {
        staticClass: "underline pointer image-video",
        class: {
          'image-video_active': step.selectedContent == 'video'
        },
        on: {
          "click": function($event) {
            step.selectedContent = 'video'
          }
        }
      }, [_vm._v("video")])])])]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [(!step.valid) ? _c('div', {
        staticClass: "col-md-5 offset-md-3",
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("\n                    Please enter a number that is not used\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-7"
      }, [_c('span', {
        class: [(_vm.needFill && !step.description) ? 'has-danger' : '']
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (step.description),
          expression: "step.description"
        }],
        staticClass: " instructions__step-text form-control",
        attrs: {
          "placeholder": "Enter step description"
        },
        domProps: {
          "value": (step.description)
        },
        on: {
          "change": function($event) {
            return _vm.onChangeChecklistTask();
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(step, "description", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "instructions__step-buttons"
      }, [(index == item.steps.length - 1) ? _c('b-button', {
        attrs: {
          "variant": "primary"
        },
        on: {
          "click": function($event) {
            _vm.addEmptyStep(item);
            _vm.onChangeChecklistTask();
          }
        }
      }, [_vm._v("Add one more step")]) : _vm._e(), _vm._v(" "), (index != item.steps.length - 1) ? _c('div') : _vm._e(), _vm._v(" "), (item.steps.length) ? _c('b-button', {
        attrs: {
          "variant": "danger"
        },
        on: {
          "click": function($event) {
            _vm.removeStep(item, index);
            _vm.onChangeChecklistTask();
          }
        }
      }, [_vm._v("Remove this step")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
        staticClass: "col-md-5"
      }, [(step.selectedContent == 'image') ? _c('thumbnail', {
        attrs: {
          "picture": step.picture,
          "picture_url": step.picture_url
        },
        on: {
          "update:picture": function($event) {
            return _vm.$set(step, "picture", $event)
          },
          "update:picture_url": function($event) {
            return _vm.$set(step, "picture_url", $event)
          },
          "change": function($event) {
            return _vm.onChangeChecklistTask()
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (step.selectedContent == 'video'),
          expression: "step.selectedContent == 'video'"
        }],
        class: [(step.video_require) ? 'has-danger' : ''],
        attrs: {
          "id": ""
        }
      }, [_c('div', {
        staticClass: "row ",
        class: [(step.video_require) ? 'form-control' : '']
      }, [_c('thumbnail', {
        attrs: {
          "picture": step.video_thumbnail,
          "picture_url": step.thumbnail_url
        },
        on: {
          "update:picture": function($event) {
            return _vm.$set(step, "video_thumbnail", $event)
          },
          "update:picture_url": function($event) {
            return _vm.$set(step, "thumbnail_url", $event)
          }
        }
      }), _vm._v(" "), _c('b-form-file', {
        ref: "stepvideofile",
        refInFor: true,
        staticStyle: {
          "margin-top": "10px"
        },
        attrs: {
          "accept": ".mp4, .mov",
          "choose-label": (!step.video && !step.video_url) ? 'Choose video' : 'Remove video',
          "placeholder": step.video_url
        },
        on: {
          "change": function($event) {
            return _vm.handleVideoFileChange($event)
          }
        },
        nativeOn: {
          "click": function($event) {
            return _vm.clearStepVideo($event, step, index)
          }
        },
        model: {
          value: (step.video),
          callback: function($$v) {
            _vm.$set(step, "video", $$v)
          },
          expression: "step.video"
        }
      })], 1)])], 1)])])]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "instructions__step-buttons"
    }, [_c('b-button', {
      attrs: {
        "variant": "success"
      },
      on: {
        "click": function($event) {
          return _vm.saveTask(item)
        }
      }
    }, [_vm._v("Save this checklist item")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTask(item, index)
        }
      }
    }, [_vm._v("Delete this checklist item")])], 1)])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "leavingItemConfirm",
    attrs: {
      "title": ""
    }
  }, [_vm._v("\n      You have unsaved changes in this item. You want to:\n      "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.saveTask(_vm.formData.tasks[_vm.activeTask]);
        _vm.$refs.leavingItemConfirm.hide();
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.discardTaskChanges(_vm.activeTask);
        _vm.$refs.leavingItemConfirm.hide();
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$refs.leavingItemConfirm.hide();
        _vm.activeTaskNext = null;
      }
    }
  }, [_vm._v("Return to this item")])], 1)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 duplicat-warning"
  }, [_c('p', [_vm._v("Details are copied from the original. If you don't make any changes and save, the item will be duplicated!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Checklist title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('b', [_vm._v("Upload main checklist image")]), _vm._v(" (if none, default icon will be used)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Assign to user role")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2 align-baseline"
  }, [_c('b', [_vm._v("Search working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Selected working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Requires two signatures")]), _vm._v(" (one signature of the user and one from somebody else e.g. manager)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2 mt-1"
  }, [_c('b', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_vm._v("OR "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("upload a PDF file with task instructions.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Step")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Order")])])
}]}

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(_vm.access_token == '') ? [_c('loginForm', {
    on: {
      "onLogin": _vm.sendAuth
    }
  })] : [_c('home', {
    attrs: {
      "onLogout": _vm.onLogout
    }
  })]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "task-config"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('uploading', {
    attrs: {
      "uploaded": _vm.upload.uploaded,
      "total": _vm.upload.total,
      "visible": _vm.upload.visible,
      "image": _vm.upload.image
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), (_vm.duplicate) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [(!_vm.duplicate && _vm.taskId) ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.duplicateTask(true)
      }
    }
  }, [_vm._v("\n          Duplicate\n        ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveTask(true)
      }
    }
  }, [_vm._v("\n          Save and add another\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveTask()
      }
    }
  }, [_vm._v("\n          Save task\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteTask()
      }
    }
  }, [_vm._v("\n          Delete task\n        ")])], 1)]), _vm._v(" "), _c('h2', [_vm._v("Basic information")]), _vm._v(" "), _c('div', {
    staticClass: "basic-info"
  }, [_c('div', {
    class: [(_vm.needFill && !_vm.formData.name) ? 'has-danger' : '', 'row basic-info__title']
  }, [_vm._m(2), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-9",
    attrs: {
      "type": "text",
      "placeholder": (_vm.formData.name) ? '' : 'Enter task title',
      "maxlength": "255"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.formData.description) ? 'has-danger' : '', 'row']
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.description),
      expression: "formData.description"
    }],
    staticClass: "col-md-12 basic-info__description form-control",
    attrs: {
      "textarea": "",
      "placeholder": "Enter task description"
    },
    domProps: {
      "value": (_vm.formData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row basic-info__title"
  }, [_vm._m(4), _vm._v(" "), _c('b-form-select', {
    staticClass: "col-md-9",
    attrs: {
      "options": _vm.userRoles,
      "value-field": "id",
      "text-field": "name"
    },
    model: {
      value: (_vm.formData.role),
      callback: function($$v) {
        _vm.$set(_vm.formData, "role", $$v)
      },
      expression: "formData.role"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: [(_vm.needFill && _vm.formData.video_require) ? 'has-danger' : '']
  }, [_c('p', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Upload main task\n            "), _c('span', {
    staticClass: "underline pointer image-video",
    class: {
      'image-video_active': _vm.formData.selectedContent == 'image'
    },
    on: {
      "click": function($event) {
        _vm.formData.selectedContent = 'image'
      }
    }
  }, [_vm._v("image")]), _vm._v("\n            or "), _c('span', {
    staticClass: "underline pointer image-video",
    class: {
      'image-video_active': _vm.formData.selectedContent == 'video'
    },
    on: {
      "click": function($event) {
        _vm.formData.selectedContent = 'video'
      }
    }
  }, [_vm._v("video")])]), _vm._v("\n          (if none, default icon will be used)\n        ")]), _vm._v(" "), (_vm.formData.selectedContent == 'image') ? _c('thumbnail', {
    attrs: {
      "picture": _vm.formData.picture,
      "picture_url": _vm.formData.img
    },
    on: {
      "update:picture": function($event) {
        return _vm.$set(_vm.formData, "picture", $event)
      },
      "update:picture_url": function($event) {
        return _vm.$set(_vm.formData, "img", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.selectedContent == 'video') ? [_c('div', {
    staticClass: "col-md-7",
    class: [(_vm.needFill && _vm.formData.video_require) ? 'form-control' : '']
  }, [_c('thumbnail', {
    attrs: {
      "picture": _vm.formData.video_thumbnail,
      "picture_url": _vm.formData.img_thumbnail
    },
    on: {
      "update:picture": function($event) {
        return _vm.$set(_vm.formData, "video_thumbnail", $event)
      },
      "update:picture_url": function($event) {
        return _vm.$set(_vm.formData, "img_thumbnail", $event)
      }
    }
  }), _vm._v(" "), _c('b-form-file', {
    ref: "videofile",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "accept": ".mp4, .mov",
      "choose-label": (!_vm.formData.video && !_vm.formData.video_url) ? 'Choose video' : 'Remove video',
      "placeholder": _vm.formData.video_url
    },
    on: {
      "change": function($event) {
        return _vm.handleVideoFileChange($event)
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearVideo($event)
      }
    },
    model: {
      value: (_vm.formData.video),
      callback: function($$v) {
        _vm.$set(_vm.formData, "video", $$v)
      },
      expression: "formData.video"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('b-form-checkbox', {
    staticClass: "col-md-3",
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    on: {
      "change": function($event) {
        return _vm.updateDeeplinkData()
      }
    },
    model: {
      value: (_vm.formData.deeplink.active),
      callback: function($$v) {
        _vm.$set(_vm.formData.deeplink, "active", $$v)
      },
      expression: "formData.deeplink.active"
    }
  }, [_c('b', [_vm._v("Deeplink to")])]), _vm._v(" "), (_vm.formData.deeplink.active) ? [_c('b-form-select', {
    staticClass: "col-md-3",
    attrs: {
      "options": _vm.deeplinks,
      "value-field": "name",
      "text-field": "name"
    },
    nativeOn: {
      "change": function($event) {
        return _vm.clearDeeplinkId()
      }
    },
    model: {
      value: (_vm.formData.deeplink.item),
      callback: function($$v) {
        _vm.$set(_vm.formData.deeplink, "item", $$v)
      },
      expression: "formData.deeplink.item"
    }
  }), _vm._v(" "), _c('span', {
    class: [_vm.formData.deeplink.badId ? 'has-danger' : '']
  }, [_c('div', {
    staticClass: "col-md-11"
  }, [_c('b-form-input', {
    staticClass: "col-md-12",
    attrs: {
      "type": "number",
      "id": "deeplink-id",
      "placeholder": "Enter numeric ID",
      "state": _vm.formData.deeplink.badId ? 'danger' : ''
    },
    on: {
      "change": function($event) {
        return _vm.checkDeeplinkId()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.checkDeeplinkId()
      }
    },
    model: {
      value: (_vm.formData.deeplink.id),
      callback: function($$v) {
        _vm.$set(_vm.formData.deeplink, "id", $$v)
      },
      expression: "formData.deeplink.id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1px",
      "margin-left": "15px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.deeplink.name) + "\n          ")])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "instructions"
  }, [_c('h2', [_vm._v("Instructions")]), _vm._v(" "), _c('p', [_vm._v("Enter instructions for the task that will appear in the app for this task. If left blank no instructions for this task will be shown.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-file', {
    ref: "pdffile",
    attrs: {
      "choose-label": (!_vm.formData.description_file && !_vm.formData.description_file_url) ? 'Choose PDF file' : 'Remove PDF file',
      "accept": ".pdf",
      "placeholder": _vm.formData.description_file_url
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearPdfFile($event)
      },
      "change": function($event) {
        return _vm.changePdfFile($event)
      }
    },
    model: {
      value: (_vm.formData.description_file),
      callback: function($$v) {
        _vm.$set(_vm.formData, "description_file", $$v)
      },
      expression: "formData.description_file"
    }
  })], 1)]), _vm._v(" "), (_vm.formData.instructionSteps.length == 0) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formData.description_file && !_vm.formData.description_file_url),
      expression: "!formData.description_file && !formData.description_file_url"
    }],
    staticClass: "instructions__step"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "instructions__step-buttons"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addNewStep
    }
  }, [_vm._v("Add steps")])], 1)])])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.instructionSteps), function(item, index) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.formData.description_file && !_vm.formData.description_file_url),
        expression: "!formData.description_file && !formData.description_file_url"
      }],
      staticClass: "instructions__step"
    }, [_c('div', {
      staticClass: "row align-items-baseline"
    }, [_vm._m(6, true), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _c('div', {
      class: [(!item.valid) ? 'has-danger' : '', 'col-md-1']
    }, [_c('b-form-input', {
      staticStyle: {
        "width": "55px"
      },
      attrs: {
        "type": "number"
      },
      on: {
        "change": function($event) {
          return _vm.validateSteps()
        }
      },
      model: {
        value: (item.order),
        callback: function($$v) {
          _vm.$set(item, "order", $$v)
        },
        expression: "item.order"
      }
    })], 1), _vm._v(" "), _c('p', {
      staticClass: "col-md-3 offset-md-3"
    }, [_c('b', [_vm._v("Attach\n              "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'image'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'image'
        }
      }
    }, [_vm._v("photo")]), _vm._v("\n              or\n              "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'video'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'video'
        }
      }
    }, [_vm._v("video")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(!item.valid) ? _c('div', {
      staticClass: "col-md-5 offset-md-3",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n              Please enter a number that is not used\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('span', {
      class: [(_vm.needFill && !item.description) ? 'has-danger' : '']
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: " instructions__step-text form-control",
      attrs: {
        "placeholder": "Enter step description"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "instructions__step-buttons"
    }, [(index == _vm.formData.instructionSteps.length - 1) ? _c('b-button', {
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": _vm.addNewStep
      }
    }, [_vm._v("Add one more step")]) : _vm._e(), _vm._v(" "), (index != _vm.formData.instructionSteps.length - 1) ? _c('div') : _vm._e(), _vm._v(" "), (_vm.formData.instructionSteps.length) ? _c('b-button', {
      attrs: {
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeStep(index)
        }
      }
    }, [_vm._v("Remove this step")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5",
      class: [(_vm.needFill && item.video_require) ? 'has-danger' : '']
    }, [(item.selectedContent == 'image') ? _c('thumbnail', {
      attrs: {
        "picture": item.picture,
        "picture_url": item.img
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "picture", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "img", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.selectedContent == 'video') ? [_c('div', {
      staticClass: "row ",
      class: [(_vm.needFill && item.video_require) ? 'form-control' : '']
    }, [_c('thumbnail', {
      attrs: {
        "picture": item.video_thumbnail,
        "picture_url": item.img_thumbnail
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "video_thumbnail", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "img_thumbnail", $event)
        }
      }
    }), _vm._v(" "), _c('b-form-file', {
      ref: "stepvideofile",
      refInFor: true,
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "accept": ".mp4, .mov",
        "choose-label": (!item.video && !item.video_url) ? 'Choose video' : 'Remove video',
        "placeholder": item.video_url
      },
      on: {
        "change": function($event) {
          return _vm.handleVideoFileChange($event)
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.clearStepVideo($event, item, index)
        }
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)] : _vm._e()], 2)])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "work-areas"
  }, [_c('h2', [_vm._v("Work areas and recurrence")]), _vm._v(" "), _c('div', [_vm._l((_vm.formData.workAreas), function(item, index) {
    return [_c('div', {
      staticClass: "row separator"
    }, [_vm._m(8, true), _vm._v(" "), _c('autocomplete', {
      attrs: {
        "suggest": _vm.formData.suggestArea,
        "anchor": "name",
        "process": _vm.processJSON,
        "on-select": _vm.getDataSearchArea,
        "additionalData": item
      }
    }), _vm._v(" "), _c('b-button', {
      staticClass: "col-md-2 offset-md-1 work-areas__btn",
      attrs: {
        "size": "",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          item.areaFromList = !item.areaFromList
        }
      }
    }, [_vm._v("Or select from list\n          ")]), _vm._v(" "), (item.areaFromList) ? _c('div', {
      staticClass: "col-md-3 offset-md-1"
    }, [_c('div', {
      staticClass: " work-areas__area-checkbox"
    }, [_c('area-checkbox', {
      attrs: {
        "type": "radio",
        "areas": _vm.areas,
        "baseId": 'areaCheckbox-' + index + '-',
        "selected": item.area
      },
      on: {
        "selectedAreaChanged": function($event) {
          return _vm.updateShiftsTableData()
        }
      },
      model: {
        value: (item.area),
        callback: function($$v) {
          _vm.$set(item, "area", $$v)
        },
        expression: "item.area"
      }
    })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.area.length) ? 'has-danger' : '', 'line']
    }, [_vm._m(9, true), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "selected-areas"
    }, _vm._l((item.area), function(item) {
      return _c('p', [_vm._v(_vm._s(item.name))])
    }), 0)])]), _vm._v(" "), _c('p', {}, [_c('b', [_vm._v("When")])]), _vm._v(" "), _c('b-form-radio', {
      attrs: {
        "options": item.scheduler.type.options
      },
      model: {
        value: (item.scheduler.type.selected),
        callback: function($$v) {
          _vm.$set(item.scheduler.type, "selected", $$v)
        },
        expression: "item.scheduler.type.selected"
      }
    }), _vm._v(" "), (item.scheduler.type.selected == 0) ? [(item.scheduler.forever) ? _c('p', [_vm._v("The task will be recurring indefinitely.\n            "), _c('span', {
      staticClass: "underline pointer",
      on: {
        "click": function($event) {
          item.scheduler.forever = false
        }
      }
    }, [_vm._v("Would you like to set specific time period?")])]) : _vm._e(), _vm._v(" "), (!item.scheduler.forever) ? _c('div', {
      staticClass: "row align-items-baseline"
    }, [_c('p', {
      class: [(item.scheduler.forever) ? 'gray-text' : ''],
      staticStyle: {
        "margin": "0 15px"
      }
    }, [_c('b', [_vm._v("From date")])]), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.scheduler.fromDate) ? 'has-danger' : '', 'date', (item.scheduler.forever) ? 'hide' : '']
    }, [_c('datepicker', {
      attrs: {
        "bootstrapStyling": true,
        "format": "dd-MM-yyyy",
        "placeholder": item.scheduler.fromDate ? '' : 'DD-MM-YYYY',
        "clear-button": ""
      },
      model: {
        value: (item.scheduler.fromDate),
        callback: function($$v) {
          _vm.$set(item.scheduler, "fromDate", $$v)
        },
        expression: "item.scheduler.fromDate"
      }
    })], 1), _vm._v(" "), _c('p', {
      class: [(item.scheduler.forever) ? 'gray-text' : ''],
      staticStyle: {
        "margin": "0 15px"
      }
    }, [_c('b', [_vm._v("To date")])]), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.scheduler.toDate) ? 'has-danger' : '', 'date', (item.scheduler.forever) ? 'hide' : '']
    }, [_c('datepicker', {
      attrs: {
        "bootstrapStyling": true,
        "format": "dd-MM-yyyy",
        "placeholder": item.scheduler.toDate ? '' : 'DD-MM-YYYY',
        "clear-button": ""
      },
      model: {
        value: (item.scheduler.toDate),
        callback: function($$v) {
          _vm.$set(item.scheduler, "toDate", $$v)
        },
        expression: "item.scheduler.toDate"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 mt-1"
    }, [_c('b-tabs', {
      ref: "tabs",
      refInFor: true,
      model: {
        value: (item.scheduler.tabIndex),
        callback: function($$v) {
          _vm.$set(item.scheduler, "tabIndex", $$v)
        },
        expression: "item.scheduler.tabIndex"
      }
    }, [_c('b-tab', {
      attrs: {
        "title": "By shifts"
      }
    }, [_c('p', {
      class: ['mt-1', (_vm.needFill && item.scheduler.byShift.isNotChecked) ? 'text-danger' : '']
    }, [_c('b', [_vm._v("Select shifts")])]), _vm._v(" "), _c('b-table', {
      attrs: {
        "items": item.scheduler.byShift.items,
        "fields": item.scheduler.byShift.fields,
        "small": ""
      },
      scopedSlots: _vm._u([_vm._l((item.scheduler.byShift.fields), function(itemField, key) {
        return {
          key: key,
          fn: function(data) {
            return [(data.value) ? _c('span', {
              class: [item.scheduler.byShift.items[data.index][key].checked ? 'checkmark' : '', 'pointer'],
              on: {
                "click": function($event) {
                  return _vm.onClickShift(item.scheduler.byShift, key, data.index)
                }
              }
            }, [_vm._v(_vm._s(data.value.value))]) : _vm._e()]
          }
        }
      }), _vm._l((item.scheduler.byShift.fields), function(itemField, key) {
        return {
          key: 'HEAD_' + key,
          fn: function(data) {
            return [_vm._v("\n                      " + _vm._s(itemField.name) + "\n                      "), _c('div', {
              staticClass: "select-shift-table__header",
              on: {
                "click": function($event) {
                  return _vm.onSelectAllShifts(key, item.scheduler.byShift)
                }
              }
            }, [(!itemField.allSelected) ? _c('span', [_vm._v("Select all shifts")]) : _c('span', [_vm._v("Deselect shifts")])])]
          }
        }
      })], null, true)
    })], 1), _vm._v(" "), _c('b-tab', {
      attrs: {
        "title": "Weekly"
      }
    }, [_c('b-form', {
      attrs: {
        "inline": true
      }
    }, [_c('p', {
      staticClass: "mt-1"
    }, [_vm._v("\n                    Recur every\n                    "), _c('b-form-input', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (item.scheduler.weekly.recurWeek),
        callback: function($$v) {
          _vm.$set(item.scheduler.weekly, "recurWeek", $$v)
        },
        expression: "item.scheduler.weekly.recurWeek"
      }
    }), _vm._v(" week"), (!item.scheduler.weekly.is_once_per_week) ? _c('span', [_vm._v(" on")]) : _vm._e()], 1)]), _vm._v(" "), (item.scheduler.weekly.is_once_per_week) ? _c('p', {
      staticClass: "underline pointer",
      on: {
        "click": function($event) {
          item.scheduler.weekly.is_once_per_week = false
        }
      }
    }, [_vm._v("Select days of the week")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.weekDays), function(week, weekIndex) {
      return (!item.scheduler.weekly.is_once_per_week) ? _c('b-form-checkbox', {
        key: weekIndex,
        attrs: {
          "value": week.value
        },
        model: {
          value: (item.scheduler.weekly.selected),
          callback: function($$v) {
            _vm.$set(item.scheduler.weekly, "selected", $$v)
          },
          expression: "item.scheduler.weekly.selected"
        }
      }, [_vm._v("\n                    " + _vm._s(week.label) + "\n                  ")]) : _vm._e()
    }), _vm._v(" "), (!item.scheduler.weekly.is_once_per_week) ? _c('span', {
      staticClass: "underline pointer cancel_right",
      on: {
        "click": function($event) {
          item.scheduler.weekly.is_once_per_week = true
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e()], 2), _vm._v(" "), _c('b-tab', {
      attrs: {
        "title": "Monthly"
      }
    }, [(item.scheduler.monthly.is_once_per_month) ? _c('div', [_c('b-form', {
      staticClass: "mt-1 ",
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "inline": true
      }
    }, [_c('p', [_vm._v("\n                      Recur every\n                      "), _c('b-form-input', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (item.scheduler.monthly.recurDay.month),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurDay, "month", $$v)
        },
        expression: "item.scheduler.monthly.recurDay.month"
      }
    }), _vm._v("\n                      month\n                      ")], 1)]), _vm._v(" "), (item.scheduler.monthly.is_once_per_month) ? _c('p', {
      staticClass: "underline pointer",
      on: {
        "click": function($event) {
          item.scheduler.monthly.is_once_per_month = false
        }
      }
    }, [_vm._v("Select days of the month")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.scheduler.monthly.is_once_per_month),
        expression: "!item.scheduler.monthly.is_once_per_month"
      }]
    }, [_c('input', {
      attrs: {
        "id": 'monthlyType-' + index + '-1',
        "type": "radio",
        "name": 'monthlyType-' + index,
        "checked": ""
      }
    }), _vm._v(" "), _c('b-form', {
      staticClass: "mt-1",
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "inline": true
      }
    }, [_vm._v("\n                      Recur on\n                      "), _c('b-form-input', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (item.scheduler.monthly.recurDay.day),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurDay, "day", $$v)
        },
        expression: "item.scheduler.monthly.recurDay.day"
      }
    }), _vm._v("\n                      day of every\n                      "), _c('b-form-input', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (item.scheduler.monthly.recurDay.month),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurDay, "month", $$v)
        },
        expression: "item.scheduler.monthly.recurDay.month"
      }
    }), _vm._v("\n                      month\n                    ")], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.scheduler.monthly.is_once_per_month),
        expression: "!item.scheduler.monthly.is_once_per_month"
      }]
    }, [_c('input', {
      staticStyle: {
        "display": "inline"
      },
      attrs: {
        "id": 'monthlyType-' + index + '-2',
        "type": "radio",
        "name": 'monthlyType-' + index
      }
    }), _vm._v(" "), _c('b-form', {
      staticClass: "mt-1",
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "inline": true,
        "name": "bla"
      }
    }, [_vm._v("\n                      The\n                      "), _c('b-form-select', {
      attrs: {
        "options": _vm.weekNumbersItem
      },
      model: {
        value: (item.scheduler.monthly.recurWeekDay.every),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurWeekDay, "every", $$v)
        },
        expression: "item.scheduler.monthly.recurWeekDay.every"
      }
    }), _vm._v(" "), _c('b-form-select', {
      attrs: {
        "options": _vm.weekdays
      },
      model: {
        value: (item.scheduler.monthly.recurWeekDay.weekDay),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurWeekDay, "weekDay", $$v)
        },
        expression: "item.scheduler.monthly.recurWeekDay.weekDay"
      }
    }), _vm._v("\n                      of every "), _c('b-form-input', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (item.scheduler.monthly.recurWeekDay.month),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurWeekDay, "month", $$v)
        },
        expression: "item.scheduler.monthly.recurWeekDay.month"
      }
    }), _vm._v("\n                      month\n                    ")], 1)], 1), _vm._v(" "), (!item.scheduler.monthly.is_once_per_month) ? _c('span', {
      staticClass: "underline pointer cancel_right",
      on: {
        "click": function($event) {
          item.scheduler.monthly.is_once_per_month = true
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e()])], 1)], 1)])] : [_c('div', {
      staticClass: "row mt-1 align-items-baseline"
    }, [_vm._m(10, true), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.scheduler.oneDay.date) ? 'has-danger' : '', 'date']
    }, [_c('datepicker', {
      attrs: {
        "bootstrapStyling": true,
        "format": "dd-MM-yyyy",
        "placeholder": item.scheduler.oneDay.date ? '' : 'DD-MM-YYYY'
      },
      on: {
        "input": function($event) {
          return _vm.updateOneDayShifts(item.scheduler.oneDay)
        }
      },
      model: {
        value: (item.scheduler.oneDay.date),
        callback: function($$v) {
          _vm.$set(item.scheduler.oneDay, "date", $$v)
        },
        expression: "item.scheduler.oneDay.date"
      }
    })], 1)]), _vm._v(" "), _c('p', {
      class: ['mt-1']
    }, [_c('b', [_vm._v("At shift")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticStyle: {
        "margin": "0 15px"
      }
    }, [_c('b-table', {
      attrs: {
        "items": item.scheduler.oneDay.item,
        "fields": item.scheduler.oneDay.field,
        "small": ""
      },
      scopedSlots: _vm._u([_vm._l((item.scheduler.oneDay.field), function(itemField, key) {
        return {
          key: key,
          fn: function(data) {
            return [(data.value) ? _c('span', {
              class: [item.scheduler.oneDay.items[data.index][key].checked ? 'checkmark' : '', 'pointer'],
              on: {
                "click": function($event) {
                  return _vm.onClickShift(item.scheduler.oneDay, key, data.index)
                }
              }
            }, [_vm._v(_vm._s(data.value.value))]) : _vm._e()]
          }
        }
      }), _vm._l((item.scheduler.oneDay.field), function(itemField, key) {
        return {
          key: 'HEAD_' + key,
          fn: function(data) {
            return [_vm._v("\n                  " + _vm._s(itemField.name) + "\n                  "), _c('div', {
              staticClass: "select-shift-table__header",
              on: {
                "click": function($event) {
                  return _vm.onSelectAllShifts(key, item.scheduler.oneDay)
                }
              }
            }, [(!itemField.allSelected) ? _c('span', [_vm._v("Select all shifts")]) : _c('span', [_vm._v("Deselect shifts")])])]
          }
        }
      })], null, true)
    })], 1)])], _vm._v(" "), _c('div', {
      staticClass: "row align-items-baseline"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [(index == _vm.formData.workAreas.length - 1) ? _c('b-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "line",
      attrs: {
        "size": "",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.addOneMoreArea()
        }
      }
    }, [_vm._v("Add one more area and recurrence rule\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [(_vm.formData.workAreas.length > 1) ? _c('b-button', {
      staticClass: "line",
      attrs: {
        "size": "",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOneArea(index)
        }
      }
    }, [_vm._v("Delete area and recurrence rule\n        ")]) : _vm._e()], 1)])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [(!_vm.duplicate && _vm.taskId) ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.duplicateTask(true)
      }
    }
  }, [_vm._v("\n            Duplicate\n          ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveTask(true)
      }
    }
  }, [_vm._v("\n            Save and add another\n          ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveTask()
      }
    }
  }, [_vm._v("\n            Save task\n          ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteTask()
      }
    }
  }, [_vm._v("\n            Delete task\n          ")])], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "delete_task",
    attrs: {
      "title": ""
    },
    on: {
      "ok": function($event) {
        return _vm.taskMustDelete();
      }
    }
  }, [_vm._v("\n      You are about to delete this task. Are you sure?\n    ")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 duplicat-warning"
  }, [_c('p', [_vm._v("Details are copied from the original. If you don't make any changes and save, the item will be duplicated!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', [_vm._v("Add a task on this page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Assign to user role")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_vm._v("OR "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("upload a PDF file with task instructions.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Step")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2 align-baseline"
  }, [_c('b', [_vm._v("Search working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Selected working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0 15px"
    }
  }, [_c('p', [_c('b', [_vm._v("On date")])])])
}]}

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header text-left"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "inverse",
      "variant": "black"
    }
  }, [_c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": _vm.getHomeUrl()
    }
  }, [(_vm.authUser && _vm.authUser.company && _vm.authUser.company.picture) ? [(_vm.authUser && _vm.authUser.company && _vm.authUser.company.picture) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.authUser.company.picture,
      "alt": ""
    }
  }) : _vm._e()] : [(_vm.company && _vm.company.picture) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.company.picture,
      "alt": ""
    }
  }) : _vm._e()], _vm._v(" "), _c('span', [_vm._v(" EZ GO Console")])], 2), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('div', {
    staticClass: "user-dropdown"
  }, [(_vm.authUser) ? _c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [(_vm.authUser) ? _c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticClass: "username",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.authUser.first_name) + " " + _vm._s(_vm.authUser.last_name))]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [(_vm.authUser && _vm.authUser.company) ? [_vm._v("\n                " + _vm._s(_vm.authUser.company.name) + "\n              ")] : (_vm.company && _vm.company.name) ? [_vm._v("\n                " + _vm._s(_vm.company.name) + "\n              ")] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.userLogout($event)
      }
    }
  }, [_vm._v("logout")])], 2) : _vm._e()], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "users-permissions"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('div', [
    [_c('b-breadcrumb', {
      staticClass: "breadCrumb",
      attrs: {
        "items": _vm.breadCrumbItems
      }
    })]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-tabs', {
    ref: "tabs",
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Administration"
    }
  }, [_c('div', {
    staticClass: " wrap-tab-item text-left"
  }, [_c('b-table', {
    attrs: {
      "items": _vm.usersList.filter(function (obj) { return obj.role && obj.role != 'basic'; }),
      "fields": _vm.fieldsAdmin,
      "filter": _vm.filter,
      "hover": ""
    },
    on: {
      "row-clicked": _vm.onAdminRowClick
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(data) {
        return [_vm._v("\n                  " + _vm._s(data.index + 1) + "\n                ")]
      }
    }, {
      key: "first_name",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }, {
      key: "last_name",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }, {
      key: "role_display",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }, {
      key: "areas",
      fn: function(item) {
        return _vm._l((_vm.getUserArea(item.value)), function(area) {
          return _c('p', [_vm._v(_vm._s(area))])
        })
      }
    }, {
      key: "upn",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }])
  })], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Basic users"
    }
  }, [_c('div', {
    staticClass: " wrap-tab-item text-left"
  }, [_c('b-table', {
    attrs: {
      "items": _vm.usersList.filter(function (obj) { return obj.role == 'basic'; }),
      "fields": _vm.fieldsBasic,
      "filter": _vm.filter,
      "hover": ""
    },
    on: {
      "row-clicked": _vm.onBasicRowClick
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(data) {
        return [_vm._v("\n                  " + _vm._s(data.index + 1) + "\n                ")]
      }
    }, {
      key: "first_name",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }, {
      key: "last_name",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }, {
      key: "areas",
      fn: function(item) {
        return _vm._l((_vm.getUserArea(item.value)), function(area) {
          return _c('p', [_vm._v(_vm._s(area))])
        })
      }
    }, {
      key: "upn",
      fn: function(item) {
        return [_vm._v("\n                  " + _vm._s(item.value) + "\n                ")]
      }
    }])
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [(_vm.tabIndex == 0) ? _c('b-button', {
    staticClass: "add-btn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAddAdminClick()
      }
    }
  }, [_vm._v("\n            Add administrator\n          ")]) : _vm._e(), _vm._v(" "), (_vm.tabIndex == 1) ? _c('b-button', {
    staticClass: "add-btn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAddUserClick()
      }
    }
  }, [_vm._v("\n            Add basic user\n          ")]) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "horizontal": "",
      "label": "",
      "label-cols": 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "debounce",
      rawName: "v-debounce",
      value: (500),
      expression: "500"
    }],
    attrs: {
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  })])], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "company-config"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('uploading', {
    attrs: {
      "uploaded": _vm.upload.uploaded,
      "total": _vm.upload.total,
      "visible": _vm.upload.visible,
      "image": _vm.upload.image
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Well Done!")]), _vm._v(" "), _c('p', [_vm._v("Saved successfully")])]), _vm._v(" "), _c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  }), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.needFill && !_vm.company.name) ? 'danger' : ''
    }
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Company name")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.company.name ? '' : 'Enter company name'
    },
    model: {
      value: (_vm.company.name),
      callback: function($$v) {
        _vm.$set(_vm.company, "name", $$v)
      },
      expression: "company.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row align-items-baseline"
  }, [_vm._m(0), _vm._v(" "), _c('thumbnail', {
    attrs: {
      "picture": _vm.company.picture,
      "picture_url": _vm.company.picture_url
    },
    on: {
      "update:picture": function($event) {
        return _vm.$set(_vm.company, "picture", $event)
      },
      "update:picture_url": function($event) {
        return _vm.$set(_vm.company, "picture_url", $event)
      },
      "change": function($event) {
        _vm.haveChanges = true
      }
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row align-items-baseline"
  }, [_vm._m(1), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "time"
    },
    on: {
      "change": function($event) {
        _vm.haveChanges = true
      }
    },
    model: {
      value: (_vm.company.logoff_after),
      callback: function($$v) {
        _vm.$set(_vm.company, "logoff_after", $$v)
      },
      expression: "company.logoff_after"
    }
  }), _c('span', [_vm._v(" (minimum of 1 hour)")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "text-left mt-2"
  }, [_vm._v("Admin account details")]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.needFill && !_vm.formData.first_name) ? 'danger' : ''
    }
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("First name")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.first_name ? '' : 'Enter name'
    },
    model: {
      value: (_vm.formData.first_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "first_name", $$v)
      },
      expression: "formData.first_name"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.needFill && !_vm.formData.last_name) ? 'danger' : ''
    }
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Last name")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.last_name ? '' : 'Enter last name'
    },
    model: {
      value: (_vm.formData.last_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "last_name", $$v)
      },
      expression: "formData.last_name"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', {
    class: [(_vm.needFill && !_vm.formData.username && !_vm.formData.email) ? 'has-danger' : '', 'row']
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Username")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.username ? '' : 'Enter username'
    },
    model: {
      value: (_vm.formData.username),
      callback: function($$v) {
        _vm.$set(_vm.formData, "username", $$v)
      },
      expression: "formData.username"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (!_vm.needFill || _vm.formData.email.length == 0) ? '' : (!_vm.validateEmail(_vm.formData.email)) ? 'danger' : ''
    }
  }, [_c('div', {
    class: [(_vm.needFill && !_vm.formData.username && !_vm.formData.email) ? 'has-danger' : '', 'row align-items-baseline']
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Email")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.email ? '' : 'Enter email',
      "state": (!_vm.needFill || _vm.formData.email.length == 0) ? '' : (!_vm.validateEmail(_vm.formData.email)) ? 'danger' : ''
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Phone")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.phone ? '' : 'Enter Phone'
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.needFill && (!_vm.formData.id && !_vm.formData.password)) ? 'danger' : ''
    }
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Password")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3",
    attrs: {
      "type": "password",
      "placeholder": _vm.formData.password ? '' : 'Enter password'
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 small red"
  }, [_vm._v("\n        Minimum password requirements "), _c('br'), _vm._v("6 characters, one capital, one number\n      ")])], 1)]), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "state": (_vm.formData.password.length == 0) ? '' : (_vm.formData.confirmPassword != _vm.formData.password) ? 'danger' : 'success'
    }
  }, [_c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Confirm Password")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-3 ",
    attrs: {
      "type": "password",
      "placeholder": _vm.formData.confirmPassword ? '' : 'Enter password',
      "state": (_vm.formData.password.length == 0) ? '' : (_vm.formData.confirmPassword != _vm.formData.password) ? 'danger' : 'success'
    },
    model: {
      value: (_vm.formData.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.formData, "confirmPassword", $$v)
      },
      expression: "formData.confirmPassword"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [(_vm.haveChanges || !_vm.company.id) ? _c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Save\n      ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.cancelData()
      }
    }
  }, [_vm._v("Cancel\n      ")])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "user_added",
    attrs: {
      "title": ""
    },
    on: {
      "ok": function($event) {
        return _vm.returnBack()
      },
      "hide": function($event) {
        return _vm.returnBack()
      }
    }
  }, [_vm._v("\n    User created\n\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "leavingConfirm",
    attrs: {
      "title": ""
    }
  }, [_vm._v("\n    You are about to leave page with unsaved changes?\n    "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.discardChanges()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.leavingConfirm.hide()
      }
    }
  }, [_vm._v("Cancel")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "auto",
      "margin-bottom": "auto"
    }
  }, [_c('b', [_vm._v("Company logo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Logoff after (hours)")])])
}]}

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "onLogout": _vm.onLogout,
      "access_token": _vm.access_token,
      "authUser": _vm.authUser
    },
    on: {
      "onLogin": _vm.onLogin
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "audit-config"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('uploading', {
    attrs: {
      "uploaded": _vm.upload.uploaded,
      "total": _vm.upload.total,
      "visible": _vm.upload.visible,
      "image": _vm.upload.image
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.confirm-audit-dup",
      modifiers: {
        "confirm-audit-dup": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("\n          Duplicate\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveAudit()
      }
    }
  }, [_vm._v("\n          Save\n        ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.confirm-audit-del",
      modifiers: {
        "confirm-audit-del": true
      }
    }],
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("\n          Delete whole audit\n        ")])], 1)]), _vm._v(" "), (_vm.duplicate) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirm-audit-dup",
      "title": "Duplicate Audit",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        return _vm.duplicateAudit(true)
      }
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("This action will duplicate the entire content of this audit."), _c('br'), _vm._v("Do you want to proceed?")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirm-audit-del",
      "title": "Delete Audit",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        return _vm.deleteAudit()
      }
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("Are you sure you want to delete the whole audit")])]), _vm._v(" "), _c('h2', [_vm._v("Basic information")]), _vm._v(" "), _c('div', {
    staticClass: "basic-info-wrapper"
  }, [_c('div', {
    class: [(_vm.needFill && !_vm.formData.name) ? 'has-danger' : '', 'row basic-info__title']
  }, [_vm._m(1), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-7",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.name ? '' : 'Enter audit title',
      "maxlength": "255"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('thumbnail', {
    attrs: {
      "picture": _vm.formData.picture,
      "picture_url": _vm.formData.picture_url
    },
    on: {
      "update:picture": function($event) {
        return _vm.$set(_vm.formData, "picture", $event)
      },
      "update:picture_url": function($event) {
        return _vm.$set(_vm.formData, "picture_url", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.formData.role) ? 'has-danger' : '', 'row basic-info__title']
  }, [_vm._m(3), _vm._v(" "), _c('b-form-select', {
    staticClass: "col-md-3",
    attrs: {
      "options": _vm.userRoles,
      "value-field": "id",
      "text-field": "name"
    },
    model: {
      value: (_vm.formData.role),
      callback: function($$v) {
        _vm.$set(_vm.formData, "role", $$v)
      },
      expression: "formData.role"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row separator mt-2"
  }, [_vm._m(4), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggest": _vm.suggestArea,
      "anchor": "name",
      "process": _vm.processJSON,
      "on-select": _vm.getDataSearchArea
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.areaFromList = !_vm.areaFromList
      }
    }
  }, [_vm._v("Or select from list\n          ")])], 1), _vm._v(" "), (_vm.areaFromList) ? _c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('div', {
    staticClass: " work-areas__area-checkbox"
  }, [_c('area-checkbox', {
    attrs: {
      "type": "radio",
      "areas": _vm.areas,
      "baseId": 'areaCheckbox',
      "selected": _vm.formData.area
    },
    on: {
      "selectedAreaChanged": function($event) {}
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.formData.area.length) ? 'has-danger' : '', 'line']
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "selected-areas"
  }, _vm._l((_vm.formData.area), function(item) {
    return _c('p', [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "options": _vm.signatureCountOptions
    },
    model: {
      value: (_vm.formData.signatureCount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "signatureCount", $$v)
      },
      expression: "formData.signatureCount"
    }
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('b-form-radio', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "disabled": _vm.is_performed,
      "options": _vm.scoreTypeOptions
    },
    model: {
      value: (_vm.formData.score_type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "score_type", $$v)
      },
      expression: "formData.score_type"
    }
  }), _vm._v(" "), (_vm.is_performed) ? _c('span', [_vm._v("Once an audit has been executed, the scoring system can no longer be changed.")]) : _vm._e(), _vm._v(" "), (_vm.formData.score_type == 'score') ? _c('div', {
    staticClass: "row score-point"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lowScore),
      expression: "formData.lowScore"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "name": "lowScore",
      "type": "number",
      "min": "0",
      "max": _vm.formData.highScore - 1,
      "step": "1",
      "disabled": _vm.is_performed
    },
    domProps: {
      "value": (_vm.formData.lowScore)
    },
    on: {
      "change": function($event) {
        return _vm.onScoreChange($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lowScore", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.highScore),
      expression: "formData.highScore"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "name": "highScore",
      "type": "number",
      "min": +_vm.formData.lowScore + 1,
      "max": "10",
      "step": "1",
      "disabled": _vm.is_performed
    },
    domProps: {
      "value": (_vm.formData.highScore)
    },
    on: {
      "change": function($event) {
        return _vm.onScoreChange($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "highScore", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.formData.id) ? _c('b-button', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveAudit()
      }
    }
  }, [_vm._v("\n        Save and continue\n      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.formData.id) ? _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-3",
    on: {
      "click": function($event) {
        _vm.showTasks = !_vm.showTasks
      }
    }
  }, [_c('b', [_vm._v("Audit questions")])])]) : _vm._e(), _vm._v(" "), (_vm.formData.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('p', {
    staticClass: "questions-wrapper",
    attrs: {
      "id": "collapse-audits"
    }
  }, [_c('b-list-group', [(!_vm.formData.tasks.length) ? _c('b-list-group-item', {
    staticClass: "list-group-question"
  }, [_vm._v("\n              There are no questions in this audit yet\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.tasks), function(item, index) {
    return _c('b-list-group-item', {
      key: index,
      staticClass: "list-group-question draggable",
      attrs: {
        "active": index === _vm.activeTask,
        "draggable": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.activeTaskNext = index
        },
        "drop": function($event) {
          return _vm.handleDrop($event, index)
        },
        "dragstart": function($event) {
          return _vm.handleDragStart($event, item, index)
        },
        "dragend": function($event) {
          return _vm.handleDragEnd($event, item, index)
        },
        "dragover": function($event) {
          return _vm.handleDragOver($event, index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  })], 2)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "",
      "variant": "primary"
    },
    on: {
      "click": _vm.addEmptyTask
    }
  }, [_vm._v("+ Add one more question")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, _vm._l((_vm.formData.tasks), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTask === index),
        expression: "activeTask === index"
      }],
      staticClass: "question-wrapper"
    }, [_c('h2', [_vm._v("Audit question information")]), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.name) ? 'has-danger' : '', 'row basic-info__title']
    }, [_vm._m(10, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "col-md-9 form-control",
      attrs: {
        "type": "text",
        "placeholder": "Enter question title",
        "maxlength": "255"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "change": function($event) {
          return _vm.onChangeAuditTask()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.description) ? 'has-danger' : '', 'row']
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "col-md-10 basic-info__description form-control",
      attrs: {
        "placeholder": "Enter description"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "change": function($event) {
          return _vm.onChangeAuditTask()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row mt-1 "
    }, [_c('p', {
      staticClass: "col-md-3"
    }, [_c('b', [_vm._v("Upload "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'image'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'image'
        }
      }
    }, [_vm._v("image")]), _vm._v("\n            or\n            "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'video'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'video'
        }
      }
    }, [_vm._v("video")]), _vm._v(" for this question")]), _vm._v(" (if none, default icon will be used)")]), _vm._v(" "), (item.selectedContent == 'image') ? _c('thumbnail', {
      attrs: {
        "picture": item.picture,
        "picture_url": item.picture_url
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "picture", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "picture_url", $event)
        },
        "change": function($event) {
          return _vm.onChangeAuditTask()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.selectedContent == 'video'),
        expression: "item.selectedContent == 'video'"
      }],
      class: [(item.video_require) ? 'has-danger' : ''],
      attrs: {
        "id": ""
      }
    }, [_c('div', {
      class: [(item.video_require) ? 'form-control' : '']
    }, [_c('thumbnail', {
      attrs: {
        "picture": item.video_thumbnail,
        "picture_url": item.thumbnail_url
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "video_thumbnail", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "thumbnail_url", $event)
        }
      }
    }), _vm._v(" "), _c('b-form-file', {
      ref: "auditItemVideoFile",
      refInFor: true,
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "accept": ".mp4, .mov",
        "choose-label": (!item.video && !item.video_url) ? 'Choose video' : 'Remove video',
        "placeholder": item.video_url
      },
      on: {
        "change": function($event) {
          return _vm.handleVideoFileChange($event)
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.clearAuditItemVideo($event, item, index)
        }
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "row mt-1 align-items-center"
    }, [_vm._m(12, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('b-form-input', {
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "type": "number"
      },
      on: {
        "change": function($event) {
          return _vm.onChangeAuditTask()
        }
      },
      model: {
        value: (item.weight),
        callback: function($$v) {
          _vm.$set(item, "weight", $$v)
        },
        expression: "item.weight"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "row mt-1 align-items-center",
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_vm._m(13, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-9"
    }, [_c('multiselect', {
      attrs: {
        "tag-placeholder": "Add this as new tag",
        "placeholder": "Search or add a tag",
        "label": "name",
        "track-by": "code",
        "options": _vm.tagsOptions,
        "multiple": true,
        "taggable": true
      },
      on: {
        "tag": function (tag) { return _vm.addTag(item, tag); },
        "input": function (tag) { return _vm.updateTags(item, tag); }
      },
      model: {
        value: (item.tagsValue),
        callback: function($$v) {
          _vm.$set(item, "tagsValue", $$v)
        },
        expression: "item.tagsValue"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "instructions"
    }, [_c('h2', [_vm._v("Instructions")]), _vm._v(" "), _c('p', [_vm._v("Enter instructions for the task that will appear in the app for this question. If left blank no instructions for this question will be shown.")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(14, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [_c('b-form-file', {
      ref: 'pdffile' + index,
      refInFor: true,
      attrs: {
        "placeholder": item.description_file_url,
        "choose-label": (!item.description_file && !item.description_file_url) ? 'Choose PDF file' : 'Remove PDF file',
        "accept": ".pdf"
      },
      nativeOn: {
        "click": function($event) {
          _vm.clearPdfFile($event, index);
          (item.description_file) ? _vm.onChangeAuditTask(): '';
        },
        "change": function($event) {
          _vm.onChangeAuditTask();
          _vm.changePdfFile($event, index);
        }
      },
      model: {
        value: (item.description_file),
        callback: function($$v) {
          _vm.$set(item, "description_file", $$v)
        },
        expression: "item.description_file"
      }
    })], 1)]), _vm._v(" "), (!item.steps.length) ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((!item.description_file && !item.description_file_url)),
        expression: "(!item.description_file && !item.description_file_url)"
      }],
      staticClass: "instructions__step"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "instructions__step-buttons"
    }, [_c('b-button', {
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          _vm.addEmptyStep(item);
          _vm.onChangeAuditTask()
        }
      }
    }, [_vm._v("Add steps")])], 1)])])])] : _vm._e(), _vm._v(" "), _vm._l((item.steps), function(step, index) {
      return [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((!item.description_file && !item.description_file_url)),
          expression: "(!item.description_file && !item.description_file_url)"
        }],
        staticClass: "instructions__step"
      }, [_c('div', {
        staticClass: "row align-items-baseline"
      }, [_vm._m(15, true), _vm._v(" "), _vm._m(16, true), _vm._v(" "), _c('div', {
        class: [(!step.valid) ? 'has-danger' : '', 'col-md-1']
      }, [_c('b-form-input', {
        staticStyle: {
          "width": "55px"
        },
        attrs: {
          "type": "number"
        },
        on: {
          "change": function($event) {
            _vm.validateSteps(item);
            _vm.onChangeAuditTask();
          }
        },
        model: {
          value: (step.order),
          callback: function($$v) {
            _vm.$set(step, "order", $$v)
          },
          expression: "step.order"
        }
      })], 1), _vm._v(" "), _c('p', {
        staticClass: "col-md-5 offset-md-3"
      }, [_c('b', [_vm._v("Attach\n                    "), _c('span', {
        staticClass: "underline pointer image-video",
        class: {
          'image-video_active': step.selectedContent == 'image'
        },
        on: {
          "click": function($event) {
            step.selectedContent = 'image'
          }
        }
      }, [_vm._v("photo")]), _vm._v("\n                    or\n                    "), _c('span', {
        staticClass: "underline pointer image-video",
        class: {
          'image-video_active': step.selectedContent == 'video'
        },
        on: {
          "click": function($event) {
            step.selectedContent = 'video'
          }
        }
      }, [_vm._v("video")])])])]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [(!step.valid) ? _c('div', {
        staticClass: "col-md-5 offset-md-3",
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("\n                    Please enter a number that is not used\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-7"
      }, [_c('span', {
        class: [(_vm.needFill && !step.description) ? 'has-danger' : '']
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (step.description),
          expression: "step.description"
        }],
        staticClass: " instructions__step-text form-control",
        attrs: {
          "placeholder": "Enter step description"
        },
        domProps: {
          "value": (step.description)
        },
        on: {
          "change": function($event) {
            return _vm.onChangeAuditTask()
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(step, "description", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "instructions__step-buttons"
      }, [(index == item.steps.length - 1) ? _c('b-button', {
        attrs: {
          "variant": "primary"
        },
        on: {
          "click": function($event) {
            _vm.addEmptyStep(item);
            _vm.onChangeAuditTask()
          }
        }
      }, [_vm._v("Add one more step")]) : _vm._e(), _vm._v(" "), (index != item.steps.length - 1) ? _c('div') : _vm._e(), _vm._v(" "), (item.steps.length) ? _c('b-button', {
        attrs: {
          "variant": "danger"
        },
        on: {
          "click": function($event) {
            _vm.removeStep(item, index);
            _vm.onChangeAuditTask()
          }
        }
      }, [_vm._v("Remove this step")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
        staticClass: "col-md-5"
      }, [(step.selectedContent == 'image') ? _c('thumbnail', {
        attrs: {
          "picture": step.picture,
          "picture_url": step.picture_url
        },
        on: {
          "update:picture": function($event) {
            return _vm.$set(step, "picture", $event)
          },
          "update:picture_url": function($event) {
            return _vm.$set(step, "picture_url", $event)
          },
          "change": function($event) {
            return _vm.onChangeAuditTask()
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (step.selectedContent == 'video'),
          expression: "step.selectedContent == 'video'"
        }],
        class: [(step.video_require) ? 'has-danger' : ''],
        attrs: {
          "id": ""
        }
      }, [_c('div', {
        staticClass: "row ",
        class: [(step.video_require) ? 'form-control' : '']
      }, [_c('thumbnail', {
        attrs: {
          "picture": step.video_thumbnail,
          "picture_url": step.thumbnail_url
        },
        on: {
          "update:picture": function($event) {
            return _vm.$set(step, "video_thumbnail", $event)
          },
          "update:picture_url": function($event) {
            return _vm.$set(step, "thumbnail_url", $event)
          }
        }
      }), _vm._v(" "), _c('b-form-file', {
        ref: "stepvideofile",
        refInFor: true,
        staticStyle: {
          "margin-top": "10px"
        },
        attrs: {
          "accept": ".mp4, .mov",
          "choose-label": (!step.video && !step.video_url) ? 'Choose video' : 'Remove video',
          "placeholder": step.video_url
        },
        on: {
          "change": function($event) {
            return _vm.handleVideoFileChange($event)
          }
        },
        nativeOn: {
          "click": function($event) {
            return _vm.clearStepVideo($event, step, index)
          }
        },
        model: {
          value: (step.video),
          callback: function($$v) {
            _vm.$set(step, "video", $$v)
          },
          expression: "step.video"
        }
      })], 1)])], 1)])])]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "instructions__step-buttons"
    }, [_c('b-button', {
      attrs: {
        "variant": "success"
      },
      on: {
        "click": function($event) {
          return _vm.saveTask(item)
        }
      }
    }, [_vm._v("Save this question")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTask(item, index)
        }
      }
    }, [_vm._v("Delete this question")])], 1)])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "leavingItemConfirm",
    attrs: {
      "title": ""
    }
  }, [_vm._v("\n      You have unsaved changes in this item. You want to:\n      "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.saveTask(_vm.formData.tasks[_vm.activeTask]);
        _vm.$refs.leavingItemConfirm.hide();
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.discardTaskChanges(_vm.activeTask);
        _vm.$refs.leavingItemConfirm.hide();
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$refs.leavingItemConfirm.hide();
        _vm.activeTaskNext = null;
      }
    }
  }, [_vm._v("Return to this item")])], 1)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 duplicat-warning"
  }, [_c('p', [_vm._v("Details are copied from the original. If you don't make any changes and save, the item will be duplicated!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Audit title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('b', [_vm._v("Upload main audit image")]), _vm._v(" (if none, default icon will be used)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Assign to user role")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2 align-baseline"
  }, [_c('b', [_vm._v("Search working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Selected working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("The audit needs to be sign at the end?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Audit score type")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-point__text"
  }, [_c('b', [_vm._v("Lowest point")]), _c('br'), _vm._v("enter a digit min 0\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-point__text"
  }, [_c('b', [_vm._v("Highest  point")]), _c('br'), _vm._v("enter a digit higher than lowest max 10\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2 mt-1"
  }, [_c('b', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('b', [_vm._v("Question weight")]), _vm._v(" (enter a multiplier for this question score. If nothing entered use 1 as default)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('b', [_vm._v("Tags")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_vm._v("OR "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("upload a PDF file with task instructions.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Step")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Order")])])
}]}

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "working-areas"
  }, [_c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  }), _vm._v(" "), _c('p', [_vm._v("Here you can create, manage and edit your company structure.")]), _vm._v(" "), _c('div', {
    staticClass: "areas-wrapper",
    attrs: {
      "id": "areas-wrapper"
    }
  }, _vm._l((_vm.globalArea), function(value, index) {
    return _c('div', {
      staticClass: "area"
    }, [_c('b-list-group', {
      style: ('padding-top: ' + _vm.getMarginTopArea(index) + 'px')
    }, [_vm._l((value), function(item, key) {
      return [(item.is_active) ? _c('b-list-group-item', {
        class: ['list-grouped', !item.is_active ? 'danger' : ''],
        attrs: {
          "active": item.id == value.activeId
        },
        nativeOn: {
          "click": function($event) {
            value.activeId = item.id;
            _vm.onClick($event, item, index)
          }
        }
      }, [_c('div', {
        staticClass: "list-group__text"
      }, [_c('img', {
        staticClass: "list-group__img",
        attrs: {
          "src": item.picture
        }
      }), _vm._v("\n                " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('b-dropdown', {
        staticClass: "m-md-2 dropdown-action",
        attrs: {
          "text": "Action"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.dropdownShowen()
          }
        }
      }, [_c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalChangeAreaName($event, index, key)
          }
        }
      }, [_vm._v("Edit name")]), _vm._v(" "), _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.setWorkHours(item.id, item.custom_shifts)
          }
        }
      }, [_vm._v("Set custom work hours")]), _vm._v(" "), (_vm.isHaveSubarea(item.subareas)) ? _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalDeleteSubArea($event, index, key)
          }
        }
      }, [_vm._v("Remove subordinate")]) : _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalAddArea($event, index, key)
          }
        }
      }, [_vm._v("Add subordinate")]), _vm._v(" "), _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalDeleteArea($event, index, key)
          }
        }
      }, [_vm._v("Delete object")]), _vm._v(" "), _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalChangeAreaPicture($event, index, key)
          }
        }
      }, [_vm._v("Assign icon")]), _vm._v(" "), _c('b-dropdown-item', {
        on: {
          "click": function($event) {
            return _vm.showModalChangeAreaLabel($event, index, key)
          }
        }
      }, [_vm._v("Add label")])], 1)], 1) : _vm._e()]
    }), _vm._v(" "), (index == 0 || _vm.isHaveSubarea(value)) ? _c('b-list-group-item', {
      staticClass: "add-new-area"
    }, [_c('span', {
      staticClass: "add-new-area",
      on: {
        "click": function($event) {
          return _vm.showModalAddArea($event, index)
        }
      }
    }, [_vm._v("\n            + add one more\n            ")]), _vm._v(" "), _c('b-modal', {
      ref: "modalAddArea",
      refInFor: true,
      attrs: {
        "title": "Add area"
      },
      on: {
        "ok": function($event) {
          return _vm.submitAddNewArea($event, index)
        },
        "shown": _vm.clearName
      }
    }, [_c('form', {
      on: {
        "submit": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.submitAddNewArea($event, index)
        }
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "placeholder": "Enter new area name"
      },
      model: {
        value: (_vm.newAreaName),
        callback: function($$v) {
          _vm.newAreaName = $$v
        },
        expression: "newAreaName"
      }
    })], 1)])], 1) : _vm._e()], 2)], 1)
  }), 0), _vm._v(" "), _c('b-modal', {
    ref: "modalChangeAreaPicture",
    attrs: {
      "title": "Change area icon"
    },
    on: {
      "ok": function($event) {
        return _vm.submitChangeAreaPicture($event)
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitChangeAreaPicture($event)
      }
    }
  }, [_c('b-form-file', {
    ref: "pictureFileInput",
    attrs: {
      "placeholder": "New area icon",
      "accept": ".jpg, .jpeg, .png"
    },
    nativeOn: {
      "change": function($event) {
        return _vm.changeImageFile($event)
      }
    },
    model: {
      value: (_vm.areaModal.picture),
      callback: function($$v) {
        _vm.$set(_vm.areaModal, "picture", $$v)
      },
      expression: "areaModal.picture"
    }
  })], 1), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalChangeNameArea",
    attrs: {
      "title": "Change area name"
    },
    on: {
      "ok": function($event) {
        return _vm.submitChangeArea($event)
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitChangeArea($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaModal.name),
      expression: "areaModal.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "New area name"
    },
    domProps: {
      "value": (_vm.areaModal.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.areaModal, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('b-modal', {
    ref: "modalChangeLabelArea",
    attrs: {
      "title": "Change area label"
    },
    on: {
      "ok": function($event) {
        return _vm.submitChangeAreaLabel($event)
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitChangeAreaLabel($event)
      }
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "New area label"
    },
    model: {
      value: (_vm.areaModal.label),
      callback: function($$v) {
        _vm.$set(_vm.areaModal, "label", $$v)
      },
      expression: "areaModal.label"
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "modalDeleteArea",
    attrs: {
      "title": "Delete area"
    },
    on: {
      "ok": function($event) {
        return _vm.submitDeleteArea($event)
      }
    }
  }, [_vm._v("\n      Are you sure you want to delete this area, all its data and sub-areas?\n    ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalDeleteSubArea",
    attrs: {
      "title": "Delete subareas"
    },
    on: {
      "ok": function($event) {
        return _vm.submitDeleteSubArea($event)
      }
    }
  }, [_vm._v("\n      You are about to delete the whole subarea and it's contents. "), _c('br'), _vm._v("Are you sure?\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "time-picker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayTime),
      expression: "displayTime"
    }],
    staticClass: "display-time",
    attrs: {
      "id": _vm.id,
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.displayTime)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDropdown($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayTime = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.hideClearButton) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDropdown && _vm.showClearBtn),
      expression: "!showDropdown && showClearBtn"
    }],
    staticClass: "clear-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clearTime($event)
      }
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticClass: "time-picker-overlay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDropdown($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdown),
      expression: "showDropdown"
    }],
    staticClass: "dropdown"
  }, [_c('div', {
    staticClass: "select-list"
  }, [_c('ul', {
    staticClass: "hours"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.hourType)
    }
  }), _vm._v(" "), _vm._l((_vm.hours), function(hr) {
    return _c('li', {
      class: {
        active: _vm.hour === hr
      },
      domProps: {
        "textContent": _vm._s(hr)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select('hour', hr)
        }
      }
    })
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "minutes"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.minuteType)
    }
  }), _vm._v(" "), _vm._l((_vm.minutes), function(m) {
    return _c('li', {
      class: {
        active: _vm.minute === m
      },
      domProps: {
        "textContent": _vm._s(m)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select('minute', m)
        }
      }
    })
  })], 2), _vm._v(" "), (_vm.secondType) ? _c('ul', {
    staticClass: "seconds"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.secondType)
    }
  }), _vm._v(" "), _vm._l((_vm.seconds), function(s) {
    return _c('li', {
      class: {
        active: _vm.second === s
      },
      domProps: {
        "textContent": _vm._s(s)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select('second', s)
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.apmType) ? _c('ul', {
    staticClass: "apms"
  }, [_c('li', {
    staticClass: "hint",
    domProps: {
      "textContent": _vm._s(_vm.apmType)
    }
  }), _vm._v(" "), _vm._l((_vm.apms), function(a) {
    return _c('li', {
      class: {
        active: _vm.apm === a
      },
      domProps: {
        "textContent": _vm._s(a)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select('apm', a)
        }
      }
    })
  })], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "area-checkbox"
  }, _vm._l((_vm.areas), function(item, index) {
    return _c('div', {
      staticClass: "area"
    }, [_c('p', {
      class: [item.subareas.length ? 'underline' : ''],
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          return _vm.onClick(index, item)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n\n    ")]), _vm._v(" "), (_vm.type != 'radio') ? _c('input', {
      attrs: {
        "id": _vm.baseId + item.id,
        "type": _vm.type
      },
      on: {
        "change": function($event) {
          return _vm.onCheck([item])
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.type == 'radio') ? _c('input', {
      attrs: {
        "id": _vm.baseId + item.id,
        "type": _vm.type,
        "name": "areaRadio"
      },
      on: {
        "change": function($event) {
          return _vm.onCheck([item])
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('b-collapse', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.areaActiveS[index]),
        expression: "!areaActiveS[index]"
      }],
      attrs: {
        "id": item.id.toString()
      },
      model: {
        value: (_vm.areaActiveS[index].active),
        callback: function($$v) {
          _vm.$set(_vm.areaActiveS[index], "active", $$v)
        },
        expression: "areaActiveS[index].active"
      }
    }, [_c('area-checkbox', {
      attrs: {
        "baseId": _vm.baseId,
        "type": _vm.type,
        "areas": item.subareas,
        "selected": _vm.selected
      },
      on: {
        "selectedAreaChanged": _vm.selectedAreaChanged
      }
    })], 1)], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "add-user"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [(!_vm.$route.params.userId) ? _c('p', [_vm._v("Add "), (_vm.type == 'admin') ? _c('span', [_vm._v("admin")]) : _c('span', [_vm._v("basic")]), _vm._v(" user. Enter user details below.")]) : _c('p', [_vm._v("Change "), (_vm.type == 'admin') ? _c('span', [_vm._v("admin")]) : _c('span', [_vm._v("basic")]), _vm._v(" user. Enter user details below.")]), _vm._v(" "), _c('personalDetails', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token,
      "type": _vm.type,
      "onLogout": _vm.onLogout
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "thumbnail"
  }, [_c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.picture_url || _vm.picture),
      expression: "picture_url || picture"
    }]
  }, [_c('div', {
    staticClass: "img-icon"
  }, [_c('div', {
    staticClass: "btn-change"
  }, [_c('label', [_c('span', {
    staticClass: "btn-change btn btn-primary btn-sm",
    attrs: {
      "variant": "danger",
      "size": "sm"
    }
  }, [_vm._v("Change")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "type": "file",
      "accept": ".jpg, .jpeg, .png"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileChange($event, $event.target.parentElement.parentElement.parentElement.children[1])
      }
    }
  })])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.pictureUrlLocal
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-delete btn btn-danger btn-sm",
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.deletePicture($event)
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.picture_url || _vm.picture)),
      expression: "!(picture_url || picture)"
    }]
  }, [_c('b-form-file', {
    ref: "fileinput",
    attrs: {
      "choose-label": "Choose Image",
      "accept": ".jpg, .jpeg, .png"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileChange($event, $event.target.parentElement.parentElement.parentElement.children[1].children[0].children[1])
      }
    },
    model: {
      value: (_vm.pictureLocal),
      callback: function($$v) {
        _vm.pictureLocal = $$v
      },
      expression: "pictureLocal"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tasks"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "debounce",
      rawName: "v-debounce",
      value: (500),
      expression: "500"
    }],
    attrs: {
      "placeholder": "Type to Search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 offset-md-1"
  }, [_c('b-button', {
    staticClass: "button-add",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAddTaskClick()
      }
    }
  }, [_vm._v("\n          Add task\n        ")])], 1)]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "md",
      "total-rows": _vm.formData.filteredTask.length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": _vm.processText
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table text-center border"
  }, [_c('thead', [_c('tr', {
    on: {
      "dragover": function($event) {
        return _vm.changePage(true)
      }
    }
  }, _vm._l((_vm.formData.taskFields), function(item) {
    return _c('th', {
      staticClass: "text-center align-middle"
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _vm._l((_vm.formData.tasks), function(item, index) {
    return ((_vm.currentPage - 1) * _vm.perPage <= _vm.filteredIndex(_vm.formData.tasks[index]) && _vm.filteredIndex(_vm.formData.tasks[index]) < (_vm.currentPage) * _vm.perPage && _vm.isInFilter(item)) ? [(item.recurrencies.length > 0) ? [_c('tbody', {
      staticClass: "row-hover"
    }, _vm._l((item.recurrencies), function(recur, recurIndex) {
      return _c('tr', {
        attrs: {
          "draggable": _vm.authUser.role !== 'shift_leader'
        },
        on: {
          "click": function($event) {
            return _vm.onRowClick(item)
          },
          "drop": function($event) {
            return _vm.handleDrop($event, index)
          },
          "dragstart": function($event) {
            return _vm.handleDragStart($event, item, index)
          },
          "dragend": function($event) {
            return _vm.handleDragEnd($event, item, index)
          },
          "dragover": function($event) {
            return _vm.handleDragOver($event, index)
          }
        }
      }, [(recurIndex == 0) ? _c('td', {
        staticClass: "align-middle",
        attrs: {
          "rowspan": item.recurrencies.length
        }
      }, [_vm._v("\n                " + _vm._s(item.index) + "\n\n                "), (_vm.authUser.role !== 'shift_leader') ? _c('div', {
        staticClass: "btn-numeric-icn draggable",
        on: {
          "mouseover": function($event) {
            return _vm.handleBtnMouseEvent(true)
          },
          "mouseleave": function($event) {
            return _vm.handleBtnMouseEvent(false)
          }
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (recurIndex == 0) ? _c('td', {
        staticClass: "text-left align-middle",
        attrs: {
          "rowspan": item.recurrencies.length
        }
      }, [_c('b', [_vm._v(_vm._s(item.id))])]) : _vm._e(), _vm._v(" "), (recurIndex == 0) ? _c('td', {
        staticClass: "text-left align-middle ",
        attrs: {
          "rowspan": item.recurrencies.length
        }
      }, [_c('p', [_c('b', [_vm._v("Title: ")]), _vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(item.description))])]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle"
      }, _vm._l((_vm.getWorkingAreasListById(recur.area, _vm.areas)), function(area) {
        return _c('div', [_vm._v("\n                " + _vm._s(area ? area.name : '')), (area.id != recur.area) ? _c('span', [_vm._v("/")]) : _vm._e()])
      }), 0), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle"
      }, [(item.role) ? [_vm._v("\n                  " + _vm._s(_vm.roles[item.role]) + "\n              ")] : _vm._e()], 2), _vm._v(" "), _c('td', {
        staticClass: "text-center align-middle recurence_cell"
      }, [(recur.type == 'week') ? [_c('span', [_vm._v("By week ")]), _vm._v(" "), _c('div', [(recur.start_date) ? _c('div', [_vm._v("From " + _vm._s(recur.start_date) + " ")]) : _vm._e(), _vm._v(" "), (recur.end_date) ? _c('div', [_vm._v("To " + _vm._s(recur.end_date) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v("Recur every " + _vm._s(recur.week) + " week")]), _vm._v(" "), (recur.is_once_per_week) ? [_c('div', [_vm._v("Once per week")])] : _vm._l((_vm.weekdays), function(weekday, key) {
        return (recur[key]) ? _c('div', [_vm._v("\n                    " + _vm._s(weekday) + "\n                  ")]) : _vm._e()
      })] : (recur.type == 'month') ? [_c('span', [_vm._v("By month")]), _vm._v(" "), (recur.start_date) ? _c('div', [_vm._v("From " + _vm._s(recur.start_date) + " ")]) : _vm._e(), _vm._v(" "), (recur.end_date) ? _c('div', [_vm._v("To " + _vm._s(recur.end_date) + " ")]) : _vm._e(), _vm._v(" "), (recur.is_once_per_month) ? [_c('div', [_vm._v("Recur every " + _vm._s(recur.month) + " month")]), _vm._v(" "), _c('div', [_vm._v("Once per month")])] : [(recur.month_recurrency == 'day_of_month') ? [_c('div', [_vm._v("Recur on " + _vm._s(recur.day) + " day of every " + _vm._s(recur.month) + " month")])] : [_c('div', [_vm._v("\n                      The " + _vm._s(_vm.getWeekNumbersItem(recur.weekday_number)) + " " + _vm._s(_vm.getDaysName(recur.weekday)) + " of every " + _vm._s(recur.month) + " month\n                    ")])]]] : (recur.type == 'shifts') ? [_c('span', [_vm._v("By shifts")]), _vm._v(" "), _c('div', [(recur.start_date) ? _c('div', [_vm._v("From " + _vm._s(recur.start_date) + " ")]) : _vm._e(), _vm._v(" "), (recur.end_date) ? _c('div', [_vm._v("To " + _vm._s(recur.end_date) + " ")]) : _vm._e()]), _vm._v(" "), _vm._l((recur.shifts), function(shift) {
        return [_c('div', [_vm._v("\n                      " + _vm._s(_vm.getShiftTime(_vm.getShiftById(shift))) + "\n                  ")])]
      })] : (recur.type == 'no recurrency') ? [_c('span', [_vm._v("One time")]), _vm._v(" "), _c('div', [_vm._v("\n                  " + _vm._s(recur.date) + "\n                ")]), _vm._v(" "), _vm._l((recur.one_time_shifts), function(shift) {
        return [_c('div', [_vm._v("\n                      " + _vm._s(_vm.getShiftTime(_vm.getShiftById(shift))) + "\n                  ")])]
      })] : [_c('span', [_vm._v(_vm._s(recur.type))])]], 2)])
    }), 0)] : [_c('tbody', {
      staticClass: "row-hover"
    }, [_c('tr', {
      attrs: {
        "draggable": _vm.authUser.role !== 'shift_leader'
      },
      on: {
        "click": function($event) {
          return _vm.onRowClick(item)
        },
        "drop": function($event) {
          return _vm.handleDrop($event, index)
        },
        "dragstart": function($event) {
          return _vm.handleDragStart($event, item, index)
        },
        "dragend": function($event) {
          return _vm.handleDragEnd($event, item, index)
        },
        "dragover": function($event) {
          return _vm.handleDragOver($event, index)
        }
      }
    }, [_c('td', {
      staticClass: "align-middle"
    }, [_vm._v("\n              " + _vm._s(item.index) + "\n              "), (_vm.authUser.role !== 'shift_leader') ? _c('div', {
      staticClass: "btn-numeric-icn draggable",
      on: {
        "mouseover": function($event) {
          return _vm.handleBtnMouseEvent(true)
        },
        "mouseleave": function($event) {
          return _vm.handleBtnMouseEvent(false)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-left align-middle"
    }, [_c('div', {
      staticClass: "cell__text"
    }, [_c('p', [_c('b', [_vm._v("Title: ")]), _vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(item.description))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-left align-middle"
    }), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    })])])]] : _vm._e()
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "end-table",
    on: {
      "dragover": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_vm._m(0)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td')])
}]}

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "audits"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "debounce",
      rawName: "v-debounce",
      value: (500),
      expression: "500"
    }],
    attrs: {
      "placeholder": "Type to Search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 offset-md-1"
  }, [_c('b-button', {
    staticClass: "button-add",
    attrs: {
      "variant": "primary",
      "to": _vm.getAddAuditUrl()
    }
  }, [_vm._v("\n          Add audit\n        ")])], 1)]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "md",
      "total-rows": _vm.formData.audits.filter(_vm.isInFilter).length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table text-center table-hover border"
  }, [_c('thead', [_c('tr', _vm._l((_vm.formData.auditsFields), function(item) {
    return _c('th', {
      staticClass: "text-center align-middle"
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.formData.audits.filter(_vm.isInFilter)), function(item, index) {
    return ((_vm.currentPage - 1) * _vm.perPage <= index && index < (_vm.currentPage) * _vm.perPage) ? [
      [_c('tr', {
        on: {
          "click": function($event) {
            return _vm.onRowClick(item)
          }
        }
      }, [_c('td', {
        staticClass: "align-middle"
      }, [_vm._v("\n              " + _vm._s(+index + 1) + "\n            ")]), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle"
      }, [_c('b', [_vm._v(_vm._s(item.id))])]), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle"
      }, [_c('div', {
        staticClass: "cell__text"
      }, [_c('b', [_vm._v(_vm._s(item.name))])])]), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle"
      }, _vm._l((_vm.getWorkingAreasListById(item.area, _vm.areas)), function(area) {
        return _c('div', [_vm._v("\n                " + _vm._s(area ? area.name : '')), (area.id != item.area) ? _c('span', [_vm._v("/")]) : _vm._e()])
      }), 0), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      })])]
    ] : _vm._e()
  })], 2)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [(_vm.authUser && _vm.authUser.role == 'superuser') ? _c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n      This is your company administrator console. Here you can configure\n      "), (_vm.authUser && _vm.authUser.role != 'shift_leader') ? _c('span', [_vm._v(" your company, users, roles, ")]) : _vm._e(), _vm._v("\n      data.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.fields), function(value, index) {
    return _c('div', {
      staticClass: "col-md-3 text-left"
    }, [_c('b-table', {
      staticClass: "my-table",
      attrs: {
        "striped": "",
        "hover": "",
        "fields": value,
        "items": _vm.items[index]
      },
      scopedSlots: _vm._u([{
        key: "name",
        fn: function(item) {
          return [_c('router-link', {
            staticClass: "link",
            attrs: {
              "to": item.item.url
            }
          }, [_vm._v(_vm._s(item.item.name))])]
        }
      }], null, true)
    })], 1)
  }), 0)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "roles"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', [
    [_c('b-breadcrumb', {
      staticClass: "breadCrumb",
      attrs: {
        "items": _vm.breadCrumbItems
      }
    })]
  ], 2), _vm._v(" "), _c('p', [_vm._v("Here you can configure role names for your company.")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row mt-3 align-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.manager_role_display_name ? '' : 'Manager'
    },
    model: {
      value: (_vm.formData.manager_role_display_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "manager_role_display_name", $$v)
      },
      expression: "formData.manager_role_display_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 align-items-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.shift_leader_role_display_name ? '' : 'Shift leader'
    },
    model: {
      value: (_vm.formData.shift_leader_role_display_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "shift_leader_role_display_name", $$v)
      },
      expression: "formData.shift_leader_role_display_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 align-items-center"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.basic_role_display_name ? '' : 'Basic user'
    },
    model: {
      value: (_vm.formData.basic_role_display_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "basic_role_display_name", $$v)
      },
      expression: "formData.basic_role_display_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "offset-md-6 text-right col-md-1"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        Save\n      ")])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Has access to all data of the company and all settings configuration.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Has access to selected areas within the company and can only configure those areas. Has access to the app. Can view reports in the app")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Has access to selected areas within the company can only perform tasks, checklists, audits. Only app access (no web access). Can view reports")])])
}]}

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "companies"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 offset-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "debounce",
      rawName: "v-debounce",
      value: (500),
      expression: "500"
    }],
    attrs: {
      "placeholder": "Type to Search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('b-button', {
    staticClass: "button-add",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.onAddCompany($event)
      }
    }
  }, [_vm._v("\n          Add new company\n        ")])], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table text-center table-hover border mt-4"
  }, [_c('thead', [_c('tr', _vm._l((_vm.companiesFields), function(item, key) {
    return _c('th', {
      class: [(key != 'index') ? 'text-left' : 'text-center', 'align-middle']
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.companies.filter(_vm.isInFilter)), function(item, index) {
    return [_c('tr', {
      on: {
        "click": function($event) {
          return _vm.onClickCompany($event, item.id)
        }
      }
    }, [_c('td', {
      staticClass: "align-middle index-cell"
    }, [_vm._v("\n            " + _vm._s(+index + 1) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left align-middle text-cell"
    }, [_c('div', {
      staticClass: "cell__text"
    }, [_c('b', [_vm._v(_vm._s(item.name))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-left align-middle area-cell"
    }, [(item.manager) ? [_vm._v("\n            " + _vm._s(item.manager.first_name) + " " + _vm._s(item.manager.last_name) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "text-left role-cell"
    }, [(item.manager) ? [_vm._v("\n              " + _vm._s(item.manager.phone) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "text-left role-cell"
    }, [(item.manager) ? [_vm._v("\n            " + _vm._s(item.manager.username) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "text-center role-cell edit-cell"
    }, [_c('b-button', {
      staticClass: "edit",
      attrs: {
        "variant": "primary",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          return _vm.onAddCompany($event, item.id)
        }
      }
    }, [_vm._v(" Edit")])], 1)])]
  })], 2)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "shifts"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', [
    [_c('b-breadcrumb', {
      staticClass: "breadCrumb",
      attrs: {
        "items": _vm.breadCrumbItems
      }
    })]
  ], 2), _vm._v(" "), _c('p', [_vm._v("Here you can set working hours for the "), (!_vm.areaId) ? _c('span', [_vm._v("whole company")]) : _c('span', [_vm._v("area")])]), _vm._v(" "), (_vm.areaId) ? _c('div', [_c('b-form-radio', {
    attrs: {
      "options": _vm.toogleCompanyShiftsOptions,
      "stacked": ""
    },
    model: {
      value: (_vm.toogleCompanyShifts),
      callback: function($$v) {
        _vm.toogleCompanyShifts = $$v
      },
      expression: "toogleCompanyShifts"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1150px"
    }
  }, [(_vm.toogleCompanyShifts === 1) ? _c('b-table', {
    attrs: {
      "items": _vm.items,
      "fields": _vm.fields,
      "small": ""
    },
    scopedSlots: _vm._u([_vm._l((_vm.fields), function(item, key) {
      return {
        key: key,
        fn: function(data) {
          return [(data.index == _vm.shifts[key].length && !_vm.areaId) ? _c('div', {
            staticClass: "pointer",
            on: {
              "click": function($event) {
                _vm.resetTimes();
                _vm.$refs['modal-' + key][0].show()
              }
            }
          }, [_vm._v("\n          " + _vm._s(_vm.addShiftStr) + "\n\n        ")]) : _vm._e(), _vm._v(" "), (data.index == _vm.shifts[key].length && !_vm.areaId) ? _c('b-modal', {
            ref: 'modal-' + key,
            refInFor: true,
            attrs: {
              "title": "Add shift"
            },
            on: {
              "ok": function($event) {
                return _vm.onClickAddShift(key)
              }
            }
          }, [_c('table', {
            staticClass: "table-border"
          }, [_c('tr', [_c('td', [_vm._v("Enter start time")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
            attrs: {
              "minute-interval": 5
            },
            model: {
              value: (_vm.timeStart),
              callback: function($$v) {
                _vm.timeStart = $$v
              },
              expression: "timeStart"
            }
          })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("enter end time ")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
            attrs: {
              "minute-interval": 5
            },
            model: {
              value: (_vm.timeEnd),
              callback: function($$v) {
                _vm.timeEnd = $$v
              },
              expression: "timeEnd"
            }
          })], 1)])])]) : _vm._e(), _vm._v(" "), (data.index < _vm.shifts[key].length) ? _c('span', {
            staticClass: "shift-item"
          }, [_vm._v("\n          " + _vm._s(data.value) + "\n          "), (!_vm.areaId) ? _c('span', {
            staticClass: "hide-button"
          }, [(_vm.authUser.role == 'superuser') ? _c('b-button', {
            staticClass: "btn-edit",
            attrs: {
              "size": "sm",
              "variant": "success"
            },
            on: {
              "click": function($event) {
                _vm.currentItem.key = key;
                _vm.currentItem.index = data.index;
                _vm.makeTimesFromString(data.value);
                _vm.$refs['modal-edit'].show()
              }
            }
          }) : _vm._e(), _vm._v(" "), (_vm.authUser.role == 'superuser') ? _c('b-button', {
            staticClass: "btn-delete",
            attrs: {
              "size": "sm",
              "variant": "danger"
            },
            on: {
              "click": function($event) {
                _vm.currentItem.key = key;
                _vm.currentItem.index = data.index;
                _vm.$refs['modal-delete'].show()
              }
            }
          }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]
        }
      }
    })], null, true)
  }) : _c('b-table', {
    attrs: {
      "items": _vm.itemsArea,
      "fields": _vm.fields,
      "small": ""
    },
    scopedSlots: _vm._u([_vm._l((_vm.fields), function(item, key) {
      return {
        key: key,
        fn: function(data) {
          return [(data.index == _vm.shiftsArea[key].length) ? _c('div', {
            staticClass: "pointer",
            on: {
              "click": function($event) {
                _vm.resetTimes();
                _vm.$refs['modal-area-' + key][0].show()
              }
            }
          }, [_vm._v("\n            " + _vm._s(_vm.addShiftStr) + "\n          ")]) : _vm._e(), _vm._v(" "), (data.index == _vm.shiftsArea[key].length) ? _c('b-modal', {
            ref: 'modal-area-' + key,
            refInFor: true,
            attrs: {
              "title": "Add shift"
            },
            on: {
              "ok": function($event) {
                return _vm.onClickAddShift(key)
              }
            }
          }, [_c('table', {
            staticClass: "table-border"
          }, [_c('tr', [_c('td', [_vm._v("Enter start time")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
            attrs: {
              "minute-interval": 5
            },
            model: {
              value: (_vm.timeStart),
              callback: function($$v) {
                _vm.timeStart = $$v
              },
              expression: "timeStart"
            }
          })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("enter end time ")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
            attrs: {
              "minute-interval": 5
            },
            model: {
              value: (_vm.timeEnd),
              callback: function($$v) {
                _vm.timeEnd = $$v
              },
              expression: "timeEnd"
            }
          })], 1)])])]) : _vm._e(), _vm._v(" "), (data.index < _vm.shiftsArea[key].length) ? _c('span', {
            staticClass: "shift-item"
          }, [_vm._v("\n          " + _vm._s(data.value) + "\n          "), _c('span', {
            staticClass: "hide-button"
          }, [(_vm.authUser.role == 'superuser') ? _c('b-button', {
            staticClass: "btn-edit",
            attrs: {
              "size": "sm",
              "variant": "success"
            },
            on: {
              "click": function($event) {
                _vm.currentItem.key = key;
                _vm.currentItem.index = data.index;
                _vm.makeTimesFromString(data.value);
                _vm.$refs['modal-edit'].show()
              }
            }
          }) : _vm._e(), _vm._v(" "), (_vm.authUser.role == 'superuser') ? _c('b-button', {
            staticClass: "btn-delete",
            attrs: {
              "size": "sm",
              "variant": "danger"
            },
            on: {
              "click": function($event) {
                _vm.currentItem.key = key;
                _vm.currentItem.index = data.index;
                _vm.$refs['modal-delete'].show()
              }
            }
          }) : _vm._e()], 1)]) : _vm._e()]
        }
      }
    })], null, true)
  })], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-edit",
    attrs: {
      "title": "Edit shift"
    },
    on: {
      "ok": function($event) {
        return _vm.onClickEdit(_vm.currentItem.key, _vm.currentItem.index)
      }
    }
  }, [_c('table', {
    staticClass: "table-border"
  }, [_c('tr', [_c('td', [_vm._v("Enter start time")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "minute-interval": 5
    },
    model: {
      value: (_vm.timeStart),
      callback: function($$v) {
        _vm.timeStart = $$v
      },
      expression: "timeStart"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("enter end time ")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "minute-interval": 5
    },
    model: {
      value: (_vm.timeEnd),
      callback: function($$v) {
        _vm.timeEnd = $$v
      },
      expression: "timeEnd"
    }
  })], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "modal-delete",
    attrs: {
      "title": "Delete shift"
    },
    on: {
      "ok": function($event) {
        return _vm.onClickDelete(_vm.currentItem.key, _vm.currentItem.index)
      }
    }
  }, [_vm._v("\n      Are you sure you want to delete this shift and its contents?\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    class: (_vm.className ? _vm.className + '-wrapper ' : '') + 'autocomplete-wrapper'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    class: (_vm.className ? _vm.className + '-input ' : '') + 'autocomplete-input form-control',
    attrs: {
      "type": "text",
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.type)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.type = $event.target.value
      }, function($event) {
        return _vm.input(_vm.type)
      }],
      "dblclick": _vm.showAll,
      "blur": _vm.hideAll,
      "keydown": _vm.keydown,
      "focus": _vm.focus
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    class: (_vm.className ? _vm.className + '-list ' : '') + 'autocomplete transition autocomplete-list'
  }, [_c('ul', _vm._l((_vm.json), function(data, i) {
    return _c('li', {
      class: _vm.activeClass(i),
      attrs: {
        "transition": "showAll"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectList(data)
        },
        "mousemove": function($event) {
          return _vm.mousemove(i)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(data[_vm.anchor]))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data[_vm.label]))])])])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(192);
module.exports = __webpack_require__(191);


/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(548),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-87ec90bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(557),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ea6fc392",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(550),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a55cf160",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12498e65",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[565]);


// WEBPACK FOOTER //
// static/js/app.0abc6afc457bdf410d6b.js